export const HSRSkillsJSON = {
  100101: {
    id: '100101',
    name: 'Frigid Cold Arrow',
    max_level: 9,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Ice DMG to a single enemy.',
    desc: "Deals Ice DMG equal to #1[i]% of March 7th's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1001_basic_atk.png'
  },
  100102: {
    id: '100102',
    name: 'The Power of Cuteness',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Defence',
    effect_text: 'Defense',
    simple_desc: 'Applies a Shield on a single ally.',
    desc: "Provides a single ally with a Shield that can absorb DMG equal to #1[i]% of March 7th's DEF plus #4[i] for #2[i] turn(s).\nIf the ally's current HP percentage is #3[i]% or higher, greatly increases the chance of enemies attacking that ally.",
    params: [
      [0.38, 3, 0.3, 190, 5],
      [0.4038, 3, 0.3, 304, 5],
      [0.4275, 3, 0.3, 389.5, 5],
      [0.4513, 3, 0.3, 475, 5],
      [0.475, 3, 0.3, 532, 5],
      [0.494, 3, 0.3, 589, 5],
      [0.513, 3, 0.3, 631.75, 5],
      [0.532, 3, 0.3, 674.5, 5],
      [0.551, 3, 0.3, 717.25, 5],
      [0.57, 3, 0.3, 760, 5],
      [0.589, 3, 0.3, 802.75, 5],
      [0.608, 3, 0.3, 845.5, 5],
      [0.627, 3, 0.3, 888.25, 5],
      [0.646, 3, 0.3, 931, 5],
      [0.665, 3, 0.3, 973.75, 5]
    ],
    icon: 'icon/skill/1001_skill.png'
  },
  100103: {
    id: '100103',
    name: 'Glacial Cascade',
    max_level: 15,
    element: 'Ice',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Deals Ice DMG to all enemies, with a chance to apply the Freeze effect',
    desc: "Deals Ice DMG equal to #1[i]% of March 7th's ATK to all enemies. Hit enemies have a #2[i]% base chance to be Frozen for #3[i] turn(s).\nWhile Frozen, enemies cannot take action and will receive Additional Ice DMG equal to #4[i]% of March 7th's ATK at the beginning of each turn.",
    params: [
      [0.9, 0.5, 1, 0.3],
      [0.96, 0.5, 1, 0.33],
      [1.02, 0.5, 1, 0.36],
      [1.08, 0.5, 1, 0.39],
      [1.14, 0.5, 1, 0.42],
      [1.2, 0.5, 1, 0.45],
      [1.275, 0.5, 1, 0.4875],
      [1.35, 0.5, 1, 0.525],
      [1.425, 0.5, 1, 0.5625],
      [1.5, 0.5, 1, 0.6],
      [1.56, 0.5, 1, 0.63],
      [1.62, 0.5, 1, 0.66],
      [1.68, 0.5, 1, 0.69],
      [1.74, 0.5, 1, 0.72],
      [1.8, 0.5, 1, 0.75]
    ],
    icon: 'icon/skill/1001_ultimate.png'
  },
  100104: {
    id: '100104',
    name: 'Girl Power',
    max_level: 15,
    element: 'Ice',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'After a Shielded ally is attacked by an enemy, March 7th immediately launches a Counter against the attacker, dealing minor Ice DMG.',
    desc: 'After a Shielded ally is attacked by an enemy, March 7th immediately Counters, dealing Ice DMG equal to #1[i]% of her ATK. This effect can be triggered #2[i] time(s) each turn.',
    params: [
      [0.5, 2],
      [0.55, 2],
      [0.6, 2],
      [0.65, 2],
      [0.7, 2],
      [0.75, 2],
      [0.8125, 2],
      [0.875, 2],
      [0.9375, 2],
      [1, 2],
      [1.05, 2],
      [1.1, 2],
      [1.15, 2],
      [1.2, 2],
      [1.25, 2]
    ],
    icon: 'icon/skill/1001_talent.png'
  },
  100106: {
    id: '100106',
    name: 'Attack',
    max_level: 1,
    element: 'Ice',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1001_basic_atk.png'
  },
  100107: {
    id: '100107',
    name: 'Freezing Beauty',
    max_level: 1,
    element: 'Ice',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, there is a high chance of inflicting Freeze on a random enemy.',
    desc: "Immediately attacks the enemy. After entering battle, there is a #1[i]% base chance to Freeze a random enemy for #2[i] turn(s).\nWhile Frozen, the enemy cannot take action and will take Additional Ice DMG equal to #3[i]% of March 7th's ATK at the beginning of each turn.",
    params: [[1, 1, 0.5]],
    icon: 'icon/skill/1001_technique.png'
  },
  100201: {
    id: '100201',
    name: 'Cloudlancer Art: North Wind',
    max_level: 9,
    element: 'Wind',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Wind DMG to a single enemy.',
    desc: "Deals Wind DMG equal to #1[i]% of Dan Heng's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1002_basic_atk.png'
  },
  100202: {
    id: '100202',
    name: 'Cloudlancer Art: Torrent',
    max_level: 15,
    element: 'Wind',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Deals Wind DMG to a single enemy. Upon a CRIT Hit, there is a high chance of Slowing the enemy.',
    desc: "Deals Wind DMG equal to #1[i]% of Dan Heng's ATK to a single enemy.\nOn a CRIT Hit, there is a #4[i]% base chance to reduce the target's SPD by #2[i]% for #3[i] turn(s).",
    params: [
      [1.3, 0.12, 2, 1],
      [1.43, 0.12, 2, 1],
      [1.56, 0.12, 2, 1],
      [1.69, 0.12, 2, 1],
      [1.82, 0.12, 2, 1],
      [1.95, 0.12, 2, 1],
      [2.1125, 0.12, 2, 1],
      [2.275, 0.12, 2, 1],
      [2.4375, 0.12, 2, 1],
      [2.6, 0.12, 2, 1],
      [2.73, 0.12, 2, 1],
      [2.86, 0.12, 2, 1],
      [2.99, 0.12, 2, 1],
      [3.12, 0.12, 2, 1],
      [3.25, 0.12, 2, 1]
    ],
    icon: 'icon/skill/1002_skill.png'
  },
  100203: {
    id: '100203',
    name: 'Ethereal Dream',
    max_level: 15,
    element: 'Wind',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Deals massive Wind DMG to a single enemy. If the enemy is Slowed, DMG multiplier dealt will be increased.',
    desc: "Deals Wind DMG equal to #1[i]% of Dan Heng's ATK to a single enemy. If the enemy is Slowed, the Ultimate's DMG multiplier increases by #2[i]%.",
    params: [
      [2.4, 0.72],
      [2.56, 0.768],
      [2.72, 0.816],
      [2.88, 0.864],
      [3.04, 0.912],
      [3.2, 0.96],
      [3.4, 1.02],
      [3.6, 1.08],
      [3.8, 1.14],
      [4, 1.2],
      [4.16, 1.248],
      [4.32, 1.296],
      [4.48, 1.344],
      [4.64, 1.392],
      [4.8, 1.44]
    ],
    icon: 'icon/skill/1002_ultimate.png'
  },
  100204: {
    id: '100204',
    name: 'Superiority of Reach',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      "When they are the target of an ally's Ability, their next attack's Wind RES PEN increases. This effect can be triggered again after 2 turns.",
    desc: "When Dan Heng is the target of an ally's Ability, his next attack's Wind RES PEN increases by #1[i]%. This effect can be triggered again after #2[i] turn(s).",
    params: [
      [0.18, 2],
      [0.198, 2],
      [0.216, 2],
      [0.234, 2],
      [0.252, 2],
      [0.27, 2],
      [0.2925, 2],
      [0.315, 2],
      [0.3375, 2],
      [0.36, 2],
      [0.378, 2],
      [0.396, 2],
      [0.414, 2],
      [0.432, 2],
      [0.45, 2]
    ],
    icon: 'icon/skill/1002_talent.png'
  },
  100206: {
    id: '100206',
    name: 'Attack',
    max_level: 1,
    element: 'Wind',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1002_basic_atk.png'
  },
  100207: {
    id: '100207',
    name: 'Splitting Spearhead',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'After they use their Technique, their ATK is increased at the start of the next battle.',
    desc: 'After Dan Heng uses his Technique, his ATK increases by #1[i]% at the start of the next battle for #2[i] turn(s).',
    params: [[0.4, 3]],
    icon: 'icon/skill/1002_technique.png'
  },
  100301: {
    id: '100301',
    name: 'Sawblade Tuning',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to a single enemy.',
    desc: "Deals Fire DMG equal to #1[i]% of Himeko's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1003_basic_atk.png'
  },
  100302: {
    id: '100302',
    name: 'Molten Detonation',
    max_level: 15,
    element: 'Fire',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals Fire DMG to a single enemy and minor Fire DMG to enemies adjacent to it.',
    desc: "Deals Fire DMG equal to #1[i]% of Himeko's ATK to a single enemy and Fire DMG equal to #2[i]% of Himeko's ATK to enemies adjacent to it.",
    params: [
      [1, 0.4],
      [1.1, 0.44],
      [1.2, 0.48],
      [1.3, 0.52],
      [1.4, 0.56],
      [1.5, 0.6],
      [1.625, 0.65],
      [1.75, 0.7],
      [1.875, 0.75],
      [2, 0.8],
      [2.1, 0.84],
      [2.2, 0.88],
      [2.3, 0.92],
      [2.4, 0.96],
      [2.5, 1]
    ],
    icon: 'icon/skill/1003_skill.png'
  },
  100303: {
    id: '100303',
    name: 'Heavenly Flare',
    max_level: 15,
    element: 'Fire',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Deals Fire DMG to all enemies and regenerates Energy if enemies are defeated.',
    desc: "Deals Fire DMG equal to #1[i]% of Himeko's ATK to all enemies. Himeko regenerates #2[i] extra Energy for each enemy defeated.",
    params: [
      [1.38, 5],
      [1.472, 5],
      [1.564, 5],
      [1.656, 5],
      [1.748, 5],
      [1.84, 5],
      [1.955, 5],
      [2.07, 5],
      [2.185, 5],
      [2.3, 5],
      [2.392, 5],
      [2.484, 5],
      [2.576, 5],
      [2.668, 5],
      [2.76, 5]
    ],
    icon: 'icon/skill/1003_ultimate.png'
  },
  100304: {
    id: '100304',
    name: 'Victory Rush',
    max_level: 15,
    element: 'Fire',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      "Gains a Charge stack when an enemy's Weakness is Broken.\nAfter an ally performs an attack, if fully Charged, immediately performs a follow-up attack and deal Fire DMG to all enemies, consuming all Charge stacks.\nGains 1 Charge stack at the start of each battle.",
    desc: 'When an enemy is inflicted with Weakness Break, Himeko gains 1 point of Charge (max #2[i] points).\nIf Himeko is fully Charged when an ally performs an attack, Himeko immediately performs 1 follow-up attack and deals Fire DMG equal to #1[i]% of her ATK to all enemies, consuming all Charge points.\nAt the start of the battle, Himeko gains 1 point of Charge.',
    params: [
      [0.7, 3],
      [0.77, 3],
      [0.84, 3],
      [0.91, 3],
      [0.98, 3],
      [1.05, 3],
      [1.1375, 3],
      [1.225, 3],
      [1.3125, 3],
      [1.4, 3],
      [1.47, 3],
      [1.54, 3],
      [1.61, 3],
      [1.68, 3],
      [1.75, 3]
    ],
    icon: 'icon/skill/1003_talent.png'
  },
  100306: {
    id: '100306',
    name: 'Attack',
    max_level: 1,
    element: 'Fire',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1003_basic_atk.png'
  },
  100307: {
    id: '100307',
    name: 'Incomplete Combustion',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'Creates a dimension. After entering combat with enemies in the dimension, there is a high chance to increase Fire DMG taken by enemies.',
    desc: 'After using Technique, creates a dimension that lasts for #4[i] second(s). After entering battle with enemies in the dimension, there is a #1[i]% base chance to increase Fire DMG taken by enemies by #2[i]% for #3[i] turn(s). Only 1 dimension created by allies can exist at the same time.',
    params: [[1, 0.1, 2, 15]],
    icon: 'icon/skill/1003_technique.png'
  },
  100401: {
    id: '100401',
    name: 'Gravity Suppression',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Imaginary DMG to a single enemy.',
    desc: "Deals Imaginary DMG equal to #1[i]% of Welt's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1004_basic_atk.png'
  },
  100402: {
    id: '100402',
    name: 'Edge of the Void',
    max_level: 15,
    element: 'Imaginary',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Bounce',
    effect_text: 'Bounce',
    simple_desc:
      'Deals minor Imaginary DMG to a single enemy. This attack can Bounce 3 times, with a chance of Slowing the hit enemies.',
    desc: "Deals Imaginary DMG equal to #1[i]% of Welt's ATK to a single enemy and further deals DMG 2 extra times, with each time dealing Imaginary DMG equal to #1[i]% of Welt's ATK to a random enemy. On hit, there is a #2[i]% base chance to reduce the enemy's SPD by #3[i]% for #4[i] turn(s).",
    params: [
      [0.36, 0.65, 0.1, 2],
      [0.396, 0.66, 0.1, 2],
      [0.432, 0.67, 0.1, 2],
      [0.468, 0.68, 0.1, 2],
      [0.504, 0.69, 0.1, 2],
      [0.54, 0.7, 0.1, 2],
      [0.585, 0.7125, 0.1, 2],
      [0.63, 0.725, 0.1, 2],
      [0.675, 0.7375, 0.1, 2],
      [0.72, 0.75, 0.1, 2],
      [0.756, 0.76, 0.1, 2],
      [0.792, 0.77, 0.1, 2],
      [0.828, 0.78, 0.1, 2],
      [0.864, 0.79, 0.1, 2],
      [0.9, 0.8, 0.1, 2]
    ],
    icon: 'icon/skill/1004_skill.png'
  },
  100403: {
    id: '100403',
    name: 'Synthetic Black Hole',
    max_level: 15,
    element: 'Imaginary',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Deals Imaginary DMG to all enemies, with a high chance of Imprisoning them.',
    desc: "Deals Imaginary DMG equal to #1[i]% of Welt's ATK to all enemies, with a #3[i]% base chance for enemies hit by this ability to be Imprisoned for 1 turn.\nImprisoned enemies have their actions delayed by #2[i]% and SPD reduced by #4[i]%.",
    params: [
      [0.9, 0.32, 1, 0.1],
      [0.96, 0.328, 1, 0.1],
      [1.02, 0.336, 1, 0.1],
      [1.08, 0.344, 1, 0.1],
      [1.14, 0.352, 1, 0.1],
      [1.2, 0.36, 1, 0.1],
      [1.275, 0.37, 1, 0.1],
      [1.35, 0.38, 1, 0.1],
      [1.425, 0.39, 1, 0.1],
      [1.5, 0.4, 1, 0.1],
      [1.56, 0.408, 1, 0.1],
      [1.62, 0.416, 1, 0.1],
      [1.68, 0.424, 1, 0.1],
      [1.74, 0.432, 1, 0.1],
      [1.8, 0.44, 1, 0.1]
    ],
    icon: 'icon/skill/1004_ultimate.png'
  },
  100404: {
    id: '100404',
    name: 'Time Distortion',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'When hitting a Slowed enemy, additionally deals minor Imaginary Additional DMG.',
    desc: 'When hitting an enemy that is already Slowed, Welt deals Additional Imaginary DMG equal to #1[i]% of his ATK to the enemy.',
    params: [
      [0.3],
      [0.33],
      [0.36],
      [0.39],
      [0.42],
      [0.45],
      [0.4875],
      [0.525],
      [0.5625],
      [0.6],
      [0.63],
      [0.66],
      [0.69],
      [0.72],
      [0.75]
    ],
    icon: 'icon/skill/1004_talent.png'
  },
  100406: {
    id: '100406',
    name: 'Attack',
    max_level: 1,
    element: 'Imaginary',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1004_basic_atk.png'
  },
  100407: {
    id: '100407',
    name: 'Gravitational Imprisonment',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'Creates a dimension. Enemies in this dimension have their Movement SPD reduced. After entering combat with enemies in the dimension, there is a high chance for the enemies to become Imprisoned.',
    desc: "After using Welt's Technique, create a dimension that lasts for #4[i] second(s). Enemies in this dimension have their Movement SPD reduced by #5[i]%. After entering battle with enemies in the dimension, there is a #1[i]% base chance to Imprison the enemies for 1 turn.\nImprisoned enemies have their actions delayed by #2[i]% and SPD reduced by #3[i]%. Only 1 dimension created by allies can exist at the same time.",
    params: [[1, 0.2, 0.1, 15, 0.5]],
    icon: 'icon/skill/1004_technique.png'
  },
  100501: {
    id: '100501',
    name: 'Midnight Tumult',
    max_level: 9,
    element: 'Thunder',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Lightning DMG to a single enemy.',
    desc: "Deals Lightning DMG equal to #1[i]% of Kafka's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1005_basic_atk.png'
  },
  100502: {
    id: '100502',
    name: 'Caressing Moonlight',
    max_level: 15,
    element: 'Thunder',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals Lightning DMG to a single enemy and minor Lightning DMG to adjacent targets.\nIf the main target currently has a DoT effect inflicted on it, the DoT deals DMG 1 extra time.',
    desc: "Deals Lightning DMG equal to #1[i]% of Kafka's ATK to a target enemy and Lightning DMG equal to #3[i]% of Kafka's ATK to enemies adjacent to it.\nIf the target enemy is currently receiving DoT, all DoTs currently placed on that enemy immediately produce DMG equal to #2[i]% of their original DMG.",
    params: [
      [0.8, 0.6, 0.3],
      [0.88, 0.615, 0.33],
      [0.96, 0.63, 0.36],
      [1.04, 0.645, 0.39],
      [1.12, 0.66, 0.42],
      [1.2, 0.675, 0.45],
      [1.3, 0.6938, 0.4875],
      [1.4, 0.7125, 0.525],
      [1.5, 0.7313, 0.5625],
      [1.6, 0.75, 0.6],
      [1.68, 0.765, 0.63],
      [1.76, 0.78, 0.66],
      [1.84, 0.795, 0.69],
      [1.92, 0.81, 0.72],
      [2, 0.825, 0.75]
    ],
    icon: 'icon/skill/1005_skill.png'
  },
  100503: {
    id: '100503',
    name: 'Twilight Trill',
    max_level: 15,
    element: 'Thunder',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Deals minor Lightning DMG to all enemies, with a high chance of Shocking them.\nIf the enemies are currently Shocked, the Shock status deals DMG 1 extra time.',
    desc: "Deals Lightning DMG equal to #1[i]% of Kafka's ATK to all enemies, with a #2[i]% base chance for enemies hit to become Shocked and immediately take DMG from their current Shock state, equal to #5[i]% of its original DMG. Shock lasts for #3[i] turn(s).\nWhile Shocked, enemies receive Lightning DoT equal to #4[i]% of Kafka's ATK at the beginning of each turn.",
    params: [
      [0.48, 1, 2, 1.16, 0.8],
      [0.512, 1, 2, 1.2688, 0.82],
      [0.544, 1, 2, 1.3775, 0.84],
      [0.576, 1, 2, 1.4863, 0.86],
      [0.608, 1, 2, 1.595, 0.88],
      [0.64, 1, 2, 1.7581, 0.9],
      [0.68, 1, 2, 1.9756, 0.925],
      [0.72, 1, 2, 2.2475, 0.95],
      [0.76, 1, 2, 2.5738, 0.975],
      [0.8, 1, 2, 2.9, 1],
      [0.832, 1, 2, 3.0414, 1.02],
      [0.864, 1, 2, 3.1828, 1.04],
      [0.896, 1, 2, 3.3241, 1.06],
      [0.928, 1, 2, 3.4655, 1.08],
      [0.96, 1, 2, 3.6069, 1.1]
    ],
    icon: 'icon/skill/1005_ultimate.png'
  },
  100504: {
    id: '100504',
    name: 'Gentle but Cruel',
    max_level: 15,
    element: 'Thunder',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'After an ally uses Basic ATK on an enemy, Kafka immediately launches a follow-up attack and deals Lightning DMG with a high chance of inflicting Shock to that target. This effect can only be triggered 1 time per turn.',
    desc: "After an ally of Kafka's uses Basic ATK on an enemy target, Kafka immediately launches 1 follow-up attack and deals Lightning DMG equal to #1[i]% of her ATK to that target, with a #2[i]% base chance to inflict Shock equivalent to that applied by her Ultimate to the attacked enemy target, lasting for #3[i] turns. This effect can only be triggered 1 time per turn.",
    params: [
      [0.42, 1, 2],
      [0.518, 1, 2],
      [0.616, 1, 2],
      [0.714, 1, 2],
      [0.812, 1, 2],
      [0.91, 1, 2],
      [1.0325, 1, 2],
      [1.155, 1, 2],
      [1.2775, 1, 2],
      [1.4, 1, 2],
      [1.498, 1, 2],
      [1.596, 1, 2],
      [1.694, 1, 2],
      [1.792, 1, 2],
      [1.89, 1, 2]
    ],
    icon: 'icon/skill/1005_talent.png'
  },
  100506: {
    id: '100506',
    name: 'Attack',
    max_level: 1,
    element: 'Thunder',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1005_basic_atk.png'
  },
  100507: {
    id: '100507',
    name: 'Mercy Is Not Forgiveness',
    max_level: 1,
    element: 'Thunder',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks all enemies within range. After entering battle, deals minor Lightning DMG to all enemies with a high chance of Shocking them.',
    desc: "Immediately attacks all enemies within a set range. After entering battle, deals Lightning DMG equal to #3[i]% of Kafka's ATK to all enemies, with a #1[i]% base chance to inflict Shock equivalent to that applied by her Ultimate on every enemy target for #2[i] turn(s).",
    params: [[1, 2, 0.5]],
    icon: 'icon/skill/1005_technique.png'
  },
  100601: {
    id: '100601',
    name: 'System Warning',
    max_level: 9,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Quantum DMG to a single enemy.',
    desc: "Deals Quantum DMG equal to #1[i]% of Silver Wolf's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1006_basic_atk.png'
  },
  100602: {
    id: '100602',
    name: 'Allow Changes?',
    max_level: 15,
    element: 'Quantum',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'There is a high chance to apply additional Type Weaknesses to a single enemy and deals Quantum DMG to this target enemy.',
    desc: "There is a #2[i]% base chance to add 1 Weakness of an on-field character's Type to the target enemy. This also reduces the enemy's DMG RES to that Weakness Type by #4[i]% for #3[i] turn(s). If the enemy already has that Type Weakness, the effect of DMG RES reduction to that Weakness Type will not be triggered.\nEach enemy can only have 1 Weakness implanted by Silver Wolf. When Silver Wolf implants another Weakness to the target, only the most recent implanted Weakness will be kept.\nIn addition, there is a #5[i]% base chance to further reduce the All-Type RES of the enemy by #6[i]% for #7[i] turn(s).\nDeals Quantum DMG equal to #1[i]% of Silver Wolf's ATK to this enemy.",
    params: [
      [0.98, 0.75, 2, 0.2, 1, 0.075, 2],
      [1.078, 0.76, 2, 0.2, 1, 0.0775, 2],
      [1.176, 0.77, 2, 0.2, 1, 0.08, 2],
      [1.274, 0.78, 2, 0.2, 1, 0.0825, 2],
      [1.372, 0.79, 2, 0.2, 1, 0.085, 2],
      [1.47, 0.8, 2, 0.2, 1, 0.0875, 2],
      [1.5925, 0.8125, 2, 0.2, 1, 0.0906, 2],
      [1.715, 0.825, 2, 0.2, 1, 0.0938, 2],
      [1.8375, 0.8375, 2, 0.2, 1, 0.0969, 2],
      [1.96, 0.85, 2, 0.2, 1, 0.1, 2],
      [2.058, 0.86, 2, 0.2, 1, 0.1025, 2],
      [2.156, 0.87, 2, 0.2, 1, 0.105, 2],
      [2.254, 0.88, 2, 0.2, 1, 0.1075, 2],
      [2.352, 0.89, 2, 0.2, 1, 0.11, 2],
      [2.45, 0.9, 2, 0.2, 1, 0.1125, 2]
    ],
    icon: 'icon/skill/1006_skill.png'
  },
  100603: {
    id: '100603',
    name: 'User Banned',
    max_level: 15,
    element: 'Quantum',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      "Has a high chance of lowering a single enemy's DEF and deals massive Quantum DMG to this target enemy.",
    desc: "There's a #2[i]% base chance to decrease the target enemy's DEF by #3[i]% for #4[i] turn(s). And at the same time, deals Quantum DMG equal to #1[i]% of Silver Wolf's ATK to the target enemy.",
    params: [
      [2.28, 0.85, 0.36, 3],
      [2.432, 0.865, 0.369, 3],
      [2.584, 0.88, 0.378, 3],
      [2.736, 0.895, 0.387, 3],
      [2.888, 0.91, 0.396, 3],
      [3.04, 0.925, 0.405, 3],
      [3.23, 0.9438, 0.4163, 3],
      [3.42, 0.9625, 0.4275, 3],
      [3.61, 0.9813, 0.4388, 3],
      [3.8, 1, 0.45, 3],
      [3.952, 1.015, 0.459, 3],
      [4.104, 1.03, 0.468, 3],
      [4.256, 1.045, 0.477, 3],
      [4.408, 1.06, 0.486, 3],
      [4.56, 1.075, 0.495, 3]
    ],
    icon: 'icon/skill/1006_ultimate.png'
  },
  100604: {
    id: '100604',
    name: 'Awaiting System Response...',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'After each attack, there is a chance of inflicting the attacked enemy with 1 random Bug.',
    desc: 'Silver Wolf can create three types of Bugs: reduce ATK by #1[i]%, reduce DEF by #2[i]%, and reduce SPD by #3[i]%.\nEvery time Silver Wolf attacks, she has a #4[i]% base chance to implant a random Bug that lasts for #5[i] turn(s) in an enemy target.',
    params: [
      [0.05, 0.04, 0.03, 0.6, 3],
      [0.055, 0.044, 0.033, 0.612, 3],
      [0.06, 0.048, 0.036, 0.624, 3],
      [0.065, 0.052, 0.039, 0.636, 3],
      [0.07, 0.056, 0.042, 0.648, 3],
      [0.075, 0.06, 0.045, 0.66, 3],
      [0.0813, 0.065, 0.0488, 0.675, 3],
      [0.0875, 0.07, 0.0525, 0.69, 3],
      [0.0938, 0.075, 0.0563, 0.705, 3],
      [0.1, 0.08, 0.06, 0.72, 3],
      [0.105, 0.084, 0.063, 0.732, 3],
      [0.11, 0.088, 0.066, 0.744, 3],
      [0.115, 0.092, 0.069, 0.756, 3],
      [0.12, 0.096, 0.072, 0.768, 3],
      [0.125, 0.1, 0.075, 0.78, 3]
    ],
    icon: 'icon/skill/1006_talent.png'
  },
  100606: {
    id: '100606',
    name: 'Attack',
    max_level: 1,
    element: 'Quantum',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1006_basic_atk.png'
  },
  100607: {
    id: '100607',
    name: 'Force Quit Program',
    max_level: 1,
    element: 'Quantum',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, deals minor amounts of DMG to all enemies and reduces Toughness of all enemies irrespective of Weakness Types.',
    desc: "Immediately attacks the enemy. After entering battle, deals Quantum DMG equal to #1[i]% of Silver Wolf's ATK to all enemies, and ignores Weakness Types and reduces Toughness from all enemies. Enemies with their Weakness Broken in this way will trigger the Quantum Weakness Break effect.",
    params: [[0.8]],
    icon: 'icon/skill/1006_technique.png'
  },
  100801: {
    id: '100801',
    name: 'Lightning Rush',
    max_level: 9,
    element: 'Thunder',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Lightning DMG to a single enemy.',
    desc: "Deals Lightning DMG equal to #1[i]% of Arlan's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1008_basic_atk.png'
  },
  100802: {
    id: '100802',
    name: 'Shackle Breaker',
    max_level: 15,
    element: 'Thunder',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Consumes a portion of HP to deal Lightning DMG to a single enemy.',
    desc: "Consumes Arlan's HP equal to #1[i]% of his Max HP to deal Lightning DMG equal to #2[i]% of Arlan's ATK to a single enemy. If Arlan does not have sufficient HP, his HP will be reduced to 1 after using his Skill.",
    params: [
      [0.15, 1.2],
      [0.15, 1.32],
      [0.15, 1.44],
      [0.15, 1.56],
      [0.15, 1.68],
      [0.15, 1.8],
      [0.15, 1.95],
      [0.15, 2.1],
      [0.15, 2.25],
      [0.15, 2.4],
      [0.15, 2.52],
      [0.15, 2.64],
      [0.15, 2.76],
      [0.15, 2.88],
      [0.15, 3]
    ],
    icon: 'icon/skill/1008_skill.png'
  },
  100803: {
    id: '100803',
    name: 'Frenzied Punishment',
    max_level: 15,
    element: 'Thunder',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals massive Lightning DMG to a single enemy and Lightning DMG to enemies adjacent to it.',
    desc: "Deals Lightning DMG equal to #1[i]% of Arlan's ATK to a single enemy and Lightning DMG equal to #2[i]% of Arlan's ATK to enemies adjacent to it.",
    params: [
      [1.92, 0.96],
      [2.048, 1.024],
      [2.176, 1.088],
      [2.304, 1.152],
      [2.432, 1.216],
      [2.56, 1.28],
      [2.72, 1.36],
      [2.88, 1.44],
      [3.04, 1.52],
      [3.2, 1.6],
      [3.328, 1.664],
      [3.456, 1.728],
      [3.584, 1.792],
      [3.712, 1.856],
      [3.84, 1.92]
    ],
    icon: 'icon/skill/1008_ultimate.png'
  },
  100804: {
    id: '100804',
    name: 'Pain and Anger',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'Increases DMG based on the current percentage of own HP lost.',
    desc: "Increases Arlan's DMG for every percent of HP below his Max HP, up to a max of #1[i]% more DMG.",
    params: [
      [0.36],
      [0.396],
      [0.432],
      [0.468],
      [0.504],
      [0.54],
      [0.585],
      [0.63],
      [0.675],
      [0.72],
      [0.756],
      [0.792],
      [0.828],
      [0.864],
      [0.9]
    ],
    icon: 'icon/skill/1008_talent.png'
  },
  100806: {
    id: '100806',
    name: 'Attack',
    max_level: 1,
    element: 'Thunder',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1008_basic_atk.png'
  },
  100807: {
    id: '100807',
    name: 'Swift Harvest',
    max_level: 1,
    element: 'Thunder',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, deals minor Lightning DMG to all enemies.',
    desc: "Immediately attacks the enemy. After entering battle, deals Lightning DMG equal to #1[i]% of Arlan's ATK to all enemies.",
    params: [[0.8]],
    icon: 'icon/skill/1008_technique.png'
  },
  100901: {
    id: '100901',
    name: 'Spectrum Beam',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to a single enemy.',
    desc: "Deals Fire DMG equal to #1[i]% of Asta's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1009_basic_atk.png'
  },
  100902: {
    id: '100902',
    name: 'Meteor Storm',
    max_level: 15,
    element: 'Fire',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Bounce',
    effect_text: 'Bounce',
    simple_desc:
      'Deals minor Fire DMG to single enemy targets with 5 Bounces in total.',
    desc: "Deals Fire DMG equal to #1[i]% of Asta's ATK to a single enemy and further deals DMG for 4 extra times, with each time dealing Fire DMG equal to #1[i]% of Asta's ATK to a random enemy.",
    params: [
      [0.25],
      [0.275],
      [0.3],
      [0.325],
      [0.35],
      [0.375],
      [0.4063],
      [0.4375],
      [0.4688],
      [0.5],
      [0.525],
      [0.55],
      [0.575],
      [0.6],
      [0.625]
    ],
    icon: 'icon/skill/1009_skill.png'
  },
  100903: {
    id: '100903',
    name: 'Astral Blessing',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: 'Increases SPD for all allies.',
    desc: 'Increases SPD of all allies by #1[i] for #2[i] turn(s).',
    params: [
      [36, 2],
      [37.4, 2],
      [38.8, 2],
      [40.2, 2],
      [41.6, 2],
      [43, 2],
      [44.75, 2],
      [46.5, 2],
      [48.25, 2],
      [50, 2],
      [51.4, 2],
      [52.8, 2],
      [54.2, 2],
      [55.6, 2],
      [57, 2]
    ],
    icon: 'icon/skill/1009_ultimate.png'
  },
  100904: {
    id: '100904',
    name: 'Astrometry',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      'The character will receive 1 stack of Charging for every different enemy they hit, for a maximum of 5 stacks. Every stack of Charging increases ATK for all allies. At the beginning of their turn, reduce Charging stacks.',
    desc: "Gains 1 stack of Charging for every different enemy hit by Asta plus an extra stack if the enemy hit has Fire Weakness.\nFor every stack of Charging Asta has, all allies' ATK increases by #1[i]%, up to #2[i] time(s).\nStarting from her second turn, Asta's Charging stack count is reduced by #3[i] at the beginning of every turn.",
    params: [
      [0.07, 5, 3],
      [0.077, 5, 3],
      [0.084, 5, 3],
      [0.091, 5, 3],
      [0.098, 5, 3],
      [0.105, 5, 3],
      [0.1138, 5, 3],
      [0.1225, 5, 3],
      [0.1313, 5, 3],
      [0.14, 5, 3],
      [0.147, 5, 3],
      [0.154, 5, 3],
      [0.161, 5, 3],
      [0.168, 5, 3],
      [0.175, 5, 3]
    ],
    icon: 'icon/skill/1009_talent.png'
  },
  100906: {
    id: '100906',
    name: 'Attack',
    max_level: 1,
    element: 'Fire',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1009_basic_atk.png'
  },
  100907: {
    id: '100907',
    name: 'Miracle Flash',
    max_level: 1,
    element: 'Fire',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, deals minor amounts of DMG to all enemies.',
    desc: "Immediately attacks the enemy. After entering battle, deals Fire DMG equal to #1[i]% of Asta's ATK to all enemies.",
    params: [[0.5]],
    icon: 'icon/skill/1009_technique.png'
  },
  101301: {
    id: '101301',
    name: 'What Are You Looking At?',
    max_level: 9,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Ice DMG to a single enemy.',
    desc: "Deals Ice DMG equal to #1[i]% of Herta's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1013_basic_atk.png'
  },
  101302: {
    id: '101302',
    name: 'One-Time Offer',
    max_level: 15,
    element: 'Ice',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Deals minor Ice DMG to all enemies. Targets with higher HP will receive increased DMG.',
    desc: "Deals Ice DMG equal to #1[i]% of Herta's ATK to all enemies. If the enemy's HP percentage is #2[i]% or higher, DMG dealt to this target increases by #3[i]%.",
    params: [
      [0.5, 0.5, 0.2],
      [0.55, 0.5, 0.2],
      [0.6, 0.5, 0.2],
      [0.65, 0.5, 0.2],
      [0.7, 0.5, 0.2],
      [0.75, 0.5, 0.2],
      [0.8125, 0.5, 0.2],
      [0.875, 0.5, 0.2],
      [0.9375, 0.5, 0.2],
      [1, 0.5, 0.2],
      [1.05, 0.5, 0.2],
      [1.1, 0.5, 0.2],
      [1.15, 0.5, 0.2],
      [1.2, 0.5, 0.2],
      [1.25, 0.5, 0.2]
    ],
    icon: 'icon/skill/1013_skill.png'
  },
  101303: {
    id: '101303',
    name: "It's Magic, I Added Some Magic",
    max_level: 15,
    element: 'Ice',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc: 'Deals Ice DMG to all enemies.',
    desc: "Deals Ice DMG equal to #1[i]% of Herta's ATK to all enemies.",
    params: [
      [1.2],
      [1.28],
      [1.36],
      [1.44],
      [1.52],
      [1.6],
      [1.7],
      [1.8],
      [1.9],
      [2],
      [2.08],
      [2.16],
      [2.24],
      [2.32],
      [2.4]
    ],
    icon: 'icon/skill/1013_ultimate.png'
  },
  101304: {
    id: '101304',
    name: "Fine, I'll Do It Myself",
    max_level: 15,
    element: 'Ice',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc: '',
    desc: "When an ally's attack causes an enemy's HP percentage to fall to #1[i]% or lower, Herta will launch a follow-up attack, dealing Ice DMG equal to #2[i]% of Herta's ATK to all enemies.",
    params: [
      [0.5, 0.25],
      [0.5, 0.265],
      [0.5, 0.28],
      [0.5, 0.295],
      [0.5, 0.31],
      [0.5, 0.325],
      [0.5, 0.3438],
      [0.5, 0.3625],
      [0.5, 0.3813],
      [0.5, 0.4],
      [0.5, 0.415],
      [0.5, 0.43],
      [0.5, 0.445],
      [0.5, 0.46],
      [0.5, 0.475]
    ],
    icon: 'icon/skill/1013_talent.png'
  },
  101306: {
    id: '101306',
    name: 'Attack',
    max_level: 1,
    element: 'Ice',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1013_basic_atk.png'
  },
  101307: {
    id: '101307',
    name: 'It Can Still Be Optimized',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "After using her Technique, Herta's ATK increases by #1[i]% for #2[i] turn(s) at the beginning of the next battle.",
    params: [[0.4, 3]],
    icon: 'icon/skill/1013_technique.png'
  },
  110101: {
    id: '110101',
    name: 'Windrider Bullet',
    max_level: 9,
    element: 'Wind',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Wind DMG to a single enemy.',
    desc: "Deals Wind DMG equal to #1[i]% of Bronya's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1101_basic_atk.png'
  },
  110102: {
    id: '110102',
    name: 'Combat Redeployment',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      'Dispels 1 debuff from a single ally, increases the damage they deal, and allows them to immediately take action.',
    desc: 'Dispels a debuff from a single ally, allows them to immediately take action, and increases their DMG by #1[i]% for #3[i] turn(s).\nWhen this Skill is used on Bronya herself, she cannot immediately take action again.',
    params: [
      [0.33, 0, 1, 1],
      [0.363, 0, 1, 1],
      [0.396, 0, 1, 1],
      [0.429, 0, 1, 1],
      [0.462, 0, 1, 1],
      [0.495, 0, 1, 1],
      [0.5363, 0, 1, 1],
      [0.5775, 0, 1, 1],
      [0.6188, 0, 1, 1],
      [0.66, 0, 1, 1],
      [0.693, 0, 1, 1],
      [0.726, 0, 1, 1],
      [0.759, 0, 1, 1],
      [0.792, 0, 1, 1],
      [0.825, 0, 1, 1]
    ],
    icon: 'icon/skill/1101_skill.png'
  },
  110103: {
    id: '110103',
    name: 'The Belobog March',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: 'Increases ATK and CRIT DMG of all allies',
    desc: "Increases the ATK of all allies by #1[i]%, and increases their CRIT DMG equal to #2[i]% of Bronya's CRIT DMG plus #3[i]% for #4[i] turn(s).",
    params: [
      [0.33, 0.12, 0.12, 2],
      [0.352, 0.124, 0.128, 2],
      [0.374, 0.128, 0.136, 2],
      [0.396, 0.132, 0.144, 2],
      [0.418, 0.136, 0.152, 2],
      [0.44, 0.14, 0.16, 2],
      [0.4675, 0.145, 0.17, 2],
      [0.495, 0.15, 0.18, 2],
      [0.5225, 0.155, 0.19, 2],
      [0.55, 0.16, 0.2, 2],
      [0.572, 0.164, 0.208, 2],
      [0.594, 0.168, 0.216, 2],
      [0.616, 0.172, 0.224, 2],
      [0.638, 0.176, 0.232, 2],
      [0.66, 0.18, 0.24, 2]
    ],
    icon: 'icon/skill/1101_ultimate.png'
  },
  110104: {
    id: '110104',
    name: 'Leading the Way',
    max_level: 15,
    element: 'Wind',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'After this character uses Basic ATK, their next action will be Advanced Forward.',
    desc: "After using her Basic ATK, Bronya's next action will be Advanced Forward by #1[i]%.",
    params: [
      [0.15],
      [0.165],
      [0.18],
      [0.195],
      [0.21],
      [0.225],
      [0.2438],
      [0.2625],
      [0.2813],
      [0.3],
      [0.315],
      [0.33],
      [0.345],
      [0.36],
      [0.375]
    ],
    icon: 'icon/skill/1101_talent.png'
  },
  110106: {
    id: '110106',
    name: 'Attack',
    max_level: 1,
    element: 'Wind',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1101_basic_atk.png'
  },
  110107: {
    id: '110107',
    name: 'Banner of Command',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      "After this character uses Technique, increases all allies' ATK at the start of the next battle.",
    desc: "After using Bronya's Technique, at the start of the next battle, all allies' ATK increases by #1[i]% for #2[i] turn(s).",
    params: [[0.15, 2]],
    icon: 'icon/skill/1101_technique.png'
  },
  110201: {
    id: '110201',
    name: 'Thwack',
    max_level: 9,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Quantum DMG to a single enemy.',
    desc: "Deals Quantum DMG equal to #1[i]% of Seele's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1102_basic_atk.png'
  },
  110202: {
    id: '110202',
    name: 'Sheathed Blade',
    max_level: 15,
    element: 'Quantum',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals Quantum DMG to a single enemy and increases SPD.',
    desc: "Increases Seele's SPD by #2[i]% for #3[i] turn(s) and deals Quantum DMG equal to #1[i]% of Seele's ATK to a single enemy.",
    params: [
      [1.1, 0.25, 2],
      [1.21, 0.25, 2],
      [1.32, 0.25, 2],
      [1.43, 0.25, 2],
      [1.54, 0.25, 2],
      [1.65, 0.25, 2],
      [1.7875, 0.25, 2],
      [1.925, 0.25, 2],
      [2.0625, 0.25, 2],
      [2.2, 0.25, 2],
      [2.31, 0.25, 2],
      [2.42, 0.25, 2],
      [2.53, 0.25, 2],
      [2.64, 0.25, 2],
      [2.75, 0.25, 2]
    ],
    icon: 'icon/skill/1102_skill.png'
  },
  110203: {
    id: '110203',
    name: 'Butterfly Flurry',
    max_level: 15,
    element: 'Quantum',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Enters the buffed state and deals massive Quantum DMG to a single enemy.',
    desc: 'Seele enters the buffed state and deals Quantum DMG equal to #1[i]% of her ATK to a single enemy.',
    params: [
      [2.55],
      [2.72],
      [2.89],
      [3.06],
      [3.23],
      [3.4],
      [3.6125],
      [3.825],
      [4.0375],
      [4.25],
      [4.42],
      [4.59],
      [4.76],
      [4.93],
      [5.1]
    ],
    icon: 'icon/skill/1102_ultimate.png'
  },
  110204: {
    id: '110204',
    name: 'Resurgence',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'Enters the buffed state upon defeating an enemy with Basic ATK, Skill, or Ultimate, and receives an extra turn. While in the buffed state, the DMG of Seele\'s attacks increases by #1[i]% for #2[i] turn(s).\nEnemies defeated in the extra turn provided by "Resurgence" will not trigger another "Resurgence."',
    params: [
      [0.4, 1],
      [0.44, 1],
      [0.48, 1],
      [0.52, 1],
      [0.56, 1],
      [0.6, 1],
      [0.65, 1],
      [0.7, 1],
      [0.75, 1],
      [0.8, 1],
      [0.84, 1],
      [0.88, 1],
      [0.92, 1],
      [0.96, 1],
      [1, 1]
    ],
    icon: 'icon/skill/1102_talent.png'
  },
  110206: {
    id: '110206',
    name: 'Attack',
    max_level: 1,
    element: 'Quantum',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1102_basic_atk.png'
  },
  110207: {
    id: '110207',
    name: 'Phantom Illusion',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'After using her Technique, Seele gains Stealth for #1[i] second(s). While Stealth is active, Seele cannot be detected by enemies. And when entering battle by attacking enemies, Seele will immediately enter the buffed state.',
    params: [[20]],
    icon: 'icon/skill/1102_technique.png'
  },
  110301: {
    id: '110301',
    name: 'Roaring Thunderclap',
    max_level: 9,
    element: 'Thunder',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Lightning DMG to a single enemy.',
    desc: "Deals Lightning DMG equal to #1[i]% of Serval's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1103_basic_atk.png'
  },
  110302: {
    id: '110302',
    name: 'Lightning Flash',
    max_level: 15,
    element: 'Thunder',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals minor Lightning DMG to a single enemy and enemies adjacent to it, with a high chance of Shocking enemies hit.',
    desc: "Deals Lightning DMG equal to #1[i]% of Serval's ATK to a single enemy and Lightning DMG equal to #2[i]% of Serval's ATK to enemies adjacent to it, with a #3[i]% base chance for enemies hit to become Shocked for #4[i] turn(s).\nWhile Shocked, enemies take Lightning DoT equal to #5[i]% of Serval's ATK at the beginning of each turn.",
    params: [
      [0.7, 0.3, 0.8, 2, 0.4],
      [0.77, 0.33, 0.8, 2, 0.44],
      [0.84, 0.36, 0.8, 2, 0.48],
      [0.91, 0.39, 0.8, 2, 0.52],
      [0.98, 0.42, 0.8, 2, 0.56],
      [1.05, 0.45, 0.8, 2, 0.62],
      [1.1375, 0.4875, 0.8, 2, 0.7],
      [1.225, 0.525, 0.8, 2, 0.8],
      [1.3125, 0.5625, 0.8, 2, 0.92],
      [1.4, 0.6, 0.8, 2, 1.04],
      [1.47, 0.63, 0.8, 2, 1.092],
      [1.54, 0.66, 0.8, 2, 1.144],
      [1.61, 0.69, 0.8, 2, 1.196],
      [1.68, 0.72, 0.8, 2, 1.248],
      [1.75, 0.75, 0.8, 2, 1.3]
    ],
    icon: 'icon/skill/1103_skill.png'
  },
  110303: {
    id: '110303',
    name: 'Here Comes the Mechanical Fever',
    max_level: 15,
    element: 'Thunder',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Deals Lightning DMG to all enemies and increases the duration of Shock.',
    desc: "Deals Lightning DMG equal to #1[i]% of Serval's ATK to all enemies. Enemies already Shocked will extend the duration of their Shock state by #2[i] turn(s).",
    params: [
      [1.08, 2],
      [1.152, 2],
      [1.224, 2],
      [1.296, 2],
      [1.368, 2],
      [1.44, 2],
      [1.53, 2],
      [1.62, 2],
      [1.71, 2],
      [1.8, 2],
      [1.872, 2],
      [1.944, 2],
      [2.016, 2],
      [2.088, 2],
      [2.16, 2]
    ],
    icon: 'icon/skill/1103_ultimate.png'
  },
  110304: {
    id: '110304',
    name: 'Galvanic Chords',
    max_level: 15,
    element: 'Thunder',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'After using an attack, deals minor Additional DMG to all Shocked enemy targets.',
    desc: "After Serval attacks, deals Additional Lightning DMG equal to #1[i]% of Serval's ATK to all Shocked enemies.",
    params: [
      [0.36],
      [0.396],
      [0.432],
      [0.468],
      [0.504],
      [0.54],
      [0.585],
      [0.63],
      [0.675],
      [0.72],
      [0.756],
      [0.792],
      [0.828],
      [0.864],
      [0.9]
    ],
    icon: 'icon/skill/1103_talent.png'
  },
  110306: {
    id: '110306',
    name: 'Attack',
    max_level: 1,
    element: 'Thunder',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1103_basic_atk.png'
  },
  110307: {
    id: '110307',
    name: 'Good Night, Belobog',
    max_level: 1,
    element: 'Thunder',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, deals minor DMG to a random single enemy, with a high chance of applying Shock to all enemy targets.',
    desc: "Immediately attacks the enemy. After entering battle, deals Lightning DMG equal to #4[i]% of Serval's ATK to a random enemy, with a #1[i]% base chance for all enemies to become Shocked for #3[i] turn(s).\nWhile Shocked, enemies will take Lightning DoT equal to #2[i]% of Serval's ATK at the beginning of each turn.",
    params: [[1, 0.5, 3, 0.5]],
    icon: 'icon/skill/1103_technique.png'
  },
  110401: {
    id: '110401',
    name: 'Fist of Conviction',
    max_level: 9,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Ice DMG to a single enemy.',
    desc: "Deals Ice DMG equal to #1[i]% of Gepard's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1104_basic_atk.png'
  },
  110402: {
    id: '110402',
    name: 'Daunting Smite',
    max_level: 15,
    element: 'Ice',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'Deals Ice DMG to a single enemy, with a chance of Freezing them.',
    desc: "Deals Ice DMG equal to #1[i]% of Gepard's ATK to a single enemy, with a #2[i]% base chance to Freeze the enemy for #3[i] turn(s).\nWhile Frozen, the enemy cannot take action and will take Additional Ice DMG equal to #4[i]% of Gepard's ATK at the beginning of each turn.",
    params: [
      [1, 0.65, 1, 0.3],
      [1.1, 0.65, 1, 0.33],
      [1.2, 0.65, 1, 0.36],
      [1.3, 0.65, 1, 0.39],
      [1.4, 0.65, 1, 0.42],
      [1.5, 0.65, 1, 0.45],
      [1.625, 0.65, 1, 0.4875],
      [1.75, 0.65, 1, 0.525],
      [1.875, 0.65, 1, 0.5625],
      [2, 0.65, 1, 0.6],
      [2.1, 0.65, 1, 0.63],
      [2.2, 0.65, 1, 0.66],
      [2.3, 0.65, 1, 0.69],
      [2.4, 0.65, 1, 0.72],
      [2.5, 0.65, 1, 0.75]
    ],
    icon: 'icon/skill/1104_skill.png'
  },
  110403: {
    id: '110403',
    name: 'Enduring Bulwark',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Defence',
    effect_text: 'Defense',
    simple_desc: 'Provides a Shield to all allies.',
    desc: "Applies a Shield to all allies, absorbing DMG equal to #1[i]% of Gepard's DEF plus #3[i] for #2[i] turn(s).",
    params: [
      [0.3, 3, 150],
      [0.3188, 3, 240],
      [0.3375, 3, 307.5],
      [0.3563, 3, 375],
      [0.375, 3, 420],
      [0.39, 3, 465],
      [0.405, 3, 498.75],
      [0.42, 3, 532.5],
      [0.435, 3, 566.25],
      [0.45, 3, 600],
      [0.465, 3, 633.75],
      [0.48, 3, 667.5],
      [0.495, 3, 701.25],
      [0.51, 3, 735],
      [0.525, 3, 768.75]
    ],
    icon: 'icon/skill/1104_ultimate.png'
  },
  110404: {
    id: '110404',
    name: 'Unyielding Will',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      'When struck by a killing blow, instead of being knocked down, immediately restores HP. This effect can only trigger 1 time per battle.',
    desc: "When struck with a killing blow, instead of becoming knocked down, Gepard's HP immediately restores to #1[i]% of his Max HP. This effect can only trigger once per battle.",
    params: [
      [0.25],
      [0.275],
      [0.3],
      [0.325],
      [0.35],
      [0.375],
      [0.4063],
      [0.4375],
      [0.4688],
      [0.5],
      [0.525],
      [0.55],
      [0.575],
      [0.6],
      [0.625]
    ],
    icon: 'icon/skill/1104_talent.png'
  },
  110406: {
    id: '110406',
    name: 'Attack',
    max_level: 1,
    element: 'Ice',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1104_basic_atk.png'
  },
  110407: {
    id: '110407',
    name: 'Comradery',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Defence',
    effect_text: 'Defense',
    simple_desc:
      'After this character uses Technique, all allies gain a Shield at the start of the next battle.',
    desc: "After Gepard uses his Technique, when the next battle begins, a Shield will be applied to all allies, absorbing DMG equal to #1[i]% of Gepard's DEF plus #3[i] for #2[i] turn(s).",
    params: [[0.24, 2, 150]],
    icon: 'icon/skill/1104_technique.png'
  },
  110501: {
    id: '110501',
    name: 'Behind the Kindness',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Physical DMG to a single enemy.',
    desc: "Deals Physical DMG equal to #1[i]% of Natasha's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1105_basic_atk.png'
  },
  110502: {
    id: '110502',
    name: 'Love, Heal, and Choose',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc: "Restores a single ally's HP and continuously heals them.",
    desc: "Restores a single ally for #1[i]% of Natasha's Max HP plus #4[i]. Restores the ally for another #2[i]% of Natasha's Max HP plus #5[i] at the beginning of each turn for #3[i] turn(s).",
    params: [
      [0.07, 0.048, 2, 70, 48],
      [0.0744, 0.051, 2, 112, 76.8],
      [0.0788, 0.054, 2, 143.5, 98.4],
      [0.0831, 0.057, 2, 175, 120],
      [0.0875, 0.06, 2, 196, 134.4],
      [0.091, 0.0624, 2, 217, 148.8],
      [0.0945, 0.0648, 2, 232.75, 159.6],
      [0.098, 0.0672, 2, 248.5, 170.4],
      [0.1015, 0.0696, 2, 264.25, 181.2],
      [0.105, 0.072, 2, 280, 192],
      [0.1085, 0.0744, 2, 295.75, 202.8],
      [0.112, 0.0768, 2, 311.5, 213.6],
      [0.1155, 0.0792, 2, 327.25, 224.4],
      [0.119, 0.0816, 2, 343, 235.2],
      [0.1225, 0.084, 2, 358.75, 246]
    ],
    icon: 'icon/skill/1105_skill.png'
  },
  110503: {
    id: '110503',
    name: 'Gift of Rebirth',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc: "Restores all allies' HP.",
    desc: "Heals all allies for #1[i]% of Natasha's Max HP plus #2[i].",
    params: [
      [0.092, 92],
      [0.0978, 147.2],
      [0.1035, 188.6],
      [0.1092, 230],
      [0.115, 257.6],
      [0.1196, 285.2],
      [0.1242, 305.9],
      [0.1288, 326.6],
      [0.1334, 347.3],
      [0.138, 368],
      [0.1426, 388.7],
      [0.1472, 409.4],
      [0.1518, 430.1],
      [0.1564, 450.8],
      [0.161, 471.5]
    ],
    icon: 'icon/skill/1105_ultimate.png'
  },
  110504: {
    id: '110504',
    name: 'Innervation',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'When healing allies with low HP, increases Outgoing Healing. This effect also works on continuous healing.',
    desc: "When healing allies with HP percentage at #1[i]% or lower, increases Natasha's Outgoing Healing by #2[i]%. This effect also works on continuous healing.",
    params: [
      [0.3, 0.25],
      [0.3, 0.275],
      [0.3, 0.3],
      [0.3, 0.325],
      [0.3, 0.35],
      [0.3, 0.375],
      [0.3, 0.4063],
      [0.3, 0.4375],
      [0.3, 0.4688],
      [0.3, 0.5],
      [0.3, 0.525],
      [0.3, 0.55],
      [0.3, 0.575],
      [0.3, 0.6],
      [0.3, 0.625]
    ],
    icon: 'icon/skill/1105_talent.png'
  },
  110506: {
    id: '110506',
    name: 'Attack',
    max_level: 1,
    element: 'Physical',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1105_basic_atk.png'
  },
  110507: {
    id: '110507',
    name: 'Hypnosis Research',
    max_level: 1,
    element: 'Physical',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, deals minor Physical DMG to a random single enemy, with a high chance to inflict Weaken to all enemy targets.',
    desc: "Immediately attacks the enemy. After entering battle, deals Physical DMG equal to #4[i]% of Natasha's ATK to a random enemy, with a #1[i]% base chance to Weaken all enemies.\nWhile Weakened, enemies deal #2[i]% less DMG to allies for #3[i] turn(s).",
    params: [[1, 0.3, 1, 0.8]],
    icon: 'icon/skill/1105_technique.png'
  },
  110601: {
    id: '110601',
    name: 'Frost Shot',
    max_level: 9,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Ice DMG to a single enemy.',
    desc: "Deals Ice DMG equal to #1[i]% of Pela's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1106_basic_atk.png'
  },
  110602: {
    id: '110602',
    name: 'Frostbite',
    max_level: 15,
    element: 'Ice',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'Dispels 1 buff from a single enemy target, and deals Ice DMG to the target enemy.',
    desc: "Removes #2[i] buff(s) and deals Ice DMG equal to #1[i]% of Pela's ATK to a single target enemy.",
    params: [
      [1.05, 1],
      [1.155, 1],
      [1.26, 1],
      [1.365, 1],
      [1.47, 1],
      [1.575, 1],
      [1.7063, 1],
      [1.8375, 1],
      [1.9688, 1],
      [2.1, 1],
      [2.205, 1],
      [2.31, 1],
      [2.415, 1],
      [2.52, 1],
      [2.625, 1]
    ],
    icon: 'icon/skill/1106_skill.png'
  },
  110603: {
    id: '110603',
    name: 'Zone Suppression',
    max_level: 15,
    element: 'Ice',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      "Has a high chance of lowering enemies' DEF and deals minor Ice DMG to all enemies.",
    desc: "Deals Ice DMG equal to #4[i]% of Pela's ATK to all enemies, with a #1[i]% base chance to inflict Exposed on all enemies.\nWhen Exposed, enemies' DEF is reduced by #2[i]% for #3[i] turn(s).",
    params: [
      [1, 0.3, 2, 0.6],
      [1, 0.31, 2, 0.64],
      [1, 0.32, 2, 0.68],
      [1, 0.33, 2, 0.72],
      [1, 0.34, 2, 0.76],
      [1, 0.35, 2, 0.8],
      [1, 0.3625, 2, 0.85],
      [1, 0.375, 2, 0.9],
      [1, 0.3875, 2, 0.95],
      [1, 0.4, 2, 1],
      [1, 0.41, 2, 1.04],
      [1, 0.42, 2, 1.08],
      [1, 0.43, 2, 1.12],
      [1, 0.44, 2, 1.16],
      [1, 0.45, 2, 1.2]
    ],
    icon: 'icon/skill/1106_ultimate.png'
  },
  110604: {
    id: '110604',
    name: 'Data Collecting',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      'After using an attack, if the enemy target is currently inflicted with debuff(s), Pela regenerates Energy.',
    desc: "If the enemy is debuffed after Pela's attack, Pela will restore #1[i] additional Energy. This effect can only be triggered 1 time per attack.",
    params: [
      [5],
      [5.5],
      [6],
      [6.5],
      [7],
      [7.5],
      [8.125],
      [8.75],
      [9.375],
      [10],
      [10.5],
      [11],
      [11.5],
      [12],
      [12.5]
    ],
    icon: 'icon/skill/1106_talent.png'
  },
  110606: {
    id: '110606',
    name: 'Attack',
    max_level: 1,
    element: 'Ice',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1106_basic_atk.png'
  },
  110607: {
    id: '110607',
    name: 'Preemptive Strike',
    max_level: 1,
    element: 'Ice',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, deals minor DMG to a random single enemy, with a high chance of lowering the DEF of all enemy targets.',
    desc: 'Immediately attacks the enemy. Upon entering battle, Pela deals Ice DMG equal to #4[i]% of her ATK to a random enemy, with a #1[i]% base chance of lowering the DEF of all enemies by #2[i]% for #3[i] turn(s).',
    params: [[1, 0.2, 2, 0.8]],
    icon: 'icon/skill/1106_technique.png'
  },
  110701: {
    id: '110701',
    name: 'I Want to Help',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Physical DMG to a single enemy.',
    desc: "Deals Physical DMG equal to #1[i]% of Clara's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1107_basic_atk.png'
  },
  110702: {
    id: '110702',
    name: 'Svarog Watches Over You',
    max_level: 15,
    element: 'Physical',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Deals Physical DMG to all enemies. Additionally deals Physical DMG to targets with Marks of Counter.',
    desc: "Deals Physical DMG equal to #1[i]% of Clara's ATK to all enemies, and additionally deals Physical DMG equal to #2[i]% of Clara's ATK to enemies marked by Svarog with a Mark of Counter.\nAll Marks of Counter will be removed after this Skill is used.",
    params: [
      [0.6, 0.6],
      [0.66, 0.66],
      [0.72, 0.72],
      [0.78, 0.78],
      [0.84, 0.84],
      [0.9, 0.9],
      [0.975, 0.975],
      [1.05, 1.05],
      [1.125, 1.125],
      [1.2, 1.2],
      [1.26, 1.26],
      [1.32, 1.32],
      [1.38, 1.38],
      [1.44, 1.44],
      [1.5, 1.5]
    ],
    icon: 'icon/skill/1107_skill.png'
  },
  110703: {
    id: '110703',
    name: 'Promise, Not Command',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'Reduces DMG received, increases chance to be attacked by enemies, and enhances Counters.',
    desc: "After Clara uses Ultimate, DMG dealt to her is reduced by an extra #4[i]%, and she has greatly increased chances of being attacked by enemies for #3[i] turn(s).\nIn addition, Svarog's Counter is enhanced. When an ally is attacked, Svarog immediately launches a Counter, and its DMG multiplier against the enemy increases by #2[i]%. Enemies adjacent to it take 50% of the DMG dealt to the target enemy. Enhanced Counter(s) can take effect #5[i] time(s).",
    params: [
      [5, 0.96, 2, 0.15, 2],
      [5, 1.024, 2, 0.16, 2],
      [5, 1.088, 2, 0.17, 2],
      [5, 1.152, 2, 0.18, 2],
      [5, 1.216, 2, 0.19, 2],
      [5, 1.28, 2, 0.2, 2],
      [5, 1.36, 2, 0.2125, 2],
      [5, 1.44, 2, 0.225, 2],
      [5, 1.52, 2, 0.2375, 2],
      [5, 1.6, 2, 0.25, 2],
      [5, 1.664, 2, 0.26, 2],
      [5, 1.728, 2, 0.27, 2],
      [5, 1.792, 2, 0.28, 2],
      [5, 1.856, 2, 0.29, 2],
      [5, 1.92, 2, 0.3, 2]
    ],
    icon: 'icon/skill/1107_ultimate.png'
  },
  110704: {
    id: '110704',
    name: "Because We're Family",
    max_level: 15,
    element: 'Physical',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      "DMG received from enemy attacks is reduced. Enemies who attack Clara will be marked with a Mark of Counter and met with Svarog's Counter, dealing Physical DMG.",
    desc: "Under the protection of Svarog, DMG taken by Clara when hit by enemy attacks is reduced by #3[i]%. Svarog will mark enemies who attack Clara with his Mark of Counter and retaliate with a Counter, dealing Physical DMG equal to #2[i]% of Clara's ATK.",
    params: [
      [1, 0.8, 0.1],
      [1, 0.88, 0.1],
      [1, 0.96, 0.1],
      [1, 1.04, 0.1],
      [1, 1.12, 0.1],
      [1, 1.2, 0.1],
      [1, 1.3, 0.1],
      [1, 1.4, 0.1],
      [1, 1.5, 0.1],
      [1, 1.6, 0.1],
      [1, 1.68, 0.1],
      [1, 1.76, 0.1],
      [1, 1.84, 0.1],
      [1, 1.92, 0.1],
      [1, 2, 0.1]
    ],
    icon: 'icon/skill/1107_talent.png'
  },
  110706: {
    id: '110706',
    name: 'Attack',
    max_level: 1,
    element: 'Physical',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1107_basic_atk.png'
  },
  110707: {
    id: '110707',
    name: 'A Small Price for Victory',
    max_level: 1,
    element: 'Physical',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      "Attacks the enemy. After entering battle, this character's chance of being attacked by enemies increases.",
    desc: 'Immediately attacks the enemy. Upon entering battle, the chance Clara will be attacked by enemies increases for #1[i] turn(s).',
    params: [[2, 5]],
    icon: 'icon/skill/1107_technique.png'
  },
  110801: {
    id: '110801',
    name: 'Dazzling Blades',
    max_level: 9,
    element: 'Wind',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Wind DMG to a single enemy.',
    desc: "Deals Wind DMG equal to #1[i]% of Sampo's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1108_basic_atk.png'
  },
  110802: {
    id: '110802',
    name: 'Ricochet Love',
    max_level: 15,
    element: 'Wind',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Bounce',
    effect_text: 'Bounce',
    simple_desc:
      'Deals minor Wind DMG to single enemy targets with 5 Bounces in total.',
    desc: "Deals Wind DMG equal to #2[i]% of Sampo's ATK to a single enemy, and further deals DMG for #1[i] extra time(s), with each time dealing Wind DMG equal to #2[i]% of Sampo's ATK to a random enemy.",
    params: [
      [4, 0.28],
      [4, 0.308],
      [4, 0.336],
      [4, 0.364],
      [4, 0.392],
      [4, 0.42],
      [4, 0.455],
      [4, 0.49],
      [4, 0.525],
      [4, 0.56],
      [4, 0.588],
      [4, 0.616],
      [4, 0.644],
      [4, 0.672],
      [4, 0.7]
    ],
    icon: 'icon/skill/1108_skill.png'
  },
  110803: {
    id: '110803',
    name: 'Surprise Present',
    max_level: 15,
    element: 'Wind',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'Deals Wind DMG to all enemies with a high chance to increase the DoT dealt to the targets.',
    desc: "Deals Wind DMG equal to #1[i]% of Sampo's ATK to all enemies, with a #4[i]% base chance to increase the targets' DoT taken by #2[i]% for #3[i] turn(s).",
    params: [
      [0.96, 0.2, 2, 1],
      [1.024, 0.21, 2, 1],
      [1.088, 0.22, 2, 1],
      [1.152, 0.23, 2, 1],
      [1.216, 0.24, 2, 1],
      [1.28, 0.25, 2, 1],
      [1.36, 0.2625, 2, 1],
      [1.44, 0.275, 2, 1],
      [1.52, 0.2875, 2, 1],
      [1.6, 0.3, 2, 1],
      [1.664, 0.31, 2, 1],
      [1.728, 0.32, 2, 1],
      [1.792, 0.33, 2, 1],
      [1.856, 0.34, 2, 1],
      [1.92, 0.35, 2, 1]
    ],
    icon: 'icon/skill/1108_ultimate.png'
  },
  110804: {
    id: '110804',
    name: 'Windtorn Dagger',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'After this character hits an enemy, there is a chance of inflicting Wind Shear on the target.',
    desc: "Sampo's attacks have a #1[i]% base chance to inflict Wind Shear for #3[i] turn(s).\nEnemies inflicted with Wind Shear will take Wind DoT equal to #2[i]% of Sampo's ATK at the beginning of each turn. Wind Shear can stack up to #4[i] time(s).",
    params: [
      [0.65, 0.2, 3, 5],
      [0.65, 0.22, 3, 5],
      [0.65, 0.24, 3, 5],
      [0.65, 0.26, 3, 5],
      [0.65, 0.28, 3, 5],
      [0.65, 0.31, 3, 5],
      [0.65, 0.35, 3, 5],
      [0.65, 0.4, 3, 5],
      [0.65, 0.46, 3, 5],
      [0.65, 0.52, 3, 5],
      [0.65, 0.546, 3, 5],
      [0.65, 0.572, 3, 5],
      [0.65, 0.598, 3, 5],
      [0.65, 0.624, 3, 5],
      [0.65, 0.65, 3, 5]
    ],
    icon: 'icon/skill/1108_talent.png'
  },
  110806: {
    id: '110806',
    name: 'Attack',
    max_level: 1,
    element: 'Wind',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1108_basic_atk.png'
  },
  110807: {
    id: '110807',
    name: 'Shining Bright',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      "Enemies in a set area are Blinded. When initiating battle against a Blinded enemy, there is a high chance to delay all enemies' actions.",
    desc: "After Sampo uses his Technique, enemies in a set area are inflicted with Blind for #1[i] second(s). Blinded enemies cannot detect your team.\nWhen initiating combat against a Blinded enemy, there is a #2[i]% fixed chance to delay all enemies' action by #3[i]%.",
    params: [[10, 1, 0.25]],
    icon: 'icon/skill/1108_technique.png'
  },
  110901: {
    id: '110901',
    name: "Hehe! Don't Get Burned!",
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to a single enemy.',
    desc: "Deals Fire DMG equal to #1[i]% of Hook's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1109_basic_atk.png'
  },
  110902: {
    id: '110902',
    name: 'Hey! Remember Hook?',
    max_level: 15,
    element: 'Fire',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Deals Fire DMG to a single enemy, with a high chance to inflict Burn on the enemy.',
    desc: "Deals Fire DMG equal to #1[i]% of Hook's ATK to a single enemy. In addition, there is a #2[i]% base chance to inflict Burn for #3[i] turn(s).\nWhen afflicted with Burn, enemies will take Fire DoT equal to #4[i]% of Hook's ATK at the beginning of each turn.",
    params: [
      [1.2, 1, 2, 0.25],
      [1.32, 1, 2, 0.275],
      [1.44, 1, 2, 0.3],
      [1.56, 1, 2, 0.325],
      [1.68, 1, 2, 0.35],
      [1.8, 1, 2, 0.3875],
      [1.95, 1, 2, 0.4375],
      [2.1, 1, 2, 0.5],
      [2.25, 1, 2, 0.575],
      [2.4, 1, 2, 0.65],
      [2.52, 1, 2, 0.6825],
      [2.64, 1, 2, 0.715],
      [2.76, 1, 2, 0.7475],
      [2.88, 1, 2, 0.78],
      [3, 1, 2, 0.8125]
    ],
    icon: 'icon/skill/1109_skill.png'
  },
  110903: {
    id: '110903',
    name: 'Boom! Here Comes the Fire!',
    max_level: 15,
    element: 'Fire',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      "Deals massive Fire DMG to a single enemy and Enhances this unit's next Skill.",
    desc: "Deals Fire DMG equal to #1[i]% of Hook's ATK to a single enemy.\nAfter using Ultimate, the next Skill to be used is Enhanced, which deals DMG to a single enemy and enemies adjacent to it.",
    params: [
      [2.4],
      [2.56],
      [2.72],
      [2.88],
      [3.04],
      [3.2],
      [3.4],
      [3.6],
      [3.8],
      [4],
      [4.16],
      [4.32],
      [4.48],
      [4.64],
      [4.8]
    ],
    icon: 'icon/skill/1109_ultimate.png'
  },
  110904: {
    id: '110904',
    name: 'Ha! Oil to the Flames!',
    max_level: 15,
    element: 'Fire',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'When attacking a Burned enemy, deals Additional Fire DMG for a moderate amount, and additionally regenerates energy.',
    desc: "When attacking a target afflicted with Burn, deals Additional Fire DMG equal to #1[i]% of Hook's ATK and regenerates #2[i] extra Energy.",
    params: [
      [0.5, 5],
      [0.55, 5],
      [0.6, 5],
      [0.65, 5],
      [0.7, 5],
      [0.75, 5],
      [0.8125, 5],
      [0.875, 5],
      [0.9375, 5],
      [1, 5],
      [1.05, 5],
      [1.1, 5],
      [1.15, 5],
      [1.2, 5],
      [1.25, 5]
    ],
    icon: 'icon/skill/1109_talent.png'
  },
  110906: {
    id: '110906',
    name: 'Attack',
    max_level: 1,
    element: 'Fire',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1109_basic_atk.png'
  },
  110907: {
    id: '110907',
    name: 'Ack! Look at This Mess!',
    max_level: 1,
    element: 'Fire',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, deals Fire DMG to a random single enemy, with a high chance to inflict Burn on all enemy targets.',
    desc: "Immediately attacks the enemy. Upon entering battle, Hook deals Fire DMG equal to #4[i]% of her ATK to a random enemy. In addition, there is a #1[i]% base chance to inflict Burn on every enemy for #3[i] turn(s).\nWhen afflicted with Burn, enemies will take Fire DoT equal to #2[i]% of Hook's ATK at the beginning of each turn.",
    params: [[1, 0.5, 3, 0.5]],
    icon: 'icon/skill/1109_technique.png'
  },
  110909: {
    id: '110909',
    name: 'Hey! Remember Hook?',
    max_level: 15,
    element: 'Fire',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals Fire DMG to a single enemy with a high chance of inflicting Burn, also deals minor Fire DMG to enemies adjacent to it.',
    desc: "Deals Fire DMG equal to #1[i]% of Hook's ATK to a single enemy, with a #2[i]% base chance to Burn them for #3[i] turn(s). Additionally, deals Fire DMG equal to #5[i]% of Hook's ATK to enemies adjacent to it.\nWhen afflicted with Burn, enemies will take Fire DoT equal to #4[i]% of Hook's ATK at the beginning of each turn.",
    params: [
      [1.4, 1, 2, 0.25, 0.4],
      [1.54, 1, 2, 0.275, 0.44],
      [1.68, 1, 2, 0.3, 0.48],
      [1.82, 1, 2, 0.325, 0.52],
      [1.96, 1, 2, 0.35, 0.56],
      [2.1, 1, 2, 0.3875, 0.6],
      [2.275, 1, 2, 0.4375, 0.65],
      [2.45, 1, 2, 0.5, 0.7],
      [2.625, 1, 2, 0.575, 0.75],
      [2.8, 1, 2, 0.65, 0.8],
      [2.94, 1, 2, 0.6825, 0.84],
      [3.08, 1, 2, 0.715, 0.88],
      [3.22, 1, 2, 0.7475, 0.92],
      [3.36, 1, 2, 0.78, 0.96],
      [3.5, 1, 2, 0.8125, 1]
    ],
    icon: 'icon/skill/1109_skill.png'
  },
  111001: {
    id: '111001',
    name: 'Ice Crampon Technique',
    max_level: 9,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Quantum DMG to a single enemy.',
    desc: "Deals Quantum DMG equal to #1[i]% of this character's Max HP to a single enemy.",
    params: [
      [0.25],
      [0.3],
      [0.35],
      [0.4],
      [0.45],
      [0.5],
      [0.55],
      [0.6],
      [0.65]
    ],
    icon: 'icon/skill/1110_basic_atk.png'
  },
  111002: {
    id: '111002',
    name: 'Salted Camping Cans',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      'Applies "Survival Response" to a single ally, increases their Max HP, and restores their HP.',
    desc: 'Applies "Survival Response" to a single target ally and increases their Max HP by #1[i]% of Lynx\'s Max HP plus #2[i]. If the target ally is a character on the Path of Destruction or Preservation, the chance of them being attacked by enemies will greatly increase. "Survival Response" lasts for #3[i] turn(s).\nRestores the target\'s HP by #4[i]% of Lynx\'s Max HP plus #5[i].',
    params: [
      [0.05, 50, 2, 0.08, 80, 5],
      [0.0525, 80, 2, 0.085, 128, 5],
      [0.055, 102.5, 2, 0.09, 164, 5],
      [0.0575, 125, 2, 0.095, 200, 5],
      [0.06, 140, 2, 0.1, 224, 5],
      [0.0625, 155, 2, 0.104, 248, 5],
      [0.0656, 166.25, 2, 0.108, 266, 5],
      [0.0688, 177.5, 2, 0.112, 284, 5],
      [0.0719, 188.75, 2, 0.116, 302, 5],
      [0.075, 200, 2, 0.12, 320, 5],
      [0.0775, 211.25, 2, 0.124, 338, 5],
      [0.08, 222.5, 2, 0.128, 356, 5],
      [0.0825, 233.75, 2, 0.132, 374, 5],
      [0.085, 245, 2, 0.136, 392, 5],
      [0.0875, 256.25, 2, 0.14, 410, 5]
    ],
    icon: 'icon/skill/1110_skill.png'
  },
  111003: {
    id: '111003',
    name: 'Snowfield First Aid',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc: 'Dispels 1 debuff from all allies and restores their HP.',
    desc: "Dispels #1[i] debuff(s) from all allies and immediately restores their respective HP by an amount equal to #2[i]% of Lynx's Max HP plus #3[i].",
    params: [
      [1, 0.09, 90],
      [1, 0.0956, 144],
      [1, 0.1013, 184.5],
      [1, 0.1069, 225],
      [1, 0.1125, 252],
      [1, 0.117, 279],
      [1, 0.1215, 299.25],
      [1, 0.126, 319.5],
      [1, 0.1305, 339.75],
      [1, 0.135, 360],
      [1, 0.1395, 380.25],
      [1, 0.144, 400.5],
      [1, 0.1485, 420.75],
      [1, 0.153, 441],
      [1, 0.1575, 461.25]
    ],
    icon: 'icon/skill/1110_ultimate.png'
  },
  111004: {
    id: '111004',
    name: 'Outdoor Survival Experience',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      'When using Skill or Ultimate, applies continuous healing on the target ally. If the target has "Survival Response", the continuous healing effect additionally increases.',
    desc: "When using Lynx's Skill or Ultimate, applies continuous healing to the target ally for #1[i] turn(s), restoring the target ally's HP by an amount equal to #2[i]% of Lynx's Max HP plus #3[i] at the start of each their turn. If the target has \"Survival Response\", the continuous healing effect additionally restores HP by an amount equal to #4[i]% of Lynx's Max HP plus #5[i].",
    params: [
      [2, 0.024, 24, 0.03, 30],
      [2, 0.0255, 38.4, 0.0319, 48],
      [2, 0.027, 49.2, 0.0338, 61.5],
      [2, 0.0285, 60, 0.0356, 75],
      [2, 0.03, 67.2, 0.0375, 84],
      [2, 0.0312, 74.4, 0.039, 93],
      [2, 0.0324, 79.8, 0.0405, 99.75],
      [2, 0.0336, 85.2, 0.042, 106.5],
      [2, 0.0348, 90.6, 0.0435, 113.25],
      [2, 0.036, 96, 0.045, 120],
      [2, 0.0372, 101.4, 0.0465, 126.75],
      [2, 0.0384, 106.8, 0.048, 133.5],
      [2, 0.0396, 112.2, 0.0495, 140.25],
      [2, 0.0408, 117.6, 0.051, 147],
      [2, 0.042, 123, 0.0525, 153.75]
    ],
    icon: 'icon/skill/1110_talent.png'
  },
  111006: {
    id: '111006',
    name: 'Attack',
    max_level: 1,
    element: 'Quantum',
    type: 'MazeNormal',
    type_text: '',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1110_basic_atk.png'
  },
  111007: {
    id: '111007',
    name: 'Chocolate Energy Bar',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      'After this character uses her Technique, at the start of the next battle, all allies are granted a continuous healing effect.',
    desc: "After Lynx uses her Technique, at the start of the next battle, all allies are granted her Talent's continuous healing effect, lasting for #1[i] turn(s).",
    params: [[2]],
    icon: 'icon/skill/1110_technique.png'
  },
  111101: {
    id: '111101',
    name: 'Direct Punch',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Physical DMG to a single enemy.',
    desc: "Deals Physical DMG equal to #1[i]% of Luka's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1111_basic_atk.png'
  },
  111102: {
    id: '111102',
    name: 'Lacerating Fist',
    max_level: 15,
    element: 'Physical',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Deals Physical DMG to a single enemy, with a high chance of causing the enemy to Bleed.',
    desc: "Deals Physical DMG equal to #1[i]% of Luka's ATK to a single enemy target. In addition, there is a #2[i]% base chance to inflict Bleed on them, lasting for #5[i] turn(s).\nWhile Bleeding, the enemy will take #3[i]% of their Max HP as Physical DoT at the start of each turn. This DMG will not exceed more than #4[i]% of Luka's ATK.",
    params: [
      [0.6, 1, 0.24, 1.3, 3],
      [0.66, 1, 0.24, 1.43, 3],
      [0.72, 1, 0.24, 1.56, 3],
      [0.78, 1, 0.24, 1.69, 3],
      [0.84, 1, 0.24, 1.82, 3],
      [0.9, 1, 0.24, 2.015, 3],
      [0.975, 1, 0.24, 2.275, 3],
      [1.05, 1, 0.24, 2.6, 3],
      [1.125, 1, 0.24, 2.99, 3],
      [1.2, 1, 0.24, 3.38, 3],
      [1.26, 1, 0.24, 3.549, 3],
      [1.32, 1, 0.24, 3.718, 3],
      [1.38, 1, 0.24, 3.887, 3],
      [1.44, 1, 0.24, 4.056, 3],
      [1.5, 1, 0.24, 4.225, 3]
    ],
    icon: 'icon/skill/1111_skill.png'
  },
  111103: {
    id: '111103',
    name: 'Coup de Grâce',
    max_level: 15,
    element: 'Physical',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      "Receives #5[i] stack(s) of Fighting Will, with a high chance of increasing the target's DMG received, and deals massive Physical DMG to the target.",
    desc: "Receives #5[i] stack(s) of Fighting Will, with a #2[i]% base chance to increase a single enemy target's DMG received by #3[i]% for #4[i] turn(s). Then, deals Physical DMG equal to #1[i]% of Luka's ATK to the target.",
    params: [
      [1.98, 1, 0.12, 3, 2],
      [2.112, 1, 0.128, 3, 2],
      [2.244, 1, 0.136, 3, 2],
      [2.376, 1, 0.144, 3, 2],
      [2.508, 1, 0.152, 3, 2],
      [2.64, 1, 0.16, 3, 2],
      [2.805, 1, 0.17, 3, 2],
      [2.97, 1, 0.18, 3, 2],
      [3.135, 1, 0.19, 3, 2],
      [3.3, 1, 0.2, 3, 2],
      [3.432, 1, 0.208, 3, 2],
      [3.564, 1, 0.216, 3, 2],
      [3.696, 1, 0.224, 3, 2],
      [3.828, 1, 0.232, 3, 2],
      [3.96, 1, 0.24, 3, 2]
    ],
    icon: 'icon/skill/1111_ultimate.png'
  },
  111104: {
    id: '111104',
    name: 'Flying Sparks',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'After using Basic ATK "Direct Punch" or Skill "Lacerating Fist," receives 1 stack of Fighting Will. When 2 or more stacks of Fighting Will are present, Basic Attack becomes Enhanced.\nIf the enemy is Bleeding, the Enhanced Basic ATK will cause Bleed to deal extra DMG for 1 time.',
    desc: 'After Luka uses his Basic ATK "Direct Punch" or Skill "Lacerating Fist," he receives #1[i] stack of Fighting Will, up to 4 stacks. When he has 2 or more stacks of Fighting Will, his Basic ATK "Direct Punch" is enhanced to "Sky-Shatter Fist." After his Enhanced Basic ATK\'s "Rising Uppercut" hits a Bleeding enemy target, the Bleed status will immediately deal DMG for 1 time equal to #2[i]% of the original DMG to the target. At the start of battle, Luka will possess 1 stack of Fighting Will.',
    params: [
      [1, 0.68],
      [1, 0.697],
      [1, 0.714],
      [1, 0.731],
      [1, 0.748],
      [1, 0.765],
      [1, 0.7863],
      [1, 0.8075],
      [1, 0.8288],
      [1, 0.85],
      [1, 0.867],
      [1, 0.884],
      [1, 0.901],
      [1, 0.918],
      [1, 0.935]
    ],
    icon: 'icon/skill/1111_talent.png'
  },
  111106: {
    id: '111106',
    name: 'Attack',
    max_level: 1,
    element: 'Physical',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1111_basic_atk.png'
  },
  111107: {
    id: '111107',
    name: 'Anticipator',
    max_level: 1,
    element: 'Physical',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, deals minor Physical DMG to a random single enemy, with a high chance to inflict Bleed to the target. Luka then gains 1 stack of Fighting Will.',
    desc: "Immediately attacks the enemy. Upon entering battle, Luka deals Physical DMG equal to #1[i]% of his ATK to a random single enemy with a #2[i]% base chance to inflict his Skill's Bleed effect on the target. Then, Luka gains 1 additional stack of Fighting Will.",
    params: [[0.5, 1]],
    icon: 'icon/skill/1111_technique.png'
  },
  111108: {
    id: '111108',
    name: 'Sky-Shatter Fist',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Consumes 2 stacks of Fighting Will to deal Physical DMG to a single enemy.',
    desc: "Consumes 2 stacks of Fighting Will. First, uses Direct Punch to deal 3 hits, with each hit dealing Physical DMG equal to #1[i]% of Luka's ATK to a single enemy target.\nThen, uses Rising Uppercut to deal 1 hit, dealing Physical DMG equal to #2[i]% of Luka's ATK to the single enemy target.",
    params: [
      [0.1, 0.4],
      [0.12, 0.48],
      [0.14, 0.56],
      [0.16, 0.64],
      [0.18, 0.72],
      [0.2, 0.8],
      [0.22, 0.88],
      [0.24, 0.96],
      [0.26, 1.04]
    ],
    icon: 'icon/skill/1111_basic_atk.png'
  },
  120101: {
    id: '120101',
    name: 'Flower Pick',
    max_level: 9,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Tosses a tile to deal minor Quantum DMG to a single enemy.',
    desc: "Tosses 1 jade tile from the suit with the fewest tiles in hand to deal Quantum DMG equal to #1[i]% of Qingque's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1201_basic_atk.png'
  },
  120102: {
    id: '120102',
    name: 'A Scoop of Moon',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      "Draw Tile, increases Qingque's DMG, and this turn does not end.",
    desc: 'Immediately draws #1[i] jade tile(s) and increases DMG by #2[i]% until the end of the current turn. This effect can stack up to #3[i] time(s). The turn will not end after this Skill is used.',
    params: [
      [2, 0.14, 4],
      [2, 0.154, 4],
      [2, 0.168, 4],
      [2, 0.182, 4],
      [2, 0.196, 4],
      [2, 0.21, 4],
      [2, 0.2275, 4],
      [2, 0.245, 4],
      [2, 0.2625, 4],
      [2, 0.28, 4],
      [2, 0.294, 4],
      [2, 0.308, 4],
      [2, 0.322, 4],
      [2, 0.336, 4],
      [2, 0.35, 4]
    ],
    icon: 'icon/skill/1201_skill.png'
  },
  120103: {
    id: '120103',
    name: 'A Quartet? Woo-hoo!',
    max_level: 15,
    element: 'Quantum',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Deals Quantum DMG to all enemies, then obtains 4 tiles of the same suit.',
    desc: "Deals Quantum DMG equal to #1[i]% of Qingque's ATK to all enemies, and obtains 4 jade tiles of the same suit.",
    params: [
      [1.2],
      [1.28],
      [1.36],
      [1.44],
      [1.52],
      [1.6],
      [1.7],
      [1.8],
      [1.9],
      [2],
      [2.08],
      [2.16],
      [2.24],
      [2.32],
      [2.4]
    ],
    icon: 'icon/skill/1201_ultimate.png'
  },
  120104: {
    id: '120104',
    name: 'Celestial Jade',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      "At the start of any ally's turn, draws a tile. At the start of their own turn, if they hold 4 tiles from the same suit, remove all tiles in possession and Enhance this Basic Attack while increasing their own ATK.",
    desc: 'When an ally\'s turn starts, Qingque randomly draws 1 tile from 3 different suits and can hold up to 4 tiles at one time.\nIf Qingque starts her turn with 4 tiles of the same suit, she consumes all tiles to enter the "Hidden Hand" state.\nWhile in this state, Qingque cannot use her Skill again. At the same time, Qingque\'s ATK increases by #1[i]%, and her Basic ATK "Flower Pick" is enhanced, becoming "Cherry on Top!" The "Hidden Hand" state ends after using "Cherry on Top!".',
    params: [
      [0.36],
      [0.396],
      [0.432],
      [0.468],
      [0.504],
      [0.54],
      [0.585],
      [0.63],
      [0.675],
      [0.72],
      [0.756],
      [0.792],
      [0.828],
      [0.864],
      [0.9]
    ],
    icon: 'icon/skill/1201_talent.png'
  },
  120106: {
    id: '120106',
    name: 'Attack',
    max_level: 1,
    element: 'Quantum',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1201_basic_atk.png'
  },
  120107: {
    id: '120107',
    name: 'Game Solitaire',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'After they use their Technique, draw tile(s) at the start of the next battle.',
    desc: 'After using Technique, Qingque draws #1[i] jade tile(s) when the battle starts.',
    params: [[2]],
    icon: 'icon/skill/1201_technique.png'
  },
  120108: {
    id: '120108',
    name: 'Cherry on Top!',
    max_level: 9,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals Quantum DMG to a single enemy and minor Quantum DMG to enemies adjacent to it.',
    desc: 'Deals Quantum DMG equal to #1[i]% of Qingque\'s ATK to a single enemy, and deals Quantum DMG equal to #2[i]% of Qingque\'s ATK to enemies adjacent to it.\n"Cherry on Top!" cannot recover Skill Points.',
    params: [
      [1.2, 0.5],
      [1.44, 0.6],
      [1.68, 0.7],
      [1.92, 0.8],
      [2.16, 0.9],
      [2.4, 1],
      [2.64, 1.1],
      [2.88, 1.2],
      [3.12, 1.3]
    ],
    icon: 'icon/skill/1201_basic_atk.png'
  },
  120201: {
    id: '120201',
    name: 'Dislodged',
    max_level: 9,
    element: 'Thunder',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Lightning DMG to a single enemy.',
    desc: 'Tingyun deals Lightning DMG equal to #1[i]% of her ATK to a single enemy.',
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1202_basic_atk.png'
  },
  120202: {
    id: '120202',
    name: 'Soothing Melody',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      'Increases the ATK of a single ally and grants them Benediction.',
    desc: "Grants a single ally with Benediction to increase their ATK by #2[i]%, up to #4[i]% of Tingyun's current ATK.\nWhen the ally with Benediction attacks, they will deal Additional Lightning DMG equal to #1[i]% of that ally's ATK for 1 time.\nBenediction lasts for #3[i] turn(s) and is only effective on the most recent receiver of Tingyun's Skill.",
    params: [
      [0.2, 0.25, 3, 0.15],
      [0.22, 0.275, 3, 0.16],
      [0.24, 0.3, 3, 0.17],
      [0.26, 0.325, 3, 0.18],
      [0.28, 0.35, 3, 0.19],
      [0.3, 0.375, 3, 0.2],
      [0.325, 0.4063, 3, 0.2125],
      [0.35, 0.4375, 3, 0.225],
      [0.375, 0.4688, 3, 0.2375],
      [0.4, 0.5, 3, 0.25],
      [0.42, 0.525, 3, 0.26],
      [0.44, 0.55, 3, 0.27],
      [0.46, 0.575, 3, 0.28],
      [0.48, 0.6, 3, 0.29],
      [0.5, 0.625, 3, 0.3]
    ],
    icon: 'icon/skill/1202_skill.png'
  },
  120203: {
    id: '120203',
    name: 'Amidst the Rejoicing Clouds',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      'Regenerates Energy for a single ally and increases their DMG dealt.',
    desc: "Regenerates #1[i] Energy for a single ally and increases the target's DMG by #3[i]% for #2[i] turn(s).",
    params: [
      [50, 2, 0.2],
      [50, 2, 0.23],
      [50, 2, 0.26],
      [50, 2, 0.29],
      [50, 2, 0.32],
      [50, 2, 0.35],
      [50, 2, 0.3875],
      [50, 2, 0.425],
      [50, 2, 0.4625],
      [50, 2, 0.5],
      [50, 2, 0.53],
      [50, 2, 0.56],
      [50, 2, 0.59],
      [50, 2, 0.62],
      [50, 2, 0.65]
    ],
    icon: 'icon/skill/1202_ultimate.png'
  },
  120204: {
    id: '120204',
    name: 'Violet Sparknado',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "When an enemy is attacked by Tingyun, the ally with Benediction immediately deals Additional Lightning DMG equal to #1[i]% of that ally's ATK to the same enemy.",
    params: [
      [0.3],
      [0.33],
      [0.36],
      [0.39],
      [0.42],
      [0.45],
      [0.4875],
      [0.525],
      [0.5625],
      [0.6],
      [0.63],
      [0.66],
      [0.69],
      [0.72],
      [0.75]
    ],
    icon: 'icon/skill/1202_talent.png'
  },
  120206: {
    id: '120206',
    name: 'Attack',
    max_level: 1,
    element: 'Thunder',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1202_basic_atk.png'
  },
  120207: {
    id: '120207',
    name: 'Gentle Breeze',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '',
    desc: 'Tingyun immediately regenerates #1[i] Energy upon using her Technique.',
    params: [[50]],
    icon: 'icon/skill/1202_technique.png'
  },
  120301: {
    id: '120301',
    name: 'Thorns of the Abyss',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Imaginary DMG to a single enemy.',
    desc: "Deals Imaginary DMG equal to #1[i]% of Luocha's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1203_basic_atk.png'
  },
  120302: {
    id: '120302',
    name: 'Prayer of Abyss Flower',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      "Restores a single ally's HP and gains 1 stack of Abyss Flower.",
    desc: "After using his Skill, Luocha immediately restores the target ally's HP equal to #1[i]% of Luocha's ATK plus #2[i]. Meanwhile, Luocha gains 1 stack of Abyss Flower.\nWhen any ally's HP percentage drops to #3[i]% or lower, an effect equivalent to Luocha's Skill will immediately be triggered and applied to this ally for one time (without consuming Skill Points). This effect can be triggered again after #4[i] turn(s).",
    params: [
      [0.4, 200, 0.5, 2],
      [0.425, 320, 0.5, 2],
      [0.45, 410, 0.5, 2],
      [0.475, 500, 0.5, 2],
      [0.5, 560, 0.5, 2],
      [0.52, 620, 0.5, 2],
      [0.54, 665, 0.5, 2],
      [0.56, 710, 0.5, 2],
      [0.58, 755, 0.5, 2],
      [0.6, 800, 0.5, 2],
      [0.62, 845, 0.5, 2],
      [0.64, 890, 0.5, 2],
      [0.66, 935, 0.5, 2],
      [0.68, 980, 0.5, 2],
      [0.7, 1025, 0.5, 2]
    ],
    icon: 'icon/skill/1203_skill.png'
  },
  120303: {
    id: '120303',
    name: 'Death Wish',
    max_level: 15,
    element: 'Imaginary',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Removes 1 buff from all enemies, deals Imaginary DMG to all enemies, and gains 1 stack of Abyss Flower.',
    desc: "Removes #2[i] buff(s) from all enemies and deals all enemies Imaginary DMG equal to #1[i]% of Luocha's ATK. At the same time, Luocha gains 1 stack of Abyss Flower.",
    params: [
      [1.2, 1],
      [1.28, 1],
      [1.36, 1],
      [1.44, 1],
      [1.52, 1],
      [1.6, 1],
      [1.7, 1],
      [1.8, 1],
      [1.9, 1],
      [2, 1],
      [2.08, 1],
      [2.16, 1],
      [2.24, 1],
      [2.32, 1],
      [2.4, 1]
    ],
    icon: 'icon/skill/1203_ultimate.png'
  },
  120304: {
    id: '120304',
    name: 'Cycle of Life',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      'Deploys a Field when Abyss Flower reaches 2 stacks. While the Field is active, allies will restore HP after they attack.',
    desc: "When Abyss Flower reaches #1[i] stacks, Luocha consumes all stacks of Abyss Flower to deploy a Field against the enemy.\nWhen any enemy in the Field is attacked by an ally, the attacking ally's HP is immediately restored by an amount equal to #2[i]% of Luocha's ATK plus #4[i].\nThe Field's effect lasts for #3[i] turns. When Luocha is knocked down, the Field will be dispelled.",
    params: [
      [2, 0.12, 2, 60],
      [2, 0.1275, 2, 96],
      [2, 0.135, 2, 123],
      [2, 0.1425, 2, 150],
      [2, 0.15, 2, 168],
      [2, 0.156, 2, 186],
      [2, 0.162, 2, 199.5],
      [2, 0.168, 2, 213],
      [2, 0.174, 2, 226.5],
      [2, 0.18, 2, 240],
      [2, 0.186, 2, 253.5],
      [2, 0.192, 2, 267],
      [2, 0.198, 2, 280.5],
      [2, 0.204, 2, 294],
      [2, 0.21, 2, 307.5]
    ],
    icon: 'icon/skill/1203_talent.png'
  },
  120306: {
    id: '120306',
    name: 'Attack',
    max_level: 1,
    element: 'Imaginary',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1203_basic_atk.png'
  },
  120307: {
    id: '120307',
    name: 'Mercy of a Fool',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      'After the Technique is used, immediately trigger the effect of the Talent at the start of the next battle.',
    desc: 'After the Technique is used, the Talent will be immediately triggered at the start of the next battle.',
    params: [[50]],
    icon: 'icon/skill/1203_technique.png'
  },
  120401: {
    id: '120401',
    name: 'Glistening Light',
    max_level: 9,
    element: 'Thunder',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Lightning DMG to a single enemy.',
    desc: 'Jing Yuan deals Lightning DMG equal to #1[i]% of his ATK to a single enemy.',
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1204_basic_atk.png'
  },
  120402: {
    id: '120402',
    name: 'Rifting Zenith',
    max_level: 15,
    element: 'Thunder',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      "Deals minor Lightning DMG to all enemies and increases Lightning-Lord's Hits Per Action.",
    desc: "Deals Lightning DMG equal to #1[i]% of Jing Yuan's ATK to all enemies and increases Lightning-Lord's Hits Per Action by #2[i] for the next turn.",
    params: [
      [0.5, 2],
      [0.55, 2],
      [0.6, 2],
      [0.65, 2],
      [0.7, 2],
      [0.75, 2],
      [0.8125, 2],
      [0.875, 2],
      [0.9375, 2],
      [1, 2],
      [1.05, 2],
      [1.1, 2],
      [1.15, 2],
      [1.2, 2],
      [1.25, 2]
    ],
    icon: 'icon/skill/1204_skill.png'
  },
  120403: {
    id: '120403',
    name: 'Lightbringer',
    max_level: 15,
    element: 'Thunder',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      "Deals Lightning DMG to all enemies and increases Lightning-Lord's Hits Per Action.",
    desc: "Deals Lightning DMG equal to #1[i]% of Jing Yuan's ATK to all enemies and increases Lightning-Lord's Hits Per Action by #2[i] for the next turn.",
    params: [
      [1.2, 3],
      [1.28, 3],
      [1.36, 3],
      [1.44, 3],
      [1.52, 3],
      [1.6, 3],
      [1.7, 3],
      [1.8, 3],
      [1.9, 3],
      [2, 3],
      [2.08, 3],
      [2.16, 3],
      [2.24, 3],
      [2.32, 3],
      [2.4, 3]
    ],
    icon: 'icon/skill/1204_ultimate.png'
  },
  120404: {
    id: '120404',
    name: 'Prana Extirpated',
    max_level: 15,
    element: 'Thunder',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Bounce',
    effect_text: 'Bounce',
    simple_desc: '',
    desc: "Summons Lightning-Lord at the start of the battle. Lightning-Lord has #1[i] base SPD and #4[i] base Hits Per Action. When the Lightning-Lord takes action, its hits are considered as follow-up attacks, with each hit dealing Lightning DMG equal to #2[i]% of Jing Yuan's ATK to a random single enemy, and enemies adjacent to it also receive Lightning DMG equal to #5[i]% of the DMG dealt to the target enemy.\nThe Lightning-Lord's Hits Per Action can reach a max of #6[i]. Every time Lightning-Lord's Hits Per Action increases by 1, its SPD increases by #3[i]. After the Lightning-Lord's action ends, its SPD and Hits Per Action return to their base values.\nWhen Jing Yuan is knocked down, the Lightning-Lord will disappear.\nWhen Jing Yuan is affected by Crowd Control debuff, the Lightning-Lord is unable to take action.",
    params: [
      [60, 0.33, 10, 3, 0.25, 10],
      [60, 0.363, 10, 3, 0.25, 10],
      [60, 0.396, 10, 3, 0.25, 10],
      [60, 0.429, 10, 3, 0.25, 10],
      [60, 0.462, 10, 3, 0.25, 10],
      [60, 0.495, 10, 3, 0.25, 10],
      [60, 0.5363, 10, 3, 0.25, 10],
      [60, 0.5775, 10, 3, 0.25, 10],
      [60, 0.6188, 10, 3, 0.25, 10],
      [60, 0.66, 10, 3, 0.25, 10],
      [60, 0.693, 10, 3, 0.25, 10],
      [60, 0.726, 10, 3, 0.25, 10],
      [60, 0.759, 10, 3, 0.25, 10],
      [60, 0.792, 10, 3, 0.25, 10],
      [60, 0.825, 10, 3, 0.25, 10]
    ],
    icon: 'icon/skill/1204_talent.png'
  },
  120406: {
    id: '120406',
    name: 'Attack',
    max_level: 1,
    element: 'Thunder',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1204_basic_atk.png'
  },
  120407: {
    id: '120407',
    name: 'Spirit Invocation',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "After the Technique is used, the Lightning-Lord's Hits Per Action in the first turn increases by #1[i] at the start of the next battle.",
    params: [[3]],
    icon: 'icon/skill/1204_technique.png'
  },
  120501: {
    id: '120501',
    name: 'Shard Sword',
    max_level: 9,
    element: 'Wind',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Wind DMG to an enemy.',
    desc: "Deals #1[i]% of Blade's ATK as Wind DMG to a target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1205_basic_atk.png'
  },
  120502: {
    id: '120502',
    name: 'Hellscape',
    max_level: 15,
    element: 'Wind',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'Consumes HP to Enhance Basic ATK, and this turn does not end after this Skill is used.',
    desc: "Consumes HP equal to #1[i]% of Blade's Max HP to enter the Hellscape state.\nWhen Hellscape is active, his Skill cannot be used, his DMG dealt increases by #4[i]%, and his Basic ATK Shard Sword is enhanced to Forest of Swords for #2[i] turn(s).\nIf Blade's current HP is insufficient, his HP will be reduced to 1 when he uses his Skill.\nThis Skill does not regenerate Energy. Using this Skill does not end the current turn.",
    params: [
      [0.3, 3, 1, 0.12],
      [0.3, 3, 1, 0.148],
      [0.3, 3, 1, 0.176],
      [0.3, 3, 1, 0.204],
      [0.3, 3, 1, 0.232],
      [0.3, 3, 1, 0.26],
      [0.3, 3, 1, 0.295],
      [0.3, 3, 1, 0.33],
      [0.3, 3, 1, 0.365],
      [0.3, 3, 1, 0.4],
      [0.3, 3, 1, 0.428],
      [0.3, 3, 1, 0.456],
      [0.3, 3, 1, 0.484],
      [0.3, 3, 1, 0.512],
      [0.3, 3, 1, 0.54]
    ],
    icon: 'icon/skill/1205_skill.png'
  },
  120503: {
    id: '120503',
    name: 'Death Sentence',
    max_level: 15,
    element: 'Wind',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Sets current HP to 50% of Max HP, and deals massive Wind DMG to a single enemy and Wind DMG to adjacent targets.',
    desc: "Sets Blade's current HP to 50% of his Max HP and deals Wind DMG to a single enemy equal to the sum of #1[i]% of his ATK, #2[i]% of his Max HP, and #5[i]% of the tally of Blade's HP loss in the current battle. At the same time, deals Wind DMG to adjacent targets equal to the sum of #3[i]% of his ATK, #4[i]% of his Max HP, and #6[i]% of the tally of his HP loss in the current battle.\nThe tally of Blade's HP loss in the current battle is capped at #7[i]% of his Max HP. This value will be reset and re-accumulated after his Ultimate has been used.",
    params: [
      [0.24, 0.6, 0.096, 0.24, 0.6, 0.24, 0.9],
      [0.256, 0.64, 0.1024, 0.256, 0.64, 0.256, 0.9],
      [0.272, 0.68, 0.1088, 0.272, 0.68, 0.272, 0.9],
      [0.288, 0.72, 0.1152, 0.288, 0.72, 0.288, 0.9],
      [0.304, 0.76, 0.1216, 0.304, 0.76, 0.304, 0.9],
      [0.32, 0.8, 0.128, 0.32, 0.8, 0.32, 0.9],
      [0.34, 0.85, 0.136, 0.34, 0.85, 0.34, 0.9],
      [0.36, 0.9, 0.144, 0.36, 0.9, 0.36, 0.9],
      [0.38, 0.95, 0.152, 0.38, 0.95, 0.38, 0.9],
      [0.4, 1, 0.16, 0.4, 1, 0.4, 0.9],
      [0.416, 1.04, 0.1664, 0.416, 1.04, 0.416, 0.9],
      [0.432, 1.08, 0.1728, 0.432, 1.08, 0.432, 0.9],
      [0.448, 1.12, 0.1792, 0.448, 1.12, 0.448, 0.9],
      [0.464, 1.16, 0.1856, 0.464, 1.16, 0.464, 0.9],
      [0.48, 1.2, 0.192, 0.48, 1.2, 0.48, 0.9]
    ],
    icon: 'icon/skill/1205_ultimate.png'
  },
  120504: {
    id: '120504',
    name: "Shuhu's Gift",
    max_level: 15,
    element: 'Wind',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      "When Blade's HP is lowered, he gains 1 stack of Charge. When maximum Charge stack is reached, Blade immediately deals Wind DMG to all enemies and restores HP. Then, all Charges are consumed.",
    desc: "When Blade sustains DMG or consumes his HP, he gains 1 stack of Charge, stacking up to 5 times. A max of 1 Charge stack can be gained every time he is attacked.\nWhen Charge stack reaches maximum, immediately launches a follow-up attack on all enemies, dealing Wind DMG equal to #2[i]% of Blade's ATK plus #4[i]% of his Max HP. At the same time, restores Blade's HP by #3[i]% of his Max HP. After the follow-up attack, all Charges are consumed.",
    params: [
      [3, 0.22, 0.25, 0.55],
      [3, 0.242, 0.25, 0.605],
      [3, 0.264, 0.25, 0.66],
      [3, 0.286, 0.25, 0.715],
      [3, 0.308, 0.25, 0.77],
      [3, 0.33, 0.25, 0.825],
      [3, 0.3575, 0.25, 0.8938],
      [3, 0.385, 0.25, 0.9625],
      [3, 0.4125, 0.25, 1.0313],
      [3, 0.44, 0.25, 1.1],
      [3, 0.462, 0.25, 1.155],
      [3, 0.484, 0.25, 1.21],
      [3, 0.506, 0.25, 1.265],
      [3, 0.528, 0.25, 1.32],
      [3, 0.55, 0.25, 1.375]
    ],
    icon: 'icon/skill/1205_talent.png'
  },
  120506: {
    id: '120506',
    name: 'Attack',
    max_level: 1,
    element: 'Wind',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1205_basic_atk.png'
  },
  120507: {
    id: '120507',
    name: 'Karma Wind',
    max_level: 1,
    element: 'Wind',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering combat, consumes own HP and deals Wind DMG to all enemies.',
    desc: "Immediately attacks the enemy. After entering combat, consumes #2[i]% of Blade's Max HP while dealing Wind DMG equal to #1[i]% of his Max HP to all enemies.\nIf Blade's current HP is insufficient, his HP will be reduced to 1 when this Technique is used.",
    params: [[0.4, 0.2]],
    icon: 'icon/skill/1205_technique.png'
  },
  120508: {
    id: '120508',
    name: 'Forest of Swords',
    max_level: 9,
    element: 'Wind',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Consumes HP and deals Wind DMG to an enemy, as well as minor Wind DMG to adjacent targets.',
    desc: "Consumes HP equal to #1[i]% of Blade's Max HP and deals Wind DMG equal to the sum of #2[i]% of his ATK and #4[i]% of his Max HP to a single enemy. In addition, deals Wind DMG equal to the sum of #3[i]% of Blade's ATK and #5[i]% of his Max HP to adjacent targets.\nIf Blade's current HP is insufficient, his HP will be reduced to 1 when using Forest of Swords.\nForest of Swords cannot regenerate Skill Points.",
    params: [
      [0.1, 0.2, 0.08, 0.5, 0.2],
      [0.1, 0.24, 0.096, 0.6, 0.24],
      [0.1, 0.28, 0.112, 0.7, 0.28],
      [0.1, 0.32, 0.128, 0.8, 0.32],
      [0.1, 0.36, 0.144, 0.9, 0.36],
      [0.1, 0.4, 0.16, 1, 0.4],
      [0.1, 0.44, 0.176, 1.1, 0.44],
      [0.1, 0.48, 0.192, 1.2, 0.48],
      [0.1, 0.52, 0.208, 1.3, 0.52]
    ],
    icon: 'icon/skill/1205_basic_atk.png'
  },
  120601: {
    id: '120601',
    name: 'Cloudfencer Art: Starshine',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Physical DMG to a single enemy.',
    desc: "Deals Physical DMG equal to #1[i]% of Sushang's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1206_basic_atk.png'
  },
  120602: {
    id: '120602',
    name: 'Cloudfencer Art: Mountainfall',
    max_level: 15,
    element: 'Physical',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Deals Physical DMG to a single enemy with a small chance of triggering Sword Stance. If the enemy has Weakness Break, Sword Stance is guaranteed to trigger.',
    desc: "Deals Physical DMG equal to #1[i]% of Sushang's ATK to a single enemy. In addition, there is a #3[i]% chance to trigger Sword Stance on the final hit, dealing Additional Physical DMG equal to #2[i]% of Sushang's ATK to the enemy.\nIf the enemy is inflicted with Weakness Break, Sword Stance is guaranteed to trigger.",
    params: [
      [1.05, 0.5, 0.33],
      [1.155, 0.55, 0.33],
      [1.26, 0.6, 0.33],
      [1.365, 0.65, 0.33],
      [1.47, 0.7, 0.33],
      [1.575, 0.75, 0.33],
      [1.7063, 0.8125, 0.33],
      [1.8375, 0.875, 0.33],
      [1.9688, 0.9375, 0.33],
      [2.1, 1, 0.33],
      [2.205, 1.05, 0.33],
      [2.31, 1.1, 0.33],
      [2.415, 1.15, 0.33],
      [2.52, 1.2, 0.33],
      [2.625, 1.25, 0.33]
    ],
    icon: 'icon/skill/1206_skill.png'
  },
  120603: {
    id: '120603',
    name: 'Shape of Taixu: Dawn Herald',
    max_level: 15,
    element: 'Physical',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      "Deals massive Physical DMG to a single enemy, enhances Sword Stance's effect, and takes action immediately.",
    desc: "Deals Physical DMG equal to #1[i]% of Sushang's ATK to a single enemy target, and she immediately takes action again. In addition, Sushang's ATK increases by #4[i]% and using her Skill has 2 extra chances to trigger Sword Stance for #2[i] turn(s).\nSword Stance triggered from the extra chances deals #3[i]% of the original DMG.",
    params: [
      [1.92, 2, 0.5, 0.18],
      [2.048, 2, 0.5, 0.192],
      [2.176, 2, 0.5, 0.204],
      [2.304, 2, 0.5, 0.216],
      [2.432, 2, 0.5, 0.228],
      [2.56, 2, 0.5, 0.24],
      [2.72, 2, 0.5, 0.255],
      [2.88, 2, 0.5, 0.27],
      [3.04, 2, 0.5, 0.285],
      [3.2, 2, 0.5, 0.3],
      [3.328, 2, 0.5, 0.312],
      [3.456, 2, 0.5, 0.324],
      [3.584, 2, 0.5, 0.336],
      [3.712, 2, 0.5, 0.348],
      [3.84, 2, 0.5, 0.36]
    ],
    icon: 'icon/skill/1206_ultimate.png'
  },
  120604: {
    id: '120604',
    name: 'Dancing Blade',
    max_level: 15,
    element: 'Physical',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      "When an enemy on the field has its Weakness Broken, this character's SPD increases.",
    desc: "When an enemy has their Weakness Broken on the field, Sushang's SPD increases by #1[i]% for #2[i] turn(s).",
    params: [
      [0.15, 2],
      [0.155, 2],
      [0.16, 2],
      [0.165, 2],
      [0.17, 2],
      [0.175, 2],
      [0.1813, 2],
      [0.1875, 2],
      [0.1938, 2],
      [0.2, 2],
      [0.205, 2],
      [0.21, 2],
      [0.215, 2],
      [0.22, 2],
      [0.225, 2]
    ],
    icon: 'icon/skill/1206_talent.png'
  },
  120606: {
    id: '120606',
    name: 'Attack',
    max_level: 1,
    element: 'Physical',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1206_basic_atk.png'
  },
  120607: {
    id: '120607',
    name: 'Cloudfencer Art: Warcry',
    max_level: 1,
    element: 'Physical',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, deals minor Physical DMG to all enemies.',
    desc: 'Immediately attacks the enemy. Upon entering battle, Sushang deals Physical DMG equal to #1[i]% of her ATK to all enemies.',
    params: [[0.8]],
    icon: 'icon/skill/1206_technique.png'
  },
  120701: {
    id: '120701',
    name: 'Arrowslinger',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Imaginary DMG to an enemy.',
    desc: "Deals #1[i]% of Yukong's ATK as Imaginary DMG to a target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1207_basic_atk.png'
  },
  120702: {
    id: '120702',
    name: 'Emboldening Salvo',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      "Obtains 2 stacks of Roaring Bowstrings. All allies' ATK increases when Roaring Bowstrings is active on this character.",
    desc: 'Obtains #1[i] stack(s) of "Roaring Bowstrings" (to a maximum of 2 stacks). When "Roaring Bowstrings" is active, the ATK of all allies increases by #2[i]%, and every time an ally\'s turn (including Yukong\'s) ends, Yukong loses 1 stack of "Roaring Bowstrings."\nWhen it\'s the turn where Yukong gains "Roaring Bowstrings" by using Skill, "Roaring Bowstrings" will not be removed.',
    params: [
      [2, 0.4],
      [2, 0.44],
      [2, 0.48],
      [2, 0.52],
      [2, 0.56],
      [2, 0.6],
      [2, 0.65],
      [2, 0.7],
      [2, 0.75],
      [2, 0.8],
      [2, 0.84],
      [2, 0.88],
      [2, 0.92],
      [2, 0.96],
      [2, 1]
    ],
    icon: 'icon/skill/1207_skill.png'
  },
  120703: {
    id: '120703',
    name: 'Diving Kestrel',
    max_level: 15,
    element: 'Imaginary',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'When Roaring Bowstrings is active on this character, increases the CRIT Rate and CRIT DMG of all allies and deals massive Imaginary DMG to a single enemy.',
    desc: 'If "Roaring Bowstrings" is active on Yukong when her Ultimate is used, additionally increases all allies\' CRIT Rate by #2[i]% and CRIT DMG by #3[i]%. At the same time, deals Imaginary DMG equal to #1[i]% of Yukong\'s ATK to a single enemy.',
    params: [
      [2.28, 0.21, 0.39],
      [2.432, 0.217, 0.416],
      [2.584, 0.224, 0.442],
      [2.736, 0.231, 0.468],
      [2.888, 0.238, 0.494],
      [3.04, 0.245, 0.52],
      [3.23, 0.2538, 0.5525],
      [3.42, 0.2625, 0.585],
      [3.61, 0.2713, 0.6175],
      [3.8, 0.28, 0.65],
      [3.952, 0.287, 0.676],
      [4.104, 0.294, 0.702],
      [4.256, 0.301, 0.728],
      [4.408, 0.308, 0.754],
      [4.56, 0.315, 0.78]
    ],
    icon: 'icon/skill/1207_ultimate.png'
  },
  120704: {
    id: '120704',
    name: 'Seven Layers, One Arrow',
    max_level: 15,
    element: 'Imaginary',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'Basic Attack additionally deals minor DMG, and the Toughness-Reducing DMG of this Basic Attack is increased. This effect can be triggered again after 1 turn have passed.',
    desc: "Basic ATK additionally deals Imaginary DMG equal to #1[i]% of Yukong's ATK, and increases the Toughness-Reducing DMG of this attack by #2[i]%. This effect can be triggered again after #3[i] turn(s).",
    params: [
      [0.4, 1, 1],
      [0.44, 1, 1],
      [0.48, 1, 1],
      [0.52, 1, 1],
      [0.56, 1, 1],
      [0.6, 1, 1],
      [0.65, 1, 1],
      [0.7, 1, 1],
      [0.75, 1, 1],
      [0.8, 1, 1],
      [0.84, 1, 1],
      [0.88, 1, 1],
      [0.92, 1, 1],
      [0.96, 1, 1],
      [1, 1, 1]
    ],
    icon: 'icon/skill/1207_talent.png'
  },
  120706: {
    id: '120706',
    name: 'Attack',
    max_level: 1,
    element: 'Imaginary',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1207_basic_atk.png'
  },
  120707: {
    id: '120707',
    name: 'Chasing the Wind',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'Increases Movement Speed. After attacking an enemy and entering battle, receive 2 stacks of Roaring Bowstrings.',
    desc: 'After using her Technique, Yukong enters Sprint mode for #1[i] seconds. In Sprint mode, her Movement SPD increases by #2[i]%, and Yukong gains #3[i] stack(s) of "Roaring Bowstrings" when she enters battle by attacking enemies.',
    params: [[20, 0.35, 2]],
    icon: 'icon/skill/1207_technique.png'
  },
  120801: {
    id: '120801',
    name: 'Novaburst',
    max_level: 9,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Quantum DMG to a single enemy.',
    desc: "Deals Quantum DMG equal to #1[i]% of Fu Xuan's Max HP to a single enemy.",
    params: [
      [0.25],
      [0.3],
      [0.35],
      [0.4],
      [0.45],
      [0.5],
      [0.55],
      [0.6],
      [0.65]
    ],
    icon: 'icon/skill/1208_basic_atk.png'
  },
  120802: {
    id: '120802',
    name: 'Known by Stars, Shown by Hearts',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Defence',
    effect_text: 'Defense',
    simple_desc:
      "Activates Matrix of Prescience. DMG received by Fu Xuan's allies are Distributed to her. Also increases CRIT Rate and Max HP of all allies.",
    desc: "Activates Matrix of Prescience, via which other team members will Distribute #1[i]% of the DMG they receive (before this DMG is mitigated by any Shields) to Fu Xuan for #3[i] turn(s).\nWhile affected by Matrix of Prescience, all team members gain the Knowledge effect, which increases their respective Max HP by #4[i]% of Fu Xuan's Max HP, and increases CRIT Rate by #5[i]%.\nWhen Fu Xuan is knocked down, the Matrix of Prescience will be dispelled.",
    params: [
      [0.65, 0, 3, 0.03, 0.06],
      [0.65, 0, 3, 0.033, 0.066],
      [0.65, 0, 3, 0.036, 0.072],
      [0.65, 0, 3, 0.039, 0.078],
      [0.65, 0, 3, 0.042, 0.084],
      [0.65, 0, 3, 0.045, 0.09],
      [0.65, 0, 3, 0.0488, 0.0975],
      [0.65, 0, 3, 0.0525, 0.105],
      [0.65, 0, 3, 0.0563, 0.1125],
      [0.65, 0, 3, 0.06, 0.12],
      [0.65, 0, 3, 0.063, 0.126],
      [0.65, 0, 3, 0.066, 0.132],
      [0.65, 0, 3, 0.069, 0.138],
      [0.65, 0, 3, 0.072, 0.144],
      [0.65, 0, 3, 0.075, 0.15]
    ],
    icon: 'icon/skill/1208_skill.png'
  },
  120803: {
    id: '120803',
    name: 'Woes of Many Morphed to One',
    max_level: 15,
    element: 'Quantum',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      "Deals Quantum DMG to all enemies and increases Fu Xuan's Talent trigger count.",
    desc: "Deals Quantum DMG equal to #1[i]% of Fu Xuan's Max HP to all enemies and obtains 1 trigger count for the HP Restore effect granted by Fu Xuan's Talent.",
    params: [
      [0.6],
      [0.64],
      [0.68],
      [0.72],
      [0.76],
      [0.8],
      [0.85],
      [0.9],
      [0.95],
      [1],
      [1.04],
      [1.08],
      [1.12],
      [1.16],
      [1.2]
    ],
    icon: 'icon/skill/1208_ultimate.png'
  },
  120804: {
    id: '120804',
    name: 'Bleak Breeds Bliss',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      'While Fu Xuan is still active in battle, the DMG taken by all team members is reduced.\nWhen her HP is low, automatically restores her own HP based on the percentage of HP already lost. This effect can have up to 2 trigger counts at any given time.',
    desc: "While Fu Xuan is still active in battle, Misfortune Avoidance is applied to the entire team. With Misfortune Avoidance, allies take #1[i]% less DMG.\nWhen Fu Xuan's current HP falls to #2[i]% of her Max HP or less, HP Restore will be triggered for Fu Xuan, restoring her HP by #3[i]% of the amount of HP she is currently missing. This effect cannot be triggered if she receives a killing blow. This effect possesses 1 trigger count by default and can have a maximum of 2 trigger counts.",
    params: [
      [0.1, 0.5, 0.8],
      [0.108, 0.5, 0.81],
      [0.116, 0.5, 0.82],
      [0.124, 0.5, 0.83],
      [0.132, 0.5, 0.84],
      [0.14, 0.5, 0.85],
      [0.15, 0.5, 0.8625],
      [0.16, 0.5, 0.875],
      [0.17, 0.5, 0.8875],
      [0.18, 0.5, 0.9],
      [0.188, 0.5, 0.91],
      [0.196, 0.5, 0.92],
      [0.204, 0.5, 0.93],
      [0.212, 0.5, 0.94],
      [0.22, 0.5, 0.95]
    ],
    icon: 'icon/skill/1208_talent.png'
  },
  120806: {
    id: '120806',
    name: 'Attack',
    max_level: 1,
    element: 'Quantum',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1208_basic_atk.png'
  },
  120807: {
    id: '120807',
    name: 'Of Fortune Comes Fate',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Defence',
    effect_text: 'Defense',
    simple_desc:
      'Activates a Barrier. Allies will not enter battle when attacked by enemies. Entering battle will automatically activate Matrix of Prescience.',
    desc: 'After the Technique is used, all team members receive a Barrier, lasting for #1[i] seconds. This Barrier can block all enemy attacks, and the team will not enter battle when attacked. Entering battle while the Barrier is active will have Fu Xuan automatically activate Matrix of Prescience at the start of the battle, lasting for #2[i] turn(s).',
    params: [[20, 2]],
    icon: 'icon/skill/1208_technique.png'
  },
  120901: {
    id: '120901',
    name: 'Frost Thorn',
    max_level: 9,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Ice DMG to a single enemy.',
    desc: "Deals Ice DMG equal to #1[i]% of Yanqing's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1209_basic_atk.png'
  },
  120902: {
    id: '120902',
    name: 'Darting Ironthorn',
    max_level: 15,
    element: 'Ice',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Deals Ice DMG to a single enemy and activates the Soulsteel Sync.',
    desc: "Deals Ice DMG equal to #1[i]% of Yanqing's ATK to a single enemy and activates Soulsteel Sync for 1 turn.",
    params: [
      [1.1],
      [1.21],
      [1.32],
      [1.43],
      [1.54],
      [1.65],
      [1.7875],
      [1.925],
      [2.0625],
      [2.2],
      [2.31],
      [2.42],
      [2.53],
      [2.64],
      [2.75]
    ],
    icon: 'icon/skill/1209_skill.png'
  },
  120903: {
    id: '120903',
    name: 'Amidst the Raining Bliss',
    max_level: 15,
    element: 'Ice',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Increases Yanqing\'s CRIT Rate. Enhances "Soulsteel Sync" and deals massive Ice DMG to a single enemy.',
    desc: "Increases Yanqing's CRIT Rate by #1[i]%. When Soulsteel Sync is active, increases Yanqing's CRIT DMG by an extra #2[i]%. This buff lasts for one turn. Afterwards, deals Ice DMG equal to #3[i]% of Yanqing's ATK to a single enemy.",
    params: [
      [0.6, 0.3, 2.1],
      [0.6, 0.32, 2.24],
      [0.6, 0.34, 2.38],
      [0.6, 0.36, 2.52],
      [0.6, 0.38, 2.66],
      [0.6, 0.4, 2.8],
      [0.6, 0.425, 2.975],
      [0.6, 0.45, 3.15],
      [0.6, 0.475, 3.325],
      [0.6, 0.5, 3.5],
      [0.6, 0.52, 3.64],
      [0.6, 0.54, 3.78],
      [0.6, 0.56, 3.92],
      [0.6, 0.58, 4.06],
      [0.6, 0.6, 4.2]
    ],
    icon: 'icon/skill/1209_ultimate.png'
  },
  120904: {
    id: '120904',
    name: 'One With the Sword',
    max_level: 15,
    element: 'Ice',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'During Soulsteel Sync, reduces the chance of this character being attacked and increases their CRIT Rate and CRIT DMG. After attacking an enemy, there is a chance of launching a follow-up attack, dealing Ice DMG with a chance to Freeze the target.\nSoulsteel Sync will be removed after this character receives damage.',
    desc: "When Soulsteel Sync is active, Yanqing is less likely to be attacked by enemies. Yanqing's CRIT Rate increases by #1[i]% and his CRIT DMG increases by #2[i]%. After Yanqing attacks an enemy, there is a #3[i]% fixed chance to perform a follow-up attack, dealing Ice DMG equal to #4[i]% of Yanqing's ATK to the enemy, which has a #6[i]% base chance to Freeze the enemy for 1 turn.\nThe Frozen target cannot take action and receives Additional Ice DMG equal to #5[i]% of Yanqing's ATK at the beginning of each turn.\nWhen Yanqing receives DMG, the Soulsteel Sync effect will disappear.",
    params: [
      [0.15, 0.15, 0.5, 0.25, 0.25, 0.65],
      [0.155, 0.165, 0.51, 0.275, 0.275, 0.65],
      [0.16, 0.18, 0.52, 0.3, 0.3, 0.65],
      [0.165, 0.195, 0.53, 0.325, 0.325, 0.65],
      [0.17, 0.21, 0.54, 0.35, 0.35, 0.65],
      [0.175, 0.225, 0.55, 0.375, 0.375, 0.65],
      [0.1813, 0.2438, 0.5625, 0.4063, 0.4063, 0.65],
      [0.1875, 0.2625, 0.575, 0.4375, 0.4375, 0.65],
      [0.1938, 0.2813, 0.5875, 0.4688, 0.4688, 0.65],
      [0.2, 0.3, 0.6, 0.5, 0.5, 0.65],
      [0.205, 0.315, 0.61, 0.525, 0.525, 0.65],
      [0.21, 0.33, 0.62, 0.55, 0.55, 0.65],
      [0.215, 0.345, 0.63, 0.575, 0.575, 0.65],
      [0.22, 0.36, 0.64, 0.6, 0.6, 0.65],
      [0.225, 0.375, 0.65, 0.625, 0.625, 0.65]
    ],
    icon: 'icon/skill/1209_talent.png'
  },
  120906: {
    id: '120906',
    name: 'Attack',
    max_level: 1,
    element: 'Ice',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1209_basic_atk.png'
  },
  120907: {
    id: '120907',
    name: 'The One True Sword',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'After this character uses Technique, at the start of the next battle, increases the DMG dealt by this character to enemy targets whose HP is 50% or higher.',
    desc: 'After using his Technique, at the start of the next battle, Yanqing deals #2[i]% more DMG for #3[i] turn(s) to enemies whose current HP is #1[i]% or higher.',
    params: [[0.5, 0.3, 2]],
    icon: 'icon/skill/1209_technique.png'
  },
  121101: {
    id: '121101',
    name: 'Diagnostic Kick',
    max_level: 9,
    element: 'Thunder',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Lightning DMG to a single enemy.',
    desc: "Deals Lightning DMG equal to #1[i]% of Bailu's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1211_basic_atk.png'
  },
  121102: {
    id: '121102',
    name: 'Singing Among Clouds',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc: 'Restores HP for a single ally, then heals random allies.',
    desc: "Heals a single ally for #1[i]% of Bailu's Max HP plus #2[i]. Bailu then heals random allies #4[i] time(s). After each healing, HP restored from the next healing is reduced by #3[i]%.",
    params: [
      [0.078, 78, 0.15, 2],
      [0.0829, 124.8, 0.15, 2],
      [0.0878, 159.9, 0.15, 2],
      [0.0926, 195, 0.15, 2],
      [0.0975, 218.4, 0.15, 2],
      [0.1014, 241.8, 0.15, 2],
      [0.1053, 259.35, 0.15, 2],
      [0.1092, 276.9, 0.15, 2],
      [0.1131, 294.45, 0.15, 2],
      [0.117, 312, 0.15, 2],
      [0.1209, 329.55, 0.15, 2],
      [0.1248, 347.1, 0.15, 2],
      [0.1287, 364.65, 0.15, 2],
      [0.1326, 382.2, 0.15, 2],
      [0.1365, 399.75, 0.15, 2]
    ],
    icon: 'icon/skill/1211_skill.png'
  },
  121103: {
    id: '121103',
    name: 'Felicitous Thunderleap',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      'Restores HP for all allies, and grants them Invigoration, or prolongs the duration of their Invigoration.',
    desc: "Heals all allies for #1[i]% of Bailu's Max HP plus #2[i].\nBailu applies Invigoration to allies that are not already Invigorated. For those already Invigorated, Bailu extends the duration of their Invigoration by 1 turn.\nThe effect of Invigoration can last for #3[i] turn(s). This effect cannot stack.",
    params: [
      [0.09, 90, 2],
      [0.0956, 144, 2],
      [0.1013, 184.5, 2],
      [0.1069, 225, 2],
      [0.1125, 252, 2],
      [0.117, 279, 2],
      [0.1215, 299.25, 2],
      [0.126, 319.5, 2],
      [0.1305, 339.75, 2],
      [0.135, 360, 2],
      [0.1395, 380.25, 2],
      [0.144, 400.5, 2],
      [0.1485, 420.75, 2],
      [0.153, 441, 2],
      [0.1575, 461.25, 2]
    ],
    icon: 'icon/skill/1211_ultimate.png'
  },
  121104: {
    id: '121104',
    name: 'Gourdful of Elixir',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      'When an ally with Invigoration is attacked, restores HP for the ally.\nWhen an ally suffers a killing blow, Bailu immediately restores their HP. This effect can only trigger 1 time per battle.',
    desc: "After an ally with Invigoration is hit, restores the ally's HP for #1[i]% of Bailu's Max HP plus #2[i]. This effect can trigger #5[i] time(s).\nWhen an ally receives a killing blow, they will not be knocked down. Bailu immediately heals the ally for #3[i]% of Bailu's Max HP plus #4[i] HP. This effect can be triggered 1 time per battle.",
    params: [
      [0.036, 36, 0.12, 120, 2],
      [0.0382, 57.6, 0.1275, 192, 2],
      [0.0405, 73.8, 0.135, 246, 2],
      [0.0428, 90, 0.1425, 300, 2],
      [0.045, 100.8, 0.15, 336, 2],
      [0.0468, 111.6, 0.156, 372, 2],
      [0.0486, 119.7, 0.162, 399, 2],
      [0.0504, 127.8, 0.168, 426, 2],
      [0.0522, 135.9, 0.174, 453, 2],
      [0.054, 144, 0.18, 480, 2],
      [0.0558, 152.1, 0.186, 507, 2],
      [0.0576, 160.2, 0.192, 534, 2],
      [0.0594, 168.3, 0.198, 561, 2],
      [0.0612, 176.4, 0.204, 588, 2],
      [0.063, 184.5, 0.21, 615, 2]
    ],
    icon: 'icon/skill/1211_talent.png'
  },
  121106: {
    id: '121106',
    name: 'Attack',
    max_level: 1,
    element: 'Thunder',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1211_basic_atk.png'
  },
  121107: {
    id: '121107',
    name: 'Saunter in the Rain',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      'After this character uses Technique, at the start of the next battle, all allies are granted Invigoration.',
    desc: 'After Technique is used, at the start of the next battle, all allies are granted Invigoration for #1[i] turn(s).',
    params: [[2]],
    icon: 'icon/skill/1211_technique.png'
  },
  121301: {
    id: '121301',
    name: 'Beneficent Lotus',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Imaginary DMG to a single enemy.',
    desc: "Uses a 2-hit attack and deals Imaginary DMG equal to #1[i]% of Dan Heng • Imbibitor Lunae's ATK to a single enemy target.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1213_basic_atk.png'
  },
  121302: {
    id: '121302',
    name: 'Dracore Libre',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'Enhances the Basic ATK Beneficent Lotus to Transcendence, Divine Spear, or Fulgurant Leap.',
    desc: "Enhances Basic ATK. Enhancements may be applied up to 3 times consecutively. Using this ability does not consume Skill Points and is not considered as using a Skill.\nEnhanced once, Beneficent Lotus becomes Transcendence.\nEnhanced twice, Beneficent Lotus becomes Divine Spear.\nEnhanced thrice, Beneficent Lotus becomes Fulgurant Leap.\nWhen using Divine Spear or Fulgurant Leap, starting from the fourth hit, 1 stack of Outroar is gained before every hit. Each stack of Outroar increases Dan Heng • Imbibitor Lunae's CRIT DMG by #1[i]%, for a max of #2[i] stacks. These stacks last until the end of his turn.",
    params: [
      [0.06, 4],
      [0.066, 4],
      [0.072, 4],
      [0.078, 4],
      [0.084, 4],
      [0.09, 4],
      [0.0975, 4],
      [0.105, 4],
      [0.1125, 4],
      [0.12, 4],
      [0.126, 4],
      [0.132, 4],
      [0.138, 4],
      [0.144, 4],
      [0.15, 4]
    ],
    icon: 'icon/skill/1213_skill.png'
  },
  121303: {
    id: '121303',
    name: "Azure's Aqua Ablutes All",
    max_level: 15,
    element: 'Imaginary',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      "Deals massive Imaginary DMG to a single enemy, deals Imaginary DMG to adjacent targets, and gains 2 Squama Sacrosancta, which can offset Dan Heng • Imbibitor Lunae's consumption of skill points. Consuming Squama Sacrosancta is considered equivalent to consuming skill points.",
    desc: "Uses a 3-hit attack and deals Imaginary DMG equal to #1[i]% of Dan Heng • Imbibitor Lunae's ATK to a single enemy target. At the same time, deals Imaginary DMG equal to #2[i]% of Dan Heng • Imbibitor Lunae's ATK to adjacent targets. Then, obtains #3[i] Squama Sacrosancta.\nIt's possible to hold up to #4[i] Squama Sacrosancta, which can be used to offset Dan Heng • Imbibitor Lunae's consumption of skill points. Consuming Squama Sacrosancta is considered equivalent to consuming skill points.",
    params: [
      [1.8, 0.84, 2, 3],
      [1.92, 0.896, 2, 3],
      [2.04, 0.952, 2, 3],
      [2.16, 1.008, 2, 3],
      [2.28, 1.064, 2, 3],
      [2.4, 1.12, 2, 3],
      [2.55, 1.19, 2, 3],
      [2.7, 1.26, 2, 3],
      [2.85, 1.33, 2, 3],
      [3, 1.4, 2, 3],
      [3.12, 1.456, 2, 3],
      [3.24, 1.512, 2, 3],
      [3.36, 1.568, 2, 3],
      [3.48, 1.624, 2, 3],
      [3.6, 1.68, 2, 3]
    ],
    icon: 'icon/skill/1213_ultimate.png'
  },
  121304: {
    id: '121304',
    name: 'Righteous Heart',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      "Increases DMG for every hit dealt. This effect is stackable and lasts until the end of this character's turn.",
    desc: 'After each hit dealt during an attack, Dan Heng • Imbibitor Lunae gains 1 stack of Righteous Heart, increasing his DMG by #1[i]%. This effect can stack up to #2[i] time(s), lasting until the end of his turn.',
    params: [
      [0.05, 6],
      [0.055, 6],
      [0.06, 6],
      [0.065, 6],
      [0.07, 6],
      [0.075, 6],
      [0.0813, 6],
      [0.0875, 6],
      [0.0938, 6],
      [0.1, 6],
      [0.105, 6],
      [0.11, 6],
      [0.115, 6],
      [0.12, 6],
      [0.125, 6]
    ],
    icon: 'icon/skill/1213_talent.png'
  },
  121306: {
    id: '121306',
    name: 'Attack',
    max_level: 1,
    element: 'Imaginary',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1213_basic_atk.png'
  },
  121307: {
    id: '121307',
    name: 'Heaven-Quelling Prismadrakon',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'Enters the Leaping Dragon state. Attacking will cause this character to move forward rapidly for a set distance and attack all enemies touched. After entering combat via attacking enemies, deals Imaginary DMG to all enemies, and gains 1 Squama Sacrosancta.',
    desc: 'After using his Technique, Dan Heng • Imbibitor Lunae enters the Leaping Dragon state for #2[i] seconds. While in the Leaping Dragon state, using his attack enables him to move forward rapidly for a set distance, attacking all enemies he touches and blocking all incoming attacks. After entering combat via attacking enemies in the Leaping Dragon state, Dan Heng • Imbibitor Lunae deals Imaginary DMG equal to #3[i]% of his ATK to all enemies, and gains #1[i] Squama Sacrosancta.',
    params: [[1, 20, 1.2]],
    icon: 'icon/skill/1213_technique.png'
  },
  121308: {
    id: '121308',
    name: 'Transcendence',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Unleashes 3 hits in this attack and deals Imaginary DMG to a single enemy target.',
    desc: "Uses a 3-hit attack and deals Imaginary DMG equal to #1[i]% of Dan Heng • Imbibitor Lunae's ATK to a single enemy target.",
    params: [
      [1.3],
      [1.56],
      [1.82],
      [2.08],
      [2.34],
      [2.6],
      [2.86],
      [3.12],
      [3.38],
      [1.3],
      [1.3],
      [1.3],
      [1.3],
      [1.3],
      [1.3]
    ],
    icon: 'icon/skill/1213_basic_atk.png'
  },
  121309: {
    id: '121309',
    name: 'Cancel',
    max_level: 1,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Enhance',
    effect_text: 'Cancel',
    simple_desc: '',
    desc: 'Cancel Enhancement',
    params: [],
    icon: 'icon/skill/1213_skill.png'
  },
  121310: {
    id: '121310',
    name: 'Divine Spear',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Unleashes 5 hits in this attack to deal massive Imaginary DMG to a single enemy and minor Imaginary DMG to adjacent targets. For each of the last 2 hits, obtains 1 stack of Outroar just before the hit, increasing CRIT DMG.',
    desc: "Uses a 5-hit attack and deals Imaginary DMG equal to #1[i]% of Dan Heng • Imbibitor Lunae's ATK to a single enemy target. From the fourth hit onward, simultaneously deals Imaginary DMG equal to #2[i]% of Dan Heng • Imbibitor Lunae's ATK to adjacent targets.",
    params: [
      [1.9, 0.3],
      [2.28, 0.36],
      [2.66, 0.42],
      [3.04, 0.48],
      [3.42, 0.54],
      [3.8, 0.6],
      [4.18, 0.66],
      [2.28, 0.36],
      [2.66, 0.42],
      [3.04, 0.48],
      [3.42, 0.54],
      [3.8, 0.6],
      [4.18, 0.66],
      [4.56, 0.72],
      [4.94, 0.78]
    ],
    icon: 'icon/skill/1213_basic_atk.png'
  },
  121312: {
    id: '121312',
    name: 'Fulgurant Leap',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Unleashes 7 hits in this attack to deal massive Imaginary DMG to a single enemy and Imaginary DMG to adjacent targets. For each of the last 4 hits, obtains 1 stack of Outroar just before the hit, increasing CRIT DMG.',
    desc: "Uses a 7-hit attack and deals Imaginary DMG equal to #1[i]% of Dan Heng • Imbibitor Lunae's ATK to a single enemy target. From the fourth hit onward, simultaneously deal Imaginary DMG equal to #2[i]% of Dan Heng • Imbibitor Lunae's ATK to adjacent targets.",
    params: [
      [2.5, 0.9],
      [3, 1.08],
      [3.5, 1.26],
      [4, 1.44],
      [4.5, 1.62],
      [5, 1.8],
      [5.5, 1.98],
      [6, 2.16],
      [6.5, 2.34]
    ],
    icon: 'icon/skill/1213_basic_atk.png'
  },
  800101: {
    id: '800101',
    name: 'Farewell Hit',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Physical DMG to a single enemy.',
    desc: "Deals Physical DMG equal to #1[i]% of the Trailblazer's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/8001_basic_atk.png'
  },
  800102: {
    id: '800102',
    name: 'RIP Home Run',
    max_level: 15,
    element: 'Physical',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals Physical DMG to a single enemy and enemies adjacent to it.',
    desc: "Deals Physical DMG equal to #1[i]% of the Trailblazer's ATK to a single enemy and enemies adjacent to it.",
    params: [
      [0.625],
      [0.6875],
      [0.75],
      [0.8125],
      [0.875],
      [0.9375],
      [1.0156],
      [1.0938],
      [1.1719],
      [1.25],
      [1.3125],
      [1.375],
      [1.4375],
      [1.5],
      [1.5625]
    ],
    icon: 'icon/skill/8001_skill.png'
  },
  800103: {
    id: '800103',
    name: 'Stardust Ace',
    max_level: 15,
    element: 'Physical',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: 'Uses Single Target ATK or Blast to strike with full force.',
    desc: "Choose between two attack modes to deliver a full strike.\nBlowout: Farewell Hit deals Physical DMG equal to #1[i]% of the Trailblazer's ATK to a single enemy.\nBlowout: RIP Home Run deals Physical DMG equal to #2[i]% of the Trailblazer's ATK to a single enemy, and Physical DMG equal to #3[i]% of the Trailblazer's ATK to enemies adjacent to it.",
    params: [
      [3, 1.8, 1.08],
      [3.15, 1.89, 1.134],
      [3.3, 1.98, 1.188],
      [3.45, 2.07, 1.242],
      [3.6, 2.16, 1.296],
      [3.75, 2.25, 1.35],
      [3.9375, 2.3625, 1.4175],
      [4.125, 2.475, 1.485],
      [4.3125, 2.5875, 1.5525],
      [4.5, 2.7, 1.62],
      [4.65, 2.79, 1.674],
      [4.8, 2.88, 1.728],
      [4.95, 2.97, 1.782],
      [5.1, 3.06, 1.836],
      [5.25, 3.15, 1.89]
    ],
    icon: 'icon/skill/8001_ultimate.png'
  },
  800104: {
    id: '800104',
    name: 'Perfect Pickoff',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'Each time after this character inflicts Weakness Break on an enemy, ATK increases by #1[i]%. This effect stacks up to #2[i] time(s).',
    params: [
      [0.1, 2],
      [0.11, 2],
      [0.12, 2],
      [0.13, 2],
      [0.14, 2],
      [0.15, 2],
      [0.1625, 2],
      [0.175, 2],
      [0.1875, 2],
      [0.2, 2],
      [0.21, 2],
      [0.22, 2],
      [0.23, 2],
      [0.24, 2],
      [0.25, 2]
    ],
    icon: 'icon/skill/8001_talent.png'
  },
  800106: {
    id: '800106',
    name: 'Attack',
    max_level: 1,
    element: 'Physical',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/8001_basic_atk.png'
  },
  800107: {
    id: '800107',
    name: 'Immortal Third Strike',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc: '',
    desc: 'Immediately heals all allies for #1[i]% of their respective Max HP after using this Technique.',
    params: [[0.15]],
    icon: 'icon/skill/8001_technique.png'
  },
  800108: {
    id: '800108',
    name: 'Blowout: Farewell Hit',
    max_level: 15,
    element: 'Physical',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals massive Physical DMG to a single enemy.',
    desc: "Deals Physical DMG equal to #1[i]% of the Trailblazer's ATK to a single enemy.",
    params: [
      [3],
      [3.15],
      [3.3],
      [3.45],
      [3.6],
      [3.75],
      [3.9375],
      [4.125],
      [4.3125],
      [4.5],
      [4.65],
      [4.8],
      [4.95],
      [5.1],
      [5.25]
    ],
    icon: 'icon/skill/8001_ultimate.png'
  },
  800109: {
    id: '800109',
    name: 'Blowout: RIP Home Run',
    max_level: 15,
    element: 'Physical',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals Physical DMG to a single enemy and enemies adjacent to it.',
    desc: "Deals Physical DMG equal to #1[i]% of Trailblazer's ATK to a single enemy and Physical DMG equal to #2[i]% of Trailblazer's ATK to enemies adjacent to it.",
    params: [
      [1.8, 1.08],
      [1.89, 1.134],
      [1.98, 1.188],
      [2.07, 1.242],
      [2.16, 1.296],
      [2.25, 1.35],
      [2.3625, 1.4175],
      [2.475, 1.485],
      [2.5875, 1.5525],
      [2.7, 1.62],
      [2.79, 1.674],
      [2.88, 1.728],
      [2.97, 1.782],
      [3.06, 1.836],
      [3.15, 1.89]
    ],
    icon: 'icon/skill/8001_ultimate.png'
  },
  800201: {
    id: '800201',
    name: 'Farewell Hit',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Physical DMG to a single enemy.',
    desc: "Deals Physical DMG equal to #1[i]% of the Trailblazer's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/8002_basic_atk.png'
  },
  800202: {
    id: '800202',
    name: 'RIP Home Run',
    max_level: 15,
    element: 'Physical',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals Physical DMG to a single enemy and enemies adjacent to it.',
    desc: "Deals Physical DMG equal to #1[i]% of the Trailblazer's ATK to a single enemy and enemies adjacent to it.",
    params: [
      [0.625],
      [0.6875],
      [0.75],
      [0.8125],
      [0.875],
      [0.9375],
      [1.0156],
      [1.0938],
      [1.1719],
      [1.25],
      [1.3125],
      [1.375],
      [1.4375],
      [1.5],
      [1.5625]
    ],
    icon: 'icon/skill/8002_skill.png'
  },
  800203: {
    id: '800203',
    name: 'Stardust Ace',
    max_level: 15,
    element: 'Physical',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: 'Uses Single Target ATK or Blast to strike with full force.',
    desc: "Choose between two attack modes to deliver a full strike.\nBlowout: Farewell Hit deals Physical DMG equal to #1[i]% of the Trailblazer's ATK to a single enemy.\nBlowout: RIP Home Run deals Physical DMG equal to #2[i]% of the Trailblazer's ATK to a single enemy, and Physical DMG equal to #3[i]% of the Trailblazer's ATK to enemies adjacent to it.",
    params: [
      [3, 1.8, 1.08],
      [3.15, 1.89, 1.134],
      [3.3, 1.98, 1.188],
      [3.45, 2.07, 1.242],
      [3.6, 2.16, 1.296],
      [3.75, 2.25, 1.35],
      [3.9375, 2.3625, 1.4175],
      [4.125, 2.475, 1.485],
      [4.3125, 2.5875, 1.5525],
      [4.5, 2.7, 1.62],
      [4.65, 2.79, 1.674],
      [4.8, 2.88, 1.728],
      [4.95, 2.97, 1.782],
      [5.1, 3.06, 1.836],
      [5.25, 3.15, 1.89]
    ],
    icon: 'icon/skill/8002_ultimate.png'
  },
  800204: {
    id: '800204',
    name: 'Perfect Pickoff',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'Each time after this character inflicts Weakness Break on an enemy, ATK increases by #1[i]%. This effect stacks up to #2[i] time(s).',
    params: [
      [0.1, 2],
      [0.11, 2],
      [0.12, 2],
      [0.13, 2],
      [0.14, 2],
      [0.15, 2],
      [0.1625, 2],
      [0.175, 2],
      [0.1875, 2],
      [0.2, 2],
      [0.21, 2],
      [0.22, 2],
      [0.23, 2],
      [0.24, 2],
      [0.25, 2]
    ],
    icon: 'icon/skill/8002_talent.png'
  },
  800206: {
    id: '800206',
    name: 'Attack',
    max_level: 1,
    element: 'Physical',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/8002_basic_atk.png'
  },
  800207: {
    id: '800207',
    name: 'Immortal Third Strike',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc: '',
    desc: 'Immediately heals all allies for #1[i]% of their respective Max HP after using this Technique.',
    params: [[0.15]],
    icon: 'icon/skill/8002_technique.png'
  },
  800208: {
    id: '800208',
    name: 'Blowout: Farewell Hit',
    max_level: 15,
    element: 'Physical',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals massive Physical DMG to a single enemy.',
    desc: "Deals Physical DMG equal to #1[i]% of the Trailblazer's ATK to a single enemy.",
    params: [
      [3],
      [3.15],
      [3.3],
      [3.45],
      [3.6],
      [3.75],
      [3.9375],
      [4.125],
      [4.3125],
      [4.5],
      [4.65],
      [4.8],
      [4.95],
      [5.1],
      [5.25]
    ],
    icon: 'icon/skill/8002_ultimate.png'
  },
  800209: {
    id: '800209',
    name: 'Blowout: RIP Home Run',
    max_level: 15,
    element: 'Physical',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals Physical DMG to a single enemy and enemies adjacent to it.',
    desc: "Deals Physical DMG equal to #1[i]% of Trailblazer's ATK to a single enemy and Physical DMG equal to #2[i]% of Trailblazer's ATK to enemies adjacent to it.",
    params: [
      [1.8, 1.08],
      [1.89, 1.134],
      [1.98, 1.188],
      [2.07, 1.242],
      [2.16, 1.296],
      [2.25, 1.35],
      [2.3625, 1.4175],
      [2.475, 1.485],
      [2.5875, 1.5525],
      [2.7, 1.62],
      [2.79, 1.674],
      [2.88, 1.728],
      [2.97, 1.782],
      [3.06, 1.836],
      [3.15, 1.89]
    ],
    icon: 'icon/skill/8002_ultimate.png'
  },
  800301: {
    id: '800301',
    name: 'Ice-Breaking Light',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to a single enemy and gains Magma Will.',
    desc: "Deals Fire DMG equal to #1[i]% of the Trailblazer's ATK to a single enemy and gains 1 stack of Magma Will.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/8003_basic_atk.png'
  },
  800302: {
    id: '800302',
    name: 'Ever-Burning Amber',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Defence',
    effect_text: 'Defense',
    simple_desc:
      'Reduces DMG taken and gains Magma Will, with a high chance to Taunt all enemies.',
    desc: "Increases the Trailblazer's DMG Reduction by #1[i]% and gains 1 stack of Magma Will, with a #2[i]% base chance to Taunt all enemies for #3[i] turn(s).",
    params: [
      [0.4, 1, 1],
      [0.41, 1, 1],
      [0.42, 1, 1],
      [0.43, 1, 1],
      [0.44, 1, 1],
      [0.45, 1, 1],
      [0.4625, 1, 1],
      [0.475, 1, 1],
      [0.4875, 1, 1],
      [0.5, 1, 1],
      [0.51, 1, 1],
      [0.52, 1, 1],
      [0.53, 1, 1],
      [0.54, 1, 1],
      [0.55, 1, 1]
    ],
    icon: 'icon/skill/8003_skill.png'
  },
  800303: {
    id: '800303',
    name: 'War-Flaming Lance',
    max_level: 15,
    element: 'Fire',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Deals Fire DMG to all enemies and enhances the next Basic ATK.',
    desc: "Deals Fire DMG equal to #1[i]% of the Trailblazer's ATK plus #2[i]% of the Trailblazer's DEF to all enemies. The next Basic ATK will be automatically enhanced and does not cost Magma Will.",
    params: [
      [0.5, 0.75],
      [0.55, 0.825],
      [0.6, 0.9],
      [0.65, 0.975],
      [0.7, 1.05],
      [0.75, 1.125],
      [0.8125, 1.2188],
      [0.875, 1.3125],
      [0.9375, 1.4063],
      [1, 1.5],
      [1.05, 1.575],
      [1.1, 1.65],
      [1.15, 1.725],
      [1.2, 1.8],
      [1.25, 1.875]
    ],
    icon: 'icon/skill/8003_ultimate.png'
  },
  800304: {
    id: '800304',
    name: 'Treasure of the Architects',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "Each time the Trailblazer is hit, they gain 1 stack of Magma Will for a max of #3[i] stack(s).\nWhen Magma Will has no fewer than 4 stacks, the Trailblazer's Basic ATK becomes enhanced, dealing DMG to a single enemy and enemies adjacent to it.\nWhen the Trailblazer uses Basic ATK, Skill, or Ultimate, apply a Shield to all allies that absorbs DMG equal to #1[i]% of the Trailblazer's DEF plus #4[i]. The Shield lasts for #2[i] turn(s).",
    params: [
      [0.04, 2, 8, 20],
      [0.0425, 2, 8, 32],
      [0.045, 2, 8, 41],
      [0.0475, 2, 8, 50],
      [0.05, 2, 8, 56],
      [0.052, 2, 8, 62],
      [0.054, 2, 8, 66.5],
      [0.056, 2, 8, 71],
      [0.058, 2, 8, 75.5],
      [0.06, 2, 8, 80],
      [0.062, 2, 8, 84.5],
      [0.064, 2, 8, 89],
      [0.066, 2, 8, 93.5],
      [0.068, 2, 8, 98],
      [0.07, 2, 8, 102.5]
    ],
    icon: 'icon/skill/8003_talent.png'
  },
  800306: {
    id: '800306',
    name: 'Attack',
    max_level: 1,
    element: 'Fire',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/8003_basic_atk.png'
  },
  800307: {
    id: '800307',
    name: 'Call of the Guardian',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Defence',
    effect_text: 'Defense',
    simple_desc: '',
    desc: "After using Technique, at the start of the next battle, gains a Shield that absorbs DMG equal to #1[i]% of the Trailblazer's DEF plus #2[i] for #3[i] turn(s).",
    params: [[0.3, 384, 1]],
    icon: 'icon/skill/8003_technique.png'
  },
  800308: {
    id: '800308',
    name: 'Ice-Breaking Light',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Consumes Magma Will, then deals Fire DMG to a single enemy and minor Fire DMG to enemies adjacent to it.',
    desc: "Consumes 4 stacks of Magma Will to enhance Basic ATK, dealing Fire DMG equal to #1[i]% of the Trailblazer's ATK to a single enemy and Fire DMG to equal to #2[i]% of the Trailblazer's ATK to enemies adjacent to it.",
    params: [
      [0.9, 0.36],
      [0.99, 0.396],
      [1.08, 0.432],
      [1.17, 0.468],
      [1.26, 0.504],
      [1.35, 0.54],
      [1.4625, 0.585],
      [1.575, 0.63],
      [1.6875, 0.675]
    ],
    icon: 'icon/skill/8003_basic_atk.png'
  },
  800401: {
    id: '800401',
    name: 'Ice-Breaking Light',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to a single enemy and gains Magma Will.',
    desc: "Deals Fire DMG equal to #1[i]% of the Trailblazer's ATK to a single enemy and gains 1 stack of Magma Will.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/8004_basic_atk.png'
  },
  800402: {
    id: '800402',
    name: 'Ever-Burning Amber',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Defence',
    effect_text: 'Defense',
    simple_desc:
      'Reduces DMG taken and gains Magma Will, with a high chance to Taunt all enemies.',
    desc: "Increases the Trailblazer's DMG Reduction by #1[i]% and gains 1 stack of Magma Will, with a #2[i]% base chance to Taunt all enemies for #3[i] turn(s).",
    params: [
      [0.4, 1, 1],
      [0.41, 1, 1],
      [0.42, 1, 1],
      [0.43, 1, 1],
      [0.44, 1, 1],
      [0.45, 1, 1],
      [0.4625, 1, 1],
      [0.475, 1, 1],
      [0.4875, 1, 1],
      [0.5, 1, 1],
      [0.51, 1, 1],
      [0.52, 1, 1],
      [0.53, 1, 1],
      [0.54, 1, 1],
      [0.55, 1, 1]
    ],
    icon: 'icon/skill/8004_skill.png'
  },
  800403: {
    id: '800403',
    name: 'War-Flaming Lance',
    max_level: 15,
    element: 'Fire',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Deals Fire DMG to all enemies and enhances the next Basic ATK.',
    desc: "Deals Fire DMG equal to #1[i]% of the Trailblazer's ATK plus #2[i]% of the Trailblazer's DEF to all enemies. The next Basic ATK will be automatically enhanced and does not cost Magma Will.",
    params: [
      [0.5, 0.75],
      [0.55, 0.825],
      [0.6, 0.9],
      [0.65, 0.975],
      [0.7, 1.05],
      [0.75, 1.125],
      [0.8125, 1.2188],
      [0.875, 1.3125],
      [0.9375, 1.4063],
      [1, 1.5],
      [1.05, 1.575],
      [1.1, 1.65],
      [1.15, 1.725],
      [1.2, 1.8],
      [1.25, 1.875]
    ],
    icon: 'icon/skill/8004_ultimate.png'
  },
  800404: {
    id: '800404',
    name: 'Treasure of the Architects',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "Each time the Trailblazer is hit, they gain 1 stack of Magma Will for a max of #3[i] stack(s).\nWhen Magma Will has no fewer than 4 stacks, the Trailblazer's Basic ATK becomes enhanced, dealing DMG to a single enemy and enemies adjacent to it.\nWhen the Trailblazer uses Basic ATK, Skill, or Ultimate, apply a Shield to all allies that absorbs DMG equal to #1[i]% of the Trailblazer's DEF plus #4[i]. The Shield lasts for #2[i] turn(s).",
    params: [
      [0.04, 2, 8, 20],
      [0.0425, 2, 8, 32],
      [0.045, 2, 8, 41],
      [0.0475, 2, 8, 50],
      [0.05, 2, 8, 56],
      [0.052, 2, 8, 62],
      [0.054, 2, 8, 66.5],
      [0.056, 2, 8, 71],
      [0.058, 2, 8, 75.5],
      [0.06, 2, 8, 80],
      [0.062, 2, 8, 84.5],
      [0.064, 2, 8, 89],
      [0.066, 2, 8, 93.5],
      [0.068, 2, 8, 98],
      [0.07, 2, 8, 102.5]
    ],
    icon: 'icon/skill/8004_talent.png'
  },
  800406: {
    id: '800406',
    name: 'Attack',
    max_level: 1,
    element: 'Fire',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/8004_basic_atk.png'
  },
  800407: {
    id: '800407',
    name: 'Call of the Guardian',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Defence',
    effect_text: 'Defense',
    simple_desc: '',
    desc: "After using Technique, at the start of the next battle, gains a Shield that absorbs DMG equal to #1[i]% of the Trailblazer's DEF plus #2[i] for #3[i] turn(s).",
    params: [[0.3, 384, 1]],
    icon: 'icon/skill/8004_technique.png'
  },
  800408: {
    id: '800408',
    name: 'Ice-Breaking Light',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Consumes Magma Will, then deals Fire DMG to a single enemy and minor Fire DMG to enemies adjacent to it.',
    desc: "Consumes 4 stacks of Magma Will to enhance Basic ATK, dealing Fire DMG equal to #1[i]% of the Trailblazer's ATK to a single enemy and Fire DMG to equal to #2[i]% of the Trailblazer's ATK to enemies adjacent to it.",
    params: [
      [0.9, 0.36],
      [0.99, 0.396],
      [1.08, 0.432],
      [1.17, 0.468],
      [1.26, 0.504],
      [1.35, 0.54],
      [1.4625, 0.585],
      [1.575, 0.63],
      [1.6875, 0.675]
    ],
    icon: 'icon/skill/8004_basic_atk.png'
  },
  909807: {
    id: '909807',
    name: '',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc: '',
    desc: '',
    params: [],
    icon: ''
  },
  121201: {
    id: '121201',
    name: 'Lucent Moonglow',
    max_level: 9,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Ice DMG to a single enemy target.',
    desc: "Deals Ice DMG equal to #1[i]% of Jingliu's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1212_basic_atk.png'
  },
  121202: {
    id: '121202',
    name: 'Transcendent Flash',
    max_level: 15,
    element: 'Ice',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Deals Ice DMG to a target enemy and obtains 1 stack of Syzygy.',
    desc: "Deals Ice DMG equal to #1[i]% of Jingliu's ATK to a single enemy and obtains #2[i] stack(s) of Syzygy.",
    params: [
      [1, 1],
      [1.1, 1],
      [1.2, 1],
      [1.3, 1],
      [1.4, 1],
      [1.5, 1],
      [1.625, 1],
      [1.75, 1],
      [1.875, 1],
      [2, 1],
      [2.1, 1],
      [2.2, 1],
      [2.3, 1],
      [2.4, 1],
      [2.5, 1]
    ],
    icon: 'icon/skill/1212_skill.png'
  },
  121203: {
    id: '121203',
    name: 'Florephemeral Dreamflux',
    max_level: 15,
    element: 'Ice',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals massive Ice DMG to a target enemy and deals Ice DMG to adjacent targets. Obtains 1 stack of Syzygy.',
    desc: "Deals Ice DMG equal to #1[i]% of Jingliu's ATK to a single enemy, and deals Ice DMG equal to #3[i]% of Jingliu's ATK to any adjacent enemies. Gains #2[i] stack(s) of Syzygy after attack ends.",
    params: [
      [1.8, 1, 0.9, 1],
      [1.92, 1, 0.96, 1],
      [2.04, 1, 1.02, 1],
      [2.16, 1, 1.08, 1],
      [2.28, 1, 1.14, 1],
      [2.4, 1, 1.2, 1],
      [2.55, 1, 1.275, 1],
      [2.7, 1, 1.35, 1],
      [2.85, 1, 1.425, 1],
      [3, 1, 1.5, 1],
      [3.12, 1, 1.56, 1],
      [3.24, 1, 1.62, 1],
      [3.36, 1, 1.68, 1],
      [3.48, 1, 1.74, 1],
      [3.6, 1, 1.8, 1]
    ],
    icon: 'icon/skill/1212_ultimate.png'
  },
  121204: {
    id: '121204',
    name: 'Crescent Transmigration',
    max_level: 15,
    element: 'Ice',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      "When possessing #5[i] stacks of Syzygy, Jingliu enters the Spectral Transmigration state with her Action Advanced by 100%, her CRIT Rate increased, and her Skill becoming Enhanced. Using an attack in this state consumes HP from all other allies and increases Jingliu's ATK according to the total HP consumed. When Syzygy stacks become 0, exits the Spectral Transmigration state.",
    desc: 'When Jingliu has #5[i] stack(s) of Syzygy, she enters the Spectral Transmigration state with her Action Advanced by #6[i]% and her CRIT Rate increases by #7[i]%. Then, Jingliu\'s Skill "Transcendent Flash" becomes enhanced and turns into "Moon On Glacial River," and becomes the only ability she can use in battle. When Jingliu uses an attack in the Spectral Transmigration state, she consumes HP from all other allies equal to #2[i]% of their respective Max HP (this cannot reduce allies\' HP to lower than 1). Jingliu\'s ATK increases by #3[i]% of the total HP consumed from all allies in this attack, capped at #4[i]% of her base ATK, lasting until the current attack ends. Jingliu cannot enter the Spectral Transmigration state again until the current Spectral Transmigration state ends. Syzygy can stack up to 3 times. When Syzygy stacks become 0, Jingliu will exit the Spectral Transmigration state.',
    params: [
      [0.3, 0.04, 5.4, 0.9, 2, 1, 0.4],
      [0.3, 0.04, 5.4, 0.99, 2, 1, 0.41],
      [0.3, 0.04, 5.4, 1.08, 2, 1, 0.42],
      [0.3, 0.04, 5.4, 1.17, 2, 1, 0.43],
      [0.3, 0.04, 5.4, 1.26, 2, 1, 0.44],
      [0.3, 0.04, 5.4, 1.35, 2, 1, 0.45],
      [0.3, 0.04, 5.4, 1.4625, 2, 1, 0.4625],
      [0.3, 0.04, 5.4, 1.575, 2, 1, 0.475],
      [0.3, 0.04, 5.4, 1.6875, 2, 1, 0.4875],
      [0.3, 0.04, 5.4, 1.8, 2, 1, 0.5],
      [0.3, 0.04, 5.4, 1.89, 2, 1, 0.51],
      [0.3, 0.04, 5.4, 1.98, 2, 1, 0.52],
      [0.3, 0.04, 5.4, 2.07, 2, 1, 0.53],
      [0.3, 0.04, 5.4, 2.16, 2, 1, 0.54],
      [0.3, 0.04, 5.4, 2.25, 2, 1, 0.55]
    ],
    icon: 'icon/skill/1212_talent.png'
  },
  121206: {
    id: '121206',
    name: 'Attack',
    max_level: 1,
    element: 'Ice',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: "After attacking an enemy and entering battle, the enemy's corresponding Type Toughness will be Weakened.",
    params: [],
    icon: 'icon/skill/1212_basic_atk.png'
  },
  121207: {
    id: '121207',
    name: 'Shine of Truth',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'Creates a dimension around the character. Enemies within this dimension will become Frozen. After entering combat with enemies in the dimension, this character regenerates Energy and obtains 1 stack of Syzygy with a high chance to Freeze enemies.',
    desc: "After using this Technique, creates a dimension around Jingliu that lasts for #3[i] seconds, and all enemies in this dimension will become Frozen. After entering combat with enemies in the dimension, Jingliu immediately regenerates #6[i] Energy and obtains #1[i] stack(s) of Syzygy, with a #2[i]% base chance of Freezing enemy targets for #4[i] turn(s). While Frozen, enemy targets cannot take action, and receive Ice Additional DMG equal to #5[i]% of Jingliu's ATK at the start of every turn. Only 1 dimension created by allies can exist at the same time.",
    params: [[1, 1, 20, 1, 0.8, 15]],
    icon: 'icon/skill/1212_technique.png'
  },
  121209: {
    id: '121209',
    name: 'Moon On Glacial River',
    max_level: 15,
    element: 'Ice',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals Ice DMG to a single enemy target and Ice DMG to adjacent targets. Consumes 1 stack of Syzygy.',
    desc: "Deals Ice DMG equal to #1[i]% of Jingliu's ATK to a single enemy, and deals Ice DMG equal to #3[i]% of Jingliu's ATK to adjacent enemies. Consumes #2[i] stack(s) of Syzygy. Using this ability does not consume Skill Points.",
    params: [
      [1.25, 1, 0.625],
      [1.375, 1, 0.6875],
      [1.5, 1, 0.75],
      [1.625, 1, 0.8125],
      [1.75, 1, 0.875],
      [1.875, 1, 0.9375],
      [2.0313, 1, 1.0156],
      [2.1875, 1, 1.0938],
      [2.3438, 1, 1.1719],
      [2.5, 1, 1.25],
      [2.625, 1, 1.3125],
      [2.75, 1, 1.375],
      [2.875, 1, 1.4375],
      [3, 1, 1.5],
      [3.125, 1, 1.5625]
    ],
    icon: 'icon/skill/1212_skill.png'
  },
  111201: {
    id: '111201',
    name: 'Deficit...',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to an enemy.',
    desc: "Deals Fire DMG equal to #1[i]% of Topaz's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1112_basic_atk.png'
  },
  111202: {
    id: '111202',
    name: 'Difficulty Paying?',
    max_level: 15,
    element: 'Fire',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Inflicts a single enemy with a Proof of Debt status and causes it to receive increased DMG from follow-up attacks. Numby deals Fire DMG to the target.',
    desc: "Inflicts a single target enemy with a Proof of Debt status, increasing the DMG it takes from follow-up attacks by #2[i]%. Proof of Debt only takes effect on the most recent target it is applied to. If there are no enemies inflicted with Proof of Debt on the field when an ally's turn starts or when an ally takes action, Topaz will inflict a random enemy with Proof of Debt.\nNumby deals Fire DMG equal to #1[i]% of Topaz's ATK to this target. Using this Skill to deal DMG is considered as launching a follow-up attack.",
    params: [
      [0.75, 0.25],
      [0.825, 0.275],
      [0.9, 0.3],
      [0.975, 0.325],
      [1.05, 0.35],
      [1.125, 0.375],
      [1.2188, 0.4063],
      [1.3125, 0.4375],
      [1.4063, 0.4688],
      [1.5, 0.5],
      [1.575, 0.525],
      [1.65, 0.55],
      [1.725, 0.575],
      [1.8, 0.6],
      [1.875, 0.625]
    ],
    icon: 'icon/skill/1112_skill.png'
  },
  111203: {
    id: '111203',
    name: 'Turn a Profit!',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'Numby enters the Windfall Bonanza! state and increases its DMG multiplier and CRIT DMG.',
    desc: "Numby enters the Windfall Bonanza! state and its DMG multiplier increases by #1[i]% and CRIT DMG increases by #2[i]%. Also, when enemies with Proof of Debt are hit by an ally's Basic ATK, Skill, or Ultimate, Numby's action is Advanced Forward by #3[i]%. Numby exits the Windfall Bonanza! state after using #4[i] attacks.",
    params: [
      [0.75, 0.125, 0.5, 2],
      [0.825, 0.1375, 0.5, 2],
      [0.9, 0.15, 0.5, 2],
      [0.975, 0.1625, 0.5, 2],
      [1.05, 0.175, 0.5, 2],
      [1.125, 0.1875, 0.5, 2],
      [1.2188, 0.2031, 0.5, 2],
      [1.3125, 0.2188, 0.5, 2],
      [1.4063, 0.2344, 0.5, 2],
      [1.5, 0.25, 0.5, 2],
      [1.575, 0.2625, 0.5, 2],
      [1.65, 0.275, 0.5, 2],
      [1.725, 0.2875, 0.5, 2],
      [1.8, 0.3, 0.5, 2],
      [1.875, 0.3125, 0.5, 2]
    ],
    icon: 'icon/skill/1112_ultimate.png'
  },
  111204: {
    id: '111204',
    name: 'Trotter Market!?',
    max_level: 15,
    element: 'Fire',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      "At the start of battle, summons Numby. When Numby takes action, Numby deals follow-up attacks to a single enemy with Proof of Debt. When an enemy with Proof of Debt takes DMG from follow-up attacks, Numby's action is Advanced Forward.",
    desc: "Summons Numby at the start of battle. Numby has #1[i] SPD by default. When taking action, Numby launches follow-up attacks on a single enemy target afflicted with Proof of Debt, dealing Fire DMG equal to #2[i]% of Topaz's ATK.\nWhen enemies afflicted with Proof of Debt receive an ally's follow-up attacks, Numby's action is Advanced Forward by #3[i]%. The action Advance Forward effect cannot be triggered during Numby's own turn.\nWhen Topaz is downed, Numby disappears.",
    params: [
      [80, 0.75, 0.5],
      [80, 0.825, 0.5],
      [80, 0.9, 0.5],
      [80, 0.975, 0.5],
      [80, 1.05, 0.5],
      [80, 1.125, 0.5],
      [80, 1.2188, 0.5],
      [80, 1.3125, 0.5],
      [80, 1.4063, 0.5],
      [80, 1.5, 0.5],
      [80, 1.575, 0.5],
      [80, 1.65, 0.5],
      [80, 1.725, 0.5],
      [80, 1.8, 0.5],
      [80, 1.875, 0.5]
    ],
    icon: 'icon/skill/1112_talent.png'
  },
  111206: {
    id: '111206',
    name: 'Attack',
    max_level: 1,
    element: 'Fire',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: "After attacking an enemy and entering battle, the enemy target's corresponding Type Toughness will be Weakened.",
    params: [],
    icon: 'icon/skill/1112_basic_atk.png'
  },
  111207: {
    id: '111207',
    name: 'Explicit Subsidy',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      "Summons Numby to tag along in a Maze. Numby will automatically search for Basic Treasures and Trotters nearby. Using Technique will regenerate Energy for Topaz after Numby's first attack in the next battle.",
    desc: "Summons Numby when Topaz enters the overworld. Numby will automatically search for Basic Treasures and Trotters within a set radius.\nUsing her Technique will regenerate #1[i] Energy for Topaz after Numby's first attack in the next battle.\nIf Topaz is still in the team after using her Technique and defeating overworld enemies, a small bonus amount of credits will be added to the earned credits. A maximum of #2[i] bonus credits can be received per calendar day.\nAfter using her Technique and defeating enemies in Simulated Universe, additionally receive a small amount of Cosmic Fragments with a small chance to obtain 1 random Curio.",
    params: [[60, 10000]],
    icon: 'icon/skill/1112_technique.png'
  },
  121001: {
    id: '121001',
    name: 'Standing Ovation',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to a single enemy.',
    desc: "Deals Fire DMG equal to #1[i]% of Guinaifen's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1210_basic_atk.png'
  },
  121002: {
    id: '121002',
    name: 'Blazing Welcome',
    max_level: 15,
    element: 'Fire',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals Fire DMG to a single enemy and minor Fire DMG to adjacent enemies, with a high chance of Burning them.',
    desc: "Deals Fire DMG equal to #1[i]% of Guinaifen's ATK to a single enemy and deals Fire DMG equal to #2[i]% of Guinaifen's ATK to any adjacent enemies with a #3[i]% base chance to Burn the target and adjacent targets. When Burned, enemies will take a Fire DoT equal to #4[i]% of Guinaifen's ATK at the beginning of each turn, lasting for #5[i] turn(s).",
    params: [
      [0.6, 0.2, 1, 0.839, 2],
      [0.66, 0.22, 1, 0.923, 2],
      [0.72, 0.24, 1, 1.0069, 2],
      [0.78, 0.26, 1, 1.0909, 2],
      [0.84, 0.28, 1, 1.1748, 2],
      [0.9, 0.3, 1, 1.3007, 2],
      [0.975, 0.325, 1, 1.4686, 2],
      [1.05, 0.35, 1, 1.6784, 2],
      [1.125, 0.375, 1, 1.9303, 2],
      [1.2, 0.4, 1, 2.1821, 2],
      [1.26, 0.42, 1, 2.2912, 2],
      [1.32, 0.44, 1, 2.4003, 2],
      [1.38, 0.46, 1, 2.5094, 2],
      [1.44, 0.48, 1, 2.6186, 2],
      [1.5, 0.5, 1, 2.7277, 2]
    ],
    icon: 'icon/skill/1210_skill.png'
  },
  121003: {
    id: '121003',
    name: 'Watch This Showstopper',
    max_level: 15,
    element: 'Fire',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Deals Fire DMG to all enemies. If the enemies are inflicted with Burn, the Burn status deals DMG 1 extra time.',
    desc: "Deals Fire DMG equal to #1[i]% of Guinaifen's ATK to all enemies. If the target enemy is currently inflicted with Burn, then their Burn status immediately produce DMG equal to #2[i]% of their original DMG.",
    params: [
      [0.72, 0.72],
      [0.768, 0.74],
      [0.816, 0.76],
      [0.864, 0.78],
      [0.912, 0.8],
      [0.96, 0.82],
      [1.02, 0.845],
      [1.08, 0.87],
      [1.14, 0.895],
      [1.2, 0.92],
      [1.248, 0.94],
      [1.296, 0.96],
      [1.344, 0.98],
      [1.392, 1],
      [1.44, 1.02]
    ],
    icon: 'icon/skill/1210_ultimate.png'
  },
  121004: {
    id: '121004',
    name: 'PatrAeon Benefits',
    max_level: 15,
    element: 'Fire',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'After the Burn status causes DMG on the enemy, there is a high chance of applying Firekiss to the enemy.',
    desc: 'When Guinaifen is on the field, there is a #1[i]% base chance to apply Firekiss to an enemy after their Burn status causes DMG. While inflicted with Firekiss, the enemy receives #4[i]% increased DMG, which lasts for #5[i] turn(s) and can stack up to #6[i] time(s).',
    params: [
      [1, 0, 0, 0.04, 3, 3],
      [1, 0, 0, 0.043, 3, 3],
      [1, 0, 0, 0.046, 3, 3],
      [1, 0, 0, 0.049, 3, 3],
      [1, 0, 0, 0.052, 3, 3],
      [1, 0, 0, 0.055, 3, 3],
      [1, 0, 0, 0.0588, 3, 3],
      [1, 0, 0, 0.0625, 3, 3],
      [1, 0, 0, 0.0663, 3, 3],
      [1, 0, 0, 0.07, 3, 3],
      [1, 0, 0, 0.073, 3, 3],
      [1, 0, 0, 0.076, 3, 3],
      [1, 0, 0, 0.079, 3, 3],
      [1, 0, 0, 0.082, 3, 3],
      [1, 0, 0, 0.085, 3, 3]
    ],
    icon: 'icon/skill/1210_talent.png'
  },
  121006: {
    id: '121006',
    name: 'Attack',
    max_level: 1,
    element: 'Fire',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: "After attacking an enemy and entering battle, the enemy target's corresponding Type Toughness will be Weakened.",
    params: [],
    icon: 'icon/skill/1210_basic_atk.png'
  },
  121007: {
    id: '121007',
    name: 'Skill Showcase',
    max_level: 1,
    element: 'Fire',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, deals minor Fire DMG to a single target while applying Firekiss, with a total of 4 Bounces.',
    desc: "Immediately attacks the enemy. After entering battle, deals DMG for #2[i] time(s), dealing Fire DMG equal to #1[i]% of Guinaifen's ATK to a random single enemy target each time, with a #3[i]% base chance of inflicting Firekiss on them.",
    params: [[0.5, 4, 1]],
    icon: 'icon/skill/1210_technique.png'
  },
  121701: {
    id: '121701',
    name: 'Banner: Stormcaller',
    max_level: 9,
    element: 'Wind',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Wind DMG to a single enemy.',
    desc: "Deals Wind DMG equal to #1[i]% of Huohuo's Max HP to a target enemy.",
    params: [
      [0.25],
      [0.3],
      [0.35],
      [0.4],
      [0.45],
      [0.5],
      [0.55],
      [0.6],
      [0.65]
    ],
    icon: 'icon/skill/1210_basic_atk.png'
  },
  121702: {
    id: '121702',
    name: 'Talisman: Protection',
    max_level: 15,
    element: 'Wind',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      'Dispels 1 debuff from an ally and restore HP to that ally and their adjacent allies.',
    desc: "Dispels #5[i] debuff(s) from a single target ally and immediately restores this ally's HP by an amount equal to #1[i]% of Huohuo's Max HP plus #2[i]. At the same time, restores HP for allies that are adjacent to this target ally by an amount equal to #3[i]% of Huohuo's Max HP plus #4[i].",
    params: [
      [0.14, 140, 0.112, 112, 1],
      [0.14875, 224, 0.119, 179.2, 1],
      [0.1575, 287, 0.126, 229.6, 1],
      [0.16625, 350, 0.133, 280, 1],
      [0.175, 392, 0.14, 313.6, 1],
      [0.182, 434, 0.1456, 347.2, 1],
      [0.189, 465.5, 0.1512, 372.4, 1],
      [0.196, 497, 0.1568, 397.6, 1],
      [0.203, 528.5, 0.1624, 422.8, 1],
      [0.21, 560, 0.168, 448, 1],
      [0.217, 591.5, 0.1736, 473.2, 1],
      [0.224, 623, 0.1792, 498.4, 1],
      [0.231, 654.5, 0.1848, 523.6, 1],
      [0.238, 686, 0.1904, 548.8, 1],
      [0.245, 717.5, 0.196, 574, 1]
    ],
    icon: 'icon/skill/1210_skill.png'
  },
  121703: {
    id: '121703',
    name: 'Tail: Spiritual Domination',
    max_level: 15,
    element: 'Wind',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      'Regenerates Energy for all allies (excluding this character) and increases their ATK.',
    desc: 'Regenerates Energy for all allies (excluding this character) by an amount equal to #1[i]% of their respective Max Energy. At the same time, increases their ATK by #2[i]% for #3[i] turn(s).',
    params: [
      [0.15, 0.24, 2],
      [0.155, 0.256, 2],
      [0.16, 0.272, 2],
      [0.165, 0.288, 2],
      [0.17, 0.304, 2],
      [0.175, 0.32, 2],
      [0.18125, 0.34, 2],
      [0.1875, 0.36, 2],
      [0.19375, 0.38, 2],
      [0.2, 0.4, 2],
      [0.205, 0.416, 2],
      [0.21, 0.432, 2],
      [0.215, 0.448, 2],
      [0.22, 0.464, 2],
      [0.225, 0.48, 2]
    ],
    icon: 'icon/skill/1210_ultimate.png'
  },
  121704: {
    id: '121704',
    name: 'Possession: Ethereal Metaflow',
    max_level: 15,
    element: 'Wind',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc:
      'Huohuo gains Divine Provision after using her Skill. If Huohuo possesses Divine Provision when an allys turn starts or when an ally uses Ultimate, restores the allys HP. At the same time, every ally with low HP receives healing once When Divine Provision is triggered to heal an ally, dispel 1 debuff from that ally.',
    desc: "After using her Skill, Huohuo gains Divine Provision, lasting for <b>2</b> turn(s). This duration decreases by 1 turn at the start of each Huohuo's turn. If Huohuo has Divine Provision when an ally's turn starts or when an ally uses their Ultimate, restores HP for that ally by an amount equal to #1[i]% of Huohuo's Max HP plus #2[i]. At the same time, every ally with 50% HP or lower receives healing once.\nWhen Divine Provision is triggered to heal an ally, dispel <b>1</b> debuff(s) from that ally. This effect can be triggered up to <b>6</b> time(s). Using the skill again resets the effect's trigger count.",
    params: [
      [0.03, 30],
      [0.03188, 48],
      [0.03375, 61.5],
      [0.03563, 75],
      [0.0375, 84],
      [0.039, 93],
      [0.0405, 99.75],
      [0.042, 106.5],
      [0.0435, 113.25],
      [0.045, 120],
      [0.0465, 126.75],
      [0.048, 133.5],
      [0.0495, 140.25],
      [0.051, 147],
      [0.0525, 153.75]
    ],
    icon: 'icon/skill/1210_talent.png'
  },
  121707: {
    id: '121707',
    name: 'Fiend: Impeachment of Evil',
    max_level: 1,
    element: 'Wind',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: 'Impair',
    simple_desc:
      'Causes surrounding enemies to become Horror-Struck. After entering battle with enemies afflicted with Horror-Struck, there is a high chance applying ATK reduction on the enemy targets',
    desc: "Huohuo terrorizes surrounding enemies, afflicting Horror-Struck on them. Enemies in Horror-Struck will flee away from Huohuo for #4[i] second(s). When entering battle with enemies in Horror-Struck, there is a #1[i]% base chance of reducing every single enemy's ATK by #2[i]% for #3[i] turn(s)",
    params: [[1, 0.25, 2, 10]],
    icon: 'icon/skill/1210_technique.png'
  },
  121501: {
    id: '121501',
    name: 'Oracle Brush',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Physical DMG to a single enemy.',
    desc: "Deals Physical DMG equal to #1[i]% of Hanya's ATK to a single enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1215_basic_atk.png'
  },
  121502: {
    id: '121502',
    name: 'Samsara, Locked',
    max_level: 15,
    element: 'Physical',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Deals Physical DMG to a single enemy and applies Burden to them. For every 2 Basic ATKs, Skills, or Ultimates allies use on an enemy with Burden, allies recover 1 Skill Point.',
    desc: "Deals Physical DMG equal to #1[i]% of Hanya's ATK to a single enemy, then applies Burden to them.\nFor every 2 Basic ATKs, Skills, or Ultimates allies use on an enemy with Burden, allies will immediately recover 1 Skill Point. Burden is only active on the latest target it is applied to, and will be dispelled automatically after the Skill Point recovery effect has been triggered #2[i] times.",
    params: [
      [1.2, 2],
      [1.32, 2],
      [1.44, 2],
      [1.56, 2],
      [1.68, 2],
      [1.8, 2],
      [1.95, 2],
      [2.1, 2],
      [2.25, 2],
      [2.4, 2],
      [2.52, 2],
      [2.64, 2],
      [2.76, 2],
      [2.88, 2],
      [3, 2]
    ],
    icon: 'icon/skill/1215_skill.png'
  },
  121503: {
    id: '121503',
    name: "Ten-Lords' Decree, All Shall Obey",
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: "Increases an ally's SPD and ATK.",
    desc: "Increases the SPD of a target ally by #3[i]% of Hanya's SPD and increases the same target ally's ATK by #1[i]%, lasting for #2[i] turn(s).",
    params: [
      [0.36, 2, 0.15],
      [0.384, 2, 0.155],
      [0.408, 2, 0.16],
      [0.432, 2, 0.165],
      [0.456, 2, 0.17],
      [0.48, 2, 0.175],
      [0.51, 2, 0.1813],
      [0.54, 2, 0.1875],
      [0.57, 2, 0.1938],
      [0.6, 2, 0.2],
      [0.624, 2, 0.205],
      [0.648, 2, 0.21],
      [0.672, 2, 0.215],
      [0.696, 2, 0.22],
      [0.72, 2, 0.225]
    ],
    icon: 'icon/skill/1215_ultimate.png'
  },
  121504: {
    id: '121504',
    name: 'Sanction',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      'Ally deals more DMG when attacking enemies inflicted with Burden.',
    desc: 'When an ally uses a Basic ATK, Skill, or Ultimate on an enemy inflicted with Burden, the DMG dealt increases by #1[i]% for #2[i] turn(s).',
    params: [
      [0.15, 2],
      [0.165, 2],
      [0.18, 2],
      [0.195, 2],
      [0.21, 2],
      [0.225, 2],
      [0.2438, 2],
      [0.2625, 2],
      [0.2813, 2],
      [0.3, 2],
      [0.315, 2],
      [0.33, 2],
      [0.345, 2],
      [0.36, 2],
      [0.375, 2]
    ],
    icon: 'icon/skill/1215_talent.png'
  },
  121506: {
    id: '121506',
    name: 'Attack',
    max_level: 1,
    element: 'Physical',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1215_basic_atk.png'
  },
  121507: {
    id: '121507',
    name: 'Netherworld Judgment',
    max_level: 1,
    element: 'Physical',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, applies Burden equivalent to that applied by the Skill to a random enemy.',
    desc: 'Immediately attacks the enemy. After entering battle, applies Burden equivalent to that applied by the Skill to a random enemy.',
    params: [[0.8]],
    icon: 'icon/skill/1215_technique.png'
  },
  130201: {
    id: '130201',
    name: 'Fleeting Fragrance',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Physical DMG to a single enemy.',
    desc: "Deals Physical DMG equal to #1[i]% of Argenti's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1302_basic_atk.png'
  },
  130202: {
    id: '130202',
    name: 'Justice, Hereby Blooms',
    max_level: 15,
    element: 'Physical',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc: 'Deals minor Physical DMG to all enemies.',
    desc: "Deals Physical DMG equal to #1[i]% of Argenti's ATK to all enemies.",
    params: [
      [0.6],
      [0.66],
      [0.72],
      [0.78],
      [0.84],
      [0.9],
      [0.975],
      [1.05],
      [1.125],
      [1.2],
      [1.26],
      [1.32],
      [1.38],
      [1.44],
      [1.5]
    ],
    icon: 'icon/skill/1302_skill.png'
  },
  130203: {
    id: '130203',
    name: 'For In This Garden Supreme Beauty Bestows',
    max_level: 15,
    element: 'Physical',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc: 'Consumes #2[i] Energy and deals Physical DMG to all enemies.',
    desc: "Consumes #2[i] Energy and deals Physical DMG equal to #1[i]% of Argenti's ATK to all enemies.",
    params: [
      [0.96, 90],
      [1.024, 90],
      [1.088, 90],
      [1.152, 90],
      [1.216, 90],
      [1.28, 90],
      [1.36, 90],
      [1.44, 90],
      [1.52, 90],
      [1.6, 90],
      [1.664, 90],
      [1.728, 90],
      [1.792, 90],
      [1.856, 90],
      [1.92, 90]
    ],
    icon: 'icon/skill/1302_ultimate.png'
  },
  130204: {
    id: '130204',
    name: 'Sublime Object',
    max_level: 15,
    element: 'Physical',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'When Argenti uses his Basic ATK, Skill, or Ultimate, he regenerates Energy and increases his CRIT Rate for every enemy target hit.',
    desc: "For every enemy hit when Argenti uses his Basic Attack, Skill, or Ultimate, regenerates Argenti's Energy by #1[i], and grants him a stack of Apotheosis, increasing his CRIT Rate by #2[i]%. This effect can stack up to #3[i] time(s).",
    params: [
      [3, 0.01, 10],
      [3, 0.0115, 10],
      [3, 0.013, 10],
      [3, 0.0145, 10],
      [3, 0.016, 10],
      [3, 0.0175, 10],
      [3, 0.0194, 10],
      [3, 0.0213, 10],
      [3, 0.0231, 10],
      [3, 0.025, 10],
      [3, 0.0265, 10],
      [3, 0.028, 10],
      [3, 0.0295, 10],
      [3, 0.031, 10],
      [3, 0.0325, 10]
    ],
    icon: 'icon/skill/1302_talent.png'
  },
  130206: {
    id: '130206',
    name: 'Attack',
    max_level: 1,
    element: 'Physical',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attack an enemy, and when the battle starts, reduce their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1302_basic_atk.png'
  },
  130207: {
    id: '130207',
    name: 'Manifesto of Purest Virtue',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'Inflicts Daze on all enemies within a set area. When attacking a Dazed enemy to enter combat, deals minor Physical DMG to all enemies and regenerates energy for Argenti.',
    desc: "After using the Technique, enemies in a set area are inflicted with Daze for #1[i] second(s). Dazed enemies will not actively attack the team.\nWhen attacking a Dazed enemy to enter combat, deals Physical DMG to all enemies equal to #2[i]% of Argenti's ATK and regenerates his Energy by #3[i].",
    params: [[10, 0.8, 15]],
    icon: 'icon/skill/1302_technique.png'
  },
  130214: {
    id: '130214',
    name: 'Merit Bestowed in "My" Garden',
    max_level: 15,
    element: 'Physical',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Consumes #4[i] Energy and deals Physical DMG to all enemies and additionally deals minor Physical DMG to random single enemy targets for 6 Bounces.',
    desc: "Consumes #4[i] Energy and deals Physical DMG equal to #1[i]% of Argenti's ATK to all enemies, and further deals DMG for #2[i] extra time(s), with each time dealing Physical DMG equal to #3[i]% of Argenti's ATK to a random enemy.",
    params: [
      [1.68, 6, 0.57, 180],
      [1.792, 6, 0.608, 180],
      [1.904, 6, 0.646, 180],
      [2.016, 6, 0.684, 180],
      [2.128, 6, 0.722, 180],
      [2.24, 6, 0.76, 180],
      [2.38, 6, 0.8075, 180],
      [2.52, 6, 0.855, 180],
      [2.66, 6, 0.9025, 180],
      [2.8, 6, 0.95, 180],
      [2.912, 6, 0.988, 180],
      [3.024, 6, 1.026, 180],
      [3.136, 6, 1.064, 180],
      [3.248, 6, 1.102, 180],
      [3.36, 6, 1.14, 180]
    ],
    icon: 'icon/skill/1302_ultimate.png'
  },
  121401: {
    id: '121401',
    name: 'Mara-Sunder Awl',
    max_level: 9,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Quantum DMG to a single enemy.',
    desc: "Deals #1[i]% of Xueyi's ATK as Quantum DMG to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1214_basic_atk.png'
  },
  121402: {
    id: '121402',
    name: 'Iniquity Obliteration',
    max_level: 15,
    element: 'Quantum',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals Quantum DMG to a single enemy and minor Quantum DMG to enemies adjacent to it.',
    desc: "Deals Quantum DMG equal to #1[i]% of Xueyi's ATK to a single enemy, and Quantum DMG equal to #2[i]% of Xueyi's ATK to any adjacent enemies.",
    params: [
      [0.7, 0.35],
      [0.77, 0.385],
      [0.84, 0.42],
      [0.91, 0.455],
      [0.98, 0.49],
      [1.05, 0.525],
      [1.1375, 0.5688],
      [1.225, 0.6125],
      [1.3125, 0.6563],
      [1.4, 0.7],
      [1.47, 0.735],
      [1.54, 0.77],
      [1.61, 0.805],
      [1.68, 0.84],
      [1.75, 0.875]
    ],
    icon: 'icon/skill/1214_skill.png'
  },
  121403: {
    id: '121403',
    name: 'Divine Castigation',
    max_level: 15,
    element: 'Quantum',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      "Deals massive Quantum DMG to a single enemy. This attack ignores Weakness Types and reduces the target's Toughness. The more Toughness is reduced, the higher the DMG will be dealt.",
    desc: "Deals Quantum DMG equal to #1[i]% of Xueyi's ATK to a single target enemy. This attack ignores Weakness Types and reduces the enemy's Toughness. When the enemy's Weakness is Broken, the Quantum Weakness Break effect is triggered.\nIn this attack, the more Toughness is reduced, the higher the DMG will be dealt, up to a max of #3[i]% increase.",
    params: [
      [1.5, 0.09, 0.36],
      [1.6, 0.096, 0.384],
      [1.7, 0.102, 0.408],
      [1.8, 0.108, 0.432],
      [1.9, 0.114, 0.456],
      [2, 0.12, 0.48],
      [2.125, 0.1275, 0.51],
      [2.25, 0.135, 0.54],
      [2.375, 0.1425, 0.57],
      [2.5, 0.15, 0.6],
      [2.6, 0.156, 0.624],
      [2.7, 0.162, 0.648],
      [2.8, 0.168, 0.672],
      [2.9, 0.174, 0.696],
      [3, 0.18, 0.72]
    ],
    icon: 'icon/skill/1214_ultimate.png'
  },
  121404: {
    id: '121404',
    name: 'Karmic Perpetuation',
    max_level: 15,
    element: 'Quantum',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Bounce',
    effect_text: 'Bounce',
    simple_desc:
      'When Xueyi or her allies reduce enemy Toughness with attacks, she gains stacks of Karma. When Karma reaches the max number of stacks, immediately launches a follow-up attack, dealing minor Quantum DMG to a single enemy target, bouncing for 3 times and consuming all Karma.',
    desc: "When Xueyi reduces enemy Toughness with attacks, Karma will be stacked. The more Toughness is reduced, the more stacks of Karma are added, up to #1[i] stacks.\nWhen Xueyi's allies reduce enemy Toughness with attacks, Xueyi gains #3[i] stacks of Karma.\nWhen Karma reaches the max number of stacks, consumes all current Karma stacks and immediately launches a follow-up attack against an enemy target, dealing DMG for 3 times, with each time dealing Quantum DMG equal to #2[i]% of Xueyi's ATK to a single random enemy. This follow-up attack will not add Karma stacks.",
    params: [
      [8, 0.45, 1],
      [8, 0.495, 1],
      [8, 0.54, 1],
      [8, 0.585, 1],
      [8, 0.63, 1],
      [8, 0.675, 1],
      [8, 0.7313, 1],
      [8, 0.7875, 1],
      [8, 0.8438, 1],
      [8, 0.9, 1],
      [8, 0.945, 1],
      [8, 0.99, 1],
      [8, 1.035, 1],
      [8, 1.08, 1],
      [8, 1.125, 1]
    ],
    icon: 'icon/skill/1214_talent.png'
  },
  121406: {
    id: '121406',
    name: 'Attack',
    max_level: 1,
    element: 'Quantum',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attacks an enemy, and when the battle starts, reduces their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1214_basic_atk.png'
  },
  121407: {
    id: '121407',
    name: 'Summary Execution',
    max_level: 1,
    element: 'Quantum',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Attacks the enemy. After entering battle, deals minor Quantum DMG to all enemies.',
    desc: "Immediately attacks the enemy. After entering combat, deals #1[i]% of Xueyi's ATK as Quantum DMG to all enemies.",
    params: [[0.8]],
    icon: 'icon/skill/1214_technique.png'
  },
  130301: {
    id: '130301',
    name: 'Threading Fragrance',
    max_level: 9,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Ice DMG to a single enemy.',
    desc: "Deals Ice DMG equal to #1[i]% of Ruan Mei's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1303_basic_atk.png'
  },
  130302: {
    id: '130302',
    name: 'String Sings Slow Swirls',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      "After using her Skill, Ruan Mei gains Overtone. When Ruan Mei has Overtone, increase all allies' DMG and Weakness Break efficiency.",
    desc: "After using her Skill, Ruan Mei gains Overtone, lasting for #3[i] turn(s). This duration decreases by 1 at the start of Ruan Mei's turn. When Ruan Mei has Overtone, all allies' DMG increases by #1[i]% and Weakness Break Efficiency increases by #2[i]%.",
    params: [
      [0.16, 0.5, 3],
      [0.176, 0.5, 3],
      [0.192, 0.5, 3],
      [0.208, 0.5, 3],
      [0.224, 0.5, 3],
      [0.24, 0.5, 3],
      [0.26, 0.5, 3],
      [0.28, 0.5, 3],
      [0.3, 0.5, 3],
      [0.32, 0.5, 3],
      [0.336, 0.5, 3],
      [0.352, 0.5, 3],
      [0.368, 0.5, 3],
      [0.384, 0.5, 3],
      [0.4, 0.5, 3]
    ],
    icon: 'icon/skill/1303_skill.png'
  },
  130303: {
    id: '130303',
    name: 'Petals to Stream, Repose in Dream',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      'Increases All-Type RES PEN for all allies, and their attacks apply Thanatoplum Rebloom to enemies hit.',
    desc: "Ruan Mei deploys a field that lasts for #2[i] turns. The field's duration decreases by 1 at the start of her turn.\nWhile inside the field, all allies' All-Type RES PEN increases by #1[i]% and their attacks apply Thanatoplum Rebloom to the enemies hit.\nWhen these enemies attempt to recover from Weakness Break, Thanatoplum Rebloom is triggered, extending the duration of their Weakness Break, delaying their action by an amount equal to #3[i]% of Ruan Mei's Break Effect plus #4[i]%, and dealing Break DMG equal to #5[i]% of Ruan Mei's Ice Break DMG.\nEnemy targets cannot have Thanatoplum Rebloom re-applied to them until they recover from Weakness Break.",
    params: [
      [0.15, 2, 0.2, 0.1, 0.3],
      [0.16, 2, 0.2, 0.1, 0.32],
      [0.17, 2, 0.2, 0.1, 0.34],
      [0.18, 2, 0.2, 0.1, 0.36],
      [0.19, 2, 0.2, 0.1, 0.38],
      [0.2, 2, 0.2, 0.1, 0.4],
      [0.2125, 2, 0.2, 0.1, 0.425],
      [0.225, 2, 0.2, 0.1, 0.45],
      [0.2375, 2, 0.2, 0.1, 0.475],
      [0.25, 2, 0.2, 0.1, 0.5],
      [0.26, 2, 0.2, 0.1, 0.52],
      [0.27, 2, 0.2, 0.1, 0.54],
      [0.28, 2, 0.2, 0.1, 0.56],
      [0.29, 2, 0.2, 0.1, 0.58],
      [0.3, 2, 0.2, 0.1, 0.6]
    ],
    icon: 'icon/skill/1303_ultimate.png'
  },
  130304: {
    id: '130304',
    name: 'Somatotypical Helix',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      "Increases SPD for all allies (excluding this character). Breaking an enemy target's Weakness will additionally deal Ice Break DMG.",
    desc: "Increases SPD by #1[i]% for the team (excluding this character). When allies Break an enemy target's Weakness, Ruan Mei deals to this enemy target Break DMG equal to #2[i]% of her Ice Break DMG.",
    params: [
      [0.08, 0.6],
      [0.082, 0.66],
      [0.084, 0.72],
      [0.086, 0.78],
      [0.088, 0.84],
      [0.09, 0.9],
      [0.0925, 0.975],
      [0.095, 1.05],
      [0.0975, 1.125],
      [0.1, 1.2],
      [0.102, 1.26],
      [0.104, 1.32],
      [0.106, 1.38],
      [0.108, 1.44],
      [0.11, 1.5]
    ],
    icon: 'icon/skill/1303_talent.png'
  },
  130306: {
    id: '130306',
    name: 'Attack',
    max_level: 1,
    element: 'Ice',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attacks an enemy, and when the battle starts, reduces their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1303_basic_atk.png'
  },
  130307: {
    id: '130307',
    name: 'Silken Serenade',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'The next time entering battle, automatically triggers the Skill for #1[i] time(s). After using the Technique, allies attacking enemies in Simulated Universe will always be regarded as attacking their Weakness to enter battle, and their Toughness is reduced regardless of Weakness types. For every Blessing in possession, increases Toughness-Reducing DMG and additionally deals Break DMG when breaking Weakness.',
    desc: "After using the Technique, gains Silken Serenade. At the start of the next battle, automatically triggers the Skill for #1[i] time(s) without consuming Skill Points.\nIn Simulated Universe, when Ruan Mei has Silken Serenade, the team actively attacking enemies will always be regarded as attacking their Weakness to enter battle, and this attack can reduce all enemies' Toughness regardless of Weakness types. When breaking Weakness, triggers Weakness Break Effect corresponding to the attacker's Type. For every Blessing in possession up to #4[i] Blessing(s), additionally increases the Toughness-Reducing DMG of this attack by #2[i]%. After breaking an enemy target's Weakness, additionally deals to the enemy target Break DMG equal to #3[i]% of Ruan Mei's Ice Break DMG.",
    params: [[1, 1, 1, 20]],
    icon: 'icon/skill/1303_technique.png'
  },
  130501: {
    id: '130501',
    name: 'Mind is Might',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Imaginary DMG to a single target enemy.',
    desc: "Deals Imaginary DMG equal to #1[i]% of Dr. Ratio's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1305_basic_atk.png'
  },
  130502: {
    id: '130502',
    name: 'Intellectual Midwifery',
    max_level: 15,
    element: 'Imaginary',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals Imaginary DMG to a single enemy.',
    desc: "Deals Imaginary DMG equal to #1[i]% of Dr. Ratio's ATK to a single target enemy.",
    params: [
      [0.75],
      [0.825],
      [0.9],
      [0.975],
      [1.05],
      [1.125],
      [1.2188],
      [1.3125],
      [1.4063],
      [1.5],
      [1.575],
      [1.65],
      [1.725],
      [1.8],
      [1.875]
    ],
    icon: 'icon/skill/1305_skill.png'
  },
  130503: {
    id: '130503',
    name: 'Syllogistic Paradox',
    max_level: 15,
    element: 'Imaginary',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      "Deals Imaginary DMG to a single target enemy and applies Wiseman's Folly. When Dr. Ratio's allies attack a target afflicted with Wiseman's Folly, Dr. Ratio launches 1 follow-up attack on this target.",
    desc: "Deals Imaginary DMG equal to #1[i]% of Dr. Ratio's ATK to a single target enemy and applies Wiseman's Folly. When Dr. Ratio's allies attack a target afflicted with Wiseman's Folly, Dr. Ratio launches his Talent's follow-up attack for 1 time against this target.\nWiseman's Folly can be triggered for up to #2[i] times and only affects the most recent target of Dr. Ratio's Ultimate. This trigger count resets after Dr. Ratio's Ultimate is used.",
    params: [
      [1.44, 2],
      [1.536, 2],
      [1.632, 2],
      [1.728, 2],
      [1.824, 2],
      [1.92, 2],
      [2.04, 2],
      [2.16, 2],
      [2.28, 2],
      [2.4, 2],
      [2.496, 2],
      [2.592, 2],
      [2.688, 2],
      [2.784, 2],
      [2.88, 2]
    ],
    icon: 'icon/skill/1305_ultimate.png'
  },
  130504: {
    id: '130504',
    name: 'Cogito, Ergo Sum',
    max_level: 15,
    element: 'Imaginary',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'When using the Skill, there is a chance of launching a follow-up attack against the target for 1 time.',
    desc: "When using his Skill, Dr. Ratio has a #2[i]% fixed chance of launching a follow-up attack against his target for 1 time, dealing Imaginary DMG equal to #1[i]% of Dr. Ratio's ATK. For each debuff the target enemy has, the fixed chance of launching follow-up attack increases by #3[i]%. If the target enemy is defeated before the follow-up attack triggers, the follow-up attack will be directed at a single random enemy instead.",
    params: [
      [1.35, 0.4, 0.2],
      [1.485, 0.4, 0.2],
      [1.62, 0.4, 0.2],
      [1.755, 0.4, 0.2],
      [1.89, 0.4, 0.2],
      [2.025, 0.4, 0.2],
      [2.1938, 0.4, 0.2],
      [2.3625, 0.4, 0.2],
      [2.5313, 0.4, 0.2],
      [2.7, 0.4, 0.2],
      [2.835, 0.4, 0.2],
      [2.97, 0.4, 0.2],
      [3.105, 0.4, 0.2],
      [3.24, 0.4, 0.2],
      [3.375, 0.4, 0.2]
    ],
    icon: 'icon/skill/1305_talent.png'
  },
  130506: {
    id: '130506',
    name: 'Attack',
    max_level: 1,
    element: 'Imaginary',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attacks an enemy, and when the battle starts, reduces their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1305_basic_atk.png'
  },
  130507: {
    id: '130507',
    name: 'Mold of Idolatry',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'Creates a special dimension. Enemies within the dimension are Taunted. After entering battle with enemies in this dimension, there is a high chance to reduce SPD of enemy targets.',
    desc: "After using Technique, creates a special dimension that Taunts nearby enemies, lasting for #1[i] second(s). After entering battle with enemies in this special dimension, there is a #2[i]% base chance to reduce each single enemy target's SPD by #3[i]% for #4[i] turn(s). Only 1 dimension created by allies can exist at the same time.",
    params: [[10, 1, 0.15, 2]],
    icon: 'icon/skill/1305_technique.png'
  },
  130701: {
    id: '130701',
    name: 'Percipience, Silent Dawn',
    max_level: 9,
    element: 'Wind',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Deals minor Wind DMG to a single enemy and has a chance of applying Arcana to the target. After targets are inflicted with Wind Shear, Bleed, Burn, or Shock, each respectively has a chance of additionally applying Arcana.',
    desc: "Deals Wind DMG equal to #1[i]% of Black Swan's ATK to a single target enemy, with a #2[i]% base chance of inflicting 1 stack of Arcana. And if the hit target currently has Wind Shear, Bleed, Burn, or Shock applied to them, each respectively has a #3[i]% base chance of inflicting 1 extra stack of Arcana onto the enemy.",
    params: [
      [0.3, 0.5, 0.5],
      [0.36, 0.53, 0.53],
      [0.42, 0.56, 0.56],
      [0.48, 0.59, 0.59],
      [0.54, 0.62, 0.62],
      [0.6, 0.65, 0.65],
      [0.66, 0.68, 0.68],
      [0.72, 0.71, 0.71],
      [0.78, 0.74, 0.74]
    ],
    icon: 'icon/skill/1307_basic_atk.png'
  },
  130702: {
    id: '130702',
    name: 'Decadence, False Twilight',
    max_level: 15,
    element: 'Wind',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      "Deals minor Wind DMG to a single enemy target and any adjacent targets, with a high chance of inflicting Arcana and lowering the targets' DEF.",
    desc: "Deals Wind DMG equal to #1[i]% of Black Swan's ATK to a single target enemy and any adjacent targets. At the same time, there is a #2[i]% base chance of inflicting 1 stack of Arcana on the target enemy and the adjacent targets. And there is a #3[i]% base chance of reducing the DEF of the target enemy and the adjacent targets by #4[i]%, lasting for #5[i] turn(s).",
    params: [
      [0.45, 1, 1, 0.148, 3],
      [0.495, 1, 1, 0.154, 3],
      [0.54, 1, 1, 0.16, 3],
      [0.585, 1, 1, 0.166, 3],
      [0.63, 1, 1, 0.172, 3],
      [0.675, 1, 1, 0.178, 3],
      [0.7312, 1, 1, 0.1855, 3],
      [0.7875, 1, 1, 0.193, 3],
      [0.8438, 1, 1, 0.2005, 3],
      [0.9, 1, 1, 0.208, 3],
      [0.945, 1, 1, 0.214, 3],
      [0.99, 1, 1, 0.22, 3],
      [1.035, 1, 1, 0.226, 3],
      [1.08, 1, 1, 0.232, 3],
      [1.125, 1, 1, 0.238, 3]
    ],
    icon: 'icon/skill/1307_skill.png'
  },
  130703: {
    id: '130703',
    name: "Bliss of Otherworld's Embrace",
    max_level: 15,
    element: 'Wind',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Inflicts Epiphany on all enemies. Affected enemies take more DMG in their turn, and their Arcana effect is regarded as Wind Shear, Bleed, Burn, and Shock effects. In addition, when their Arcana effect is triggered at the beginning of the next turn, the Arcana stacks are not reset. Deals Wind DMG to all enemies.',
    desc: "Inflicts Epiphany on all enemies for #2[i] turn(s).\nEnemies affected by Epiphany take #3[i]% more DMG in their turn, and their Arcana effect is regarded as Wind Shear, Bleed, Burn, and Shock effects. In addition, when their Arcana effect is triggered at the beginning of the next turn, the Arcana stacks are not reset. The stack non-reset effect can be triggered up to #4[i] time(s) in Epiphany's duration, and its charges are replenished when Epiphany is applied again.\nDeals Wind DMG equal to #1[i]% of Black Swan's ATK to all enemies.",
    params: [
      [0.72, 2, 0.15, 1],
      [0.768, 2, 0.16, 1],
      [0.816, 2, 0.17, 1],
      [0.864, 2, 0.18, 1],
      [0.912, 2, 0.19, 1],
      [0.96, 2, 0.2, 1],
      [1.02, 2, 0.2125, 1],
      [1.08, 2, 0.225, 1],
      [1.14, 2, 0.2375, 1],
      [1.2, 2, 0.25, 1],
      [1.248, 2, 0.26, 1],
      [1.296, 2, 0.27, 1],
      [1.344, 2, 0.28, 1],
      [1.392, 2, 0.29, 1],
      [1.44, 2, 0.3, 1]
    ],
    icon: 'icon/skill/1307_ultimate.png'
  },
  130704: {
    id: '130704',
    name: "Loom of Fate's Caprice",
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'When an enemy target receives DoT at the start of each turn, there is a chance for it to be inflicted with Arcana. They receive Wind DoT at the start of the turn, and Black Swan triggers additional effects based on the number of Arcana stacks.',
    desc: "Every time an enemy target receives DoT at the start of each turn, there is a #2[i]% base chance for it to be inflicted with Arcana.\nWhile afflicted with Arcana, enemy targets receive Wind DoT equal to #1[i]% of Black Swan's ATK at the start of each turn. Each stack of Arcana increases this DoT DMG multiplier by #3[i]%. Then Arcana resets to 1 stack. Arcana can stack up to #8[i] times.\nOnly when Arcana causes DMG at the start of an enemy target's turn, Black Swan triggers additional effects based on the number of Arcana stacks inflicted on the target:\nWhen there are #4[i] or more Arcana stacks, deals Wind DoT equal to #5[i]% of Black Swan's ATK to adjacent targets, with a #2[i]% base chance of inflicting 1 stack of Arcana on adjacent targets.\nWhen there are #6[i] or more Arcana stacks, enables the current DoT dealt this time to ignore #7[i]% of the target's and adjacent targets' DEF.",
    params: [
      [0.96, 0.5, 0.048, 3, 0.72, 7, 0.2, 50],
      [1.1184, 0.515, 0.0559, 3, 0.8388, 7, 0.2, 50],
      [1.2768, 0.53, 0.0638, 3, 0.9576, 7, 0.2, 50],
      [1.4352, 0.545, 0.0718, 3, 1.0764, 7, 0.2, 50],
      [1.5936, 0.56, 0.0797, 3, 1.1952, 7, 0.2, 50],
      [1.752, 0.575, 0.0876, 3, 1.314, 7, 0.2, 50],
      [1.896, 0.5938, 0.0948, 3, 1.422, 7, 0.2, 50],
      [2.04, 0.6125, 0.102, 3, 1.53, 7, 0.2, 50],
      [2.22, 0.6312, 0.111, 3, 1.665, 7, 0.2, 50],
      [2.4, 0.65, 0.12, 3, 1.8, 7, 0.2, 50],
      [2.52, 0.665, 0.126, 3, 1.89, 7, 0.2, 50],
      [2.64, 0.68, 0.132, 3, 1.98, 7, 0.2, 50],
      [2.76, 0.695, 0.138, 3, 2.07, 7, 0.2, 50],
      [2.88, 0.71, 0.144, 3, 2.16, 7, 0.2, 50],
      [3, 0.725, 0.15, 3, 2.25, 7, 0.2, 50]
    ],
    icon: 'icon/skill/1307_talent.png'
  },
  130706: {
    id: '130706',
    name: 'Attack',
    max_level: 1,
    element: 'Wind',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attacks an enemy, and when the battle starts, reduces their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1307_basic_atk.png'
  },
  130707: {
    id: '130707',
    name: 'From Façade to Vérité',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'After this Technique is used, at the start of the next battle, there is a high chance for each enemy to be inflicted with Arcana repeatedly until Arcana fails to be inflicted.',
    desc: 'After this Technique is used, there is a #1[i]% base chance for each enemy to be inflicted with 1 stack of Arcana at the start of the next battle. For each successful application of Arcana on a target, inflicts another stack of Arcana on the same target. This process repeats until Arcana fails to be inflicted on this target. For each successive application of Arcana on a target, its base chance of success is equal to #2[i]% of the base chance of the previous successful infliction of Arcana on that target.',
    params: [[1.5, 0.5]],
    icon: 'icon/skill/1307_technique.png'
  },
  131201: {
    id: '131201',
    name: 'E—Excuse Me, Please!',
    max_level: 9,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Ice DMG to a single enemy.',
    desc: "Deals Ice DMG equal to #1[i]% of Misha's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1312_basic_atk.png'
  },
  131202: {
    id: '131202',
    name: 'R—Room Service',
    max_level: 15,
    element: 'Ice',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      "Deals Ice DMG to an enemy and minor Ice DMG to enemies adjacent to them. In addition, increase Misha's next Ultimate's Hit Per Action.",
    desc: "Increases the Hits Per Action for Misha's next Ultimate by #3[i] hit(s). Deals Ice DMG equal to #1[i]% of Misha's ATK to a single target enemy, and Ice DMG equal to #2[i]% of Misha's ATK to adjacent targets.",
    params: [
      [1, 0.4, 1],
      [1.1, 0.44, 1],
      [1.2, 0.48, 1],
      [1.3, 0.52, 1],
      [1.4, 0.56, 1],
      [1.5, 0.6, 1],
      [1.625, 0.65, 1],
      [1.75, 0.7, 1],
      [1.875, 0.75, 1],
      [2, 0.8, 1],
      [2.1, 0.84, 1],
      [2.2, 0.88, 1],
      [2.3, 0.92, 1],
      [2.4, 0.96, 1],
      [2.5, 1, 1]
    ],
    icon: 'icon/skill/1312_skill.png'
  },
  131203: {
    id: '131203',
    name: 'G—Gonna Be Late!',
    max_level: 15,
    element: 'Ice',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Bounce',
    effect_text: 'Bounce',
    simple_desc:
      'Deals minor Ice DMG to single enemies. The attack bounces among enemies #1[i] times by default and up to a maximum of #5[i] times. Before each hits land, there is a minor chance to Freeze the target.',
    desc: "Has #1[i] Hits Per Action by default. First, uses 1 hit to deal Ice DMG equal to #2[i]% of Misha's ATK to a single target enemy. Then, the rest of the hits each deals Ice DMG equal to #2[i]% of Misha's ATK to a single random enemy. Just before each hit lands, there is a #3[i]% base chance to Freeze the target, lasting for 1 turn.\nWhile Frozen, enemy targets cannot take any actions, and at the start of their turn, they receive Additional Ice DMG equal to #4[i]% of Misha's ATK.\nThis Ultimate can possess up to #5[i] Hits Per Action. After the Ultimate is used, its Hits Per Action will be reset to the default level.",
    params: [
      [3, 0.36, 0.12, 0.18, 10],
      [3, 0.384, 0.128, 0.192, 10],
      [3, 0.408, 0.136, 0.204, 10],
      [3, 0.432, 0.144, 0.216, 10],
      [3, 0.456, 0.152, 0.228, 10],
      [3, 0.48, 0.16, 0.24, 10],
      [3, 0.51, 0.17, 0.255, 10],
      [3, 0.54, 0.18, 0.27, 10],
      [3, 0.57, 0.19, 0.285, 10],
      [3, 0.6, 0.2, 0.3, 10],
      [3, 0.624, 0.208, 0.312, 10],
      [3, 0.648, 0.216, 0.324, 10],
      [3, 0.672, 0.224, 0.336, 10],
      [3, 0.696, 0.232, 0.348, 10],
      [3, 0.72, 0.24, 0.36, 10]
    ],
    icon: 'icon/skill/1312_ultimate.png'
  },
  131204: {
    id: '131204',
    name: 'Horological Escapement',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      "Whenever any ally consumes 1 Skill Point, Misha's next Ultimate delivers more Hits Per Action and Misha regenerates his Energy.",
    desc: "Whenever any ally consumes 1 Skill Point, Misha's next Ultimate delivers #2[i] more Hit(s) Per Action and Misha regenerates #1[i] Energy.",
    params: [
      [1, 1],
      [1.1, 1],
      [1.2, 1],
      [1.3, 1],
      [1.4, 1],
      [1.5, 1],
      [1.625, 1],
      [1.75, 1],
      [1.875, 1],
      [2, 1],
      [2.1, 1],
      [2.2, 1],
      [2.3, 1],
      [2.4, 1],
      [2.5, 1]
    ],
    icon: 'icon/skill/1312_talent.png'
  },
  131206: {
    id: '131206',
    name: 'Attack',
    max_level: 1,
    element: 'Ice',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attacks an enemy, and when the battle starts, reduces their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1312_basic_atk.png'
  },
  131207: {
    id: '131207',
    name: 'Wait, You Are So Beautiful!',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      "Creates a dimension that stops all enemies within. Upon entering battle against enemies within the dimension, Misha's next Ultimate deals more Hits Per Action.",
    desc: "After using the Technique, creates a dimension that lasts for #1[i] seconds. Enemies caught in the dimension are inflicted with Dream Prison and stop all their actions. Upon entering battle against enemies afflicted with Dream Prison, increases the Hits Per Action for Misha's next Ultimate by #2[i] hit(s). Only 1 dimension created by allies can exist at the same time.",
    params: [[15, 2]],
    icon: 'icon/skill/1312_technique.png'
  },
  130601: {
    id: '130601',
    name: 'Monodrama',
    max_level: 9,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Quantum DMG to a single enemy.',
    desc: "Deals Quantum DMG equal to #1[i]% of Sparkle's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1306_basic_atk.png'
  },
  130602: {
    id: '130602',
    name: 'Dreamdiver',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      "Increases an ally's CRIT DMG and Advances Forward their action.",
    desc: "Increases the CRIT DMG of a single target ally by #1[i]% of Sparkle's CRIT DMG plus #2[i]%, lasting for #3[i] turn(s). And at the same time, Advances Forward this ally's action by #4[i]%.\nWhen Sparkle uses this ability on herself, the Action Advance effect will not trigger.",
    params: [
      [0.12, 0.27, 1, 0.5],
      [0.132, 0.288, 1, 0.5],
      [0.144, 0.306, 1, 0.5],
      [0.156, 0.324, 1, 0.5],
      [0.168, 0.342, 1, 0.5],
      [0.18, 0.36, 1, 0.5],
      [0.195, 0.3825, 1, 0.5],
      [0.21, 0.405, 1, 0.5],
      [0.225, 0.4275, 1, 0.5],
      [0.24, 0.45, 1, 0.5],
      [0.252, 0.468, 1, 0.5],
      [0.264, 0.486, 1, 0.5],
      [0.276, 0.504, 1, 0.5],
      [0.288, 0.522, 1, 0.5],
      [0.3, 0.54, 1, 0.5]
    ],
    icon: 'icon/skill/1306_skill.png'
  },
  130603: {
    id: '130603',
    name: 'The Hero with a Thousand Faces',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      "Recovers Skill Points for the team, and enables the DMG Boost provided by Sparkle's Talent to be additionally enhanced.",
    desc: "Recovers #2[i] Skill Points for the team and grants all allies Cipher. For allies with Cipher, each stack of the DMG Boost effect provided by Sparkle's Talent additionally increases by #3[i]%, lasting for #4[i] turns.",
    params: [
      [2, 4, 0.06, 2],
      [2, 4, 0.064, 2],
      [2, 4, 0.068, 2],
      [2, 4, 0.072, 2],
      [2, 4, 0.076, 2],
      [2, 4, 0.08, 2],
      [2, 4, 0.085, 2],
      [2, 4, 0.09, 2],
      [2, 4, 0.095, 2],
      [2, 4, 0.1, 2],
      [2, 4, 0.104, 2],
      [2, 4, 0.108, 2],
      [2, 4, 0.112, 2],
      [2, 4, 0.116, 2],
      [2, 4, 0.12, 2]
    ],
    icon: 'icon/skill/1306_ultimate.png'
  },
  130604: {
    id: '130604',
    name: 'Red Herring',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      "Increases the team's Max Skill Points. Whenever an ally consumes Skill Points, enables all allies to deal more damage.",
    desc: "While Sparkle is on the battlefield, additionally increases the max number of Skill Points by #3[i]. Whenever an ally consumes 1 Skill Point, all allies' DMG dealt increases by #2[i]%. This effect lasts for #1[i] turn(s) and can stack up to #4[i] time(s).",
    params: [
      [2, 0.03, 2, 3],
      [2, 0.033, 2, 3],
      [2, 0.036, 2, 3],
      [2, 0.039, 2, 3],
      [2, 0.042, 2, 3],
      [2, 0.045, 2, 3],
      [2, 0.0488, 2, 3],
      [2, 0.0525, 2, 3],
      [2, 0.0563, 2, 3],
      [2, 0.06, 2, 3],
      [2, 0.063, 2, 3],
      [2, 0.066, 2, 3],
      [2, 0.069, 2, 3],
      [2, 0.072, 2, 3],
      [2, 0.075, 2, 3]
    ],
    icon: 'icon/skill/1306_talent.png'
  },
  130606: {
    id: '130606',
    name: 'Attack',
    max_level: 1,
    element: 'Quantum',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attacks an enemy, and when the battle starts, reduces their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1306_basic_atk.png'
  },
  130607: {
    id: '130607',
    name: 'Unreliable Narrator',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      'Using the Technique grants all allies Misdirect. Characters with Misdirect will not be detected by enemies, and entering battle while in Misdirect recovers Skill Points for allies.',
    desc: 'Using the Technique grants all allies Misdirect for #2[i] seconds. Characters with Misdirect will not be detected by enemies, and entering battle in the Misdirect state recovers #1[i] Skill Point(s) for the team.',
    params: [[3, 20]],
    icon: 'icon/skill/1306_technique.png'
  },
  140001: {
    id: '140001',
    name: 'Trilateral Wiltcross',
    max_level: 9,
    element: 'Lightning',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Lightning DMG to a single enemy.',
    desc: "Deals Lightning DMG equal to #1[i]% of Acheron's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1306_basic_atk.png'
  },
  140002: {
    id: '140002',
    name: 'Octobolt Flash',
    max_level: 15,
    element: 'Lightning',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc: '',
    desc: "Gains 1 point(s) of Slashed Dream. Inflicts 1 stack(s) of Crimson Knot on a single target enemy, dealing Lightning DMG equal to #1[i]% of Acheron's ATK to this target, as well as Lightning DMG equal to #2[i]% of Acheron's ATK to adjacent targets.",
    params: [
      [0.8, 0.3],
      [0.88, 0.33],
      [0.96, 0.36],
      [1.04, 0.39],
      [1.12, 0.42],
      [1.2, 0.45],
      [1.3, 0.4875],
      [1.4, 0.525],
      [1.5, 0.5625],
      [1.6, 0.6],
      [1.68, 0.63],
      [1.76, 0.66],
      [1, 1],
      [1, 1],
      [1, 1]
    ],
    icon: 'icon/skill/1306_skill.png'
  },
  140003: {
    id: '140003',
    name: 'Slashed Dream Cries in Red',
    max_level: 15,
    element: 'Lightning',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoE',
    effect_text: 'AoE',
    simple_desc: '',
    desc: "Sequentially unleash Rainblade 3 times and Stygian Resurge 1 time, dealing Lightning DMG up to #1[i]% of Acheron's ATK to a single target enemy, as well as Lightning DMG up to #2[i]% of Acheron's ATK to other targets.\nRainblade: Deals Lightning DMG equal to #3[i]% of Acheron's ATK to a single target enemy and removes up to 3 stacks of Crimson Knot from the target. When Crimson Knot is removed, immediately deals Lightning DMG equal to #4[i]% of Acheron's ATK to all enemies. For every stack of Crimson Knot removed, the DMG Multiplier for this is additionally increased, up to a maximum of #5[i]%.\nStygian Resurge: Deals Lightning DMG equal to #6[i]% of Acheron's ATK to all enemies and remove all Crimson Knots.\nCrimson Knot cannot be applied to enemies during the Ultimate.",
    params: [
      [2.232, 1.8, 0.144, 0.09, 0.36, 0.72],
      [2.3808, 1.92, 0.1536, 0.096, 0.384, 0.768],
      [2.5296, 2.04, 0.1632, 0.102, 0.408, 0.816],
      [2.6784, 2.16, 0.1728, 0.108, 0.432, 0.864],
      [2.8272, 2.28, 0.1824, 0.114, 0.456, 0.912],
      [2.976, 2.4, 0.192, 0.12, 0.48, 0.96],
      [3.162, 2.55, 0.204, 0.1275, 0.51, 1.02],
      [3.34, 2.7, 0.216, 0.135, 0.54, 1.08],
      [3.534, 2.85, 0.228, 0.1425, 0.57, 1.14],
      [3.72, 3.0, 0.24, 0.15, 0.6, 1.2],
      [3.8688, 3.12, 0.2496, 0.156, 0.624, 1.248],
      [4.0176, 3.24, 0.2592, 0.162, 0.648, 1.296],
      [1, 1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1, 1]
    ],
    icon: 'icon/skill/1306_ultimate.png'
  },
  140004: {
    id: '140004',
    name: 'Atop Rainleaf Hangs Oneness',
    max_level: 15,
    element: 'Lightning',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "When Slashed Dream reaches 9 point(s), the Ultimate can be activated. During the Ultimate, reduces enemies' Toughness regardless of Weakness Types and reduces all enemies' All-Type RES by #1[i]%, lasting until the end of the Ultimate.\nWhen any unit inflicts debuffs on an enemy target while using their ability, Acheron gains 1 point of Slashed Dream and inflicts 1 stack of Crimson Knot on the target. If debuffs are inflicted on multiple targets, then the 1 stack of Crimson Knot will be inflicted on the enemy target with the most Crimson Knot stacks. This effect can only trigger once per every ability usage.\nAfter an enemy target exits the field or gets defeated by any unit while Acheron is on the field, their Crimson Knot stacks will be transferred to the enemy target with the most Crimson Knot stacks on the whole field.",
    params: [
      [0.1, 1],
      [0.1, 1],
      [0.12, 1],
      [0.13, 1],
      [0.14, 1],
      [0.15, 1],
      [0.1625, 1],
      [0.175, 1],
      [0.1875, 1],
      [0.2, 1],
      [0.21, 1],
      [0.22, 1],
      [1, 1],
      [1, 1],
      [1, 1]
    ],
    icon: 'icon/skill/1306_talent.png'
  },
  140007: {
    id: '140007',
    name: 'Quadrivalent Ascendance',
    max_level: 1,
    element: 'Lightning',
    type: 'Maze',
    type_text: 'Technique',
    effect: '',
    effect_text: '',
    simple_desc: '',
    desc: "Immediately attacks the enemy. At the start of each wave, gains Quadrivalent Ascendance, dealing Lightning DMG equal to #1[i]% of Acheron's ATK to all enemies and reducing Toughness of all enemies irrespective of Weakness Types. When Weakness is broken, triggers the Lightning Weakness Break effect.\nQuadrivalent Ascendance: After using the Ultimate, Acheron gains 1 point(s) of Slashed Dream and inflicts 1 stack(s) of Crimson Knot on a single random enemy.\nIf attacking a normal enemy, immediately defeats them without entering combat. When not hitting any enemies, no Technique Points are consumed.",
    params: [[2.0]],
    icon: 'icon/skill/1306_technique.png'
  },
  150001: {
    id: '150001',
    name: 'Corkage Fee',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to a single enemy.',
    desc: "Deals Fire DMG equal to #1[i]% of Gallagher's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1306_basic_atk.png'
  },
  150008: {
    id: '150008',
    name: 'Nectar Blitz',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to a single enemy.',
    desc: "Deals Fire DMG equal to #1[i]% of Gallagher's ATK to a single target enemy. And reduces the target's ATK by #2[i]%, lasting for 2 turns.",
    params: [
      [1.25, 0.1],
      [1.5, 0.11],
      [1.75, 0.12],
      [2, 0.13],
      [2.25, 0.14],
      [2.5, 0.15],
      [2.75, 0.16],
      [1, 1],
      [1, 1]
    ],
    icon: 'icon/skill/1306_basic_atk.png'
  },
  150002: {
    id: '150002',
    name: 'Special Brew',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Restore',
    effect_text: 'Restore',
    simple_desc: '',
    desc: 'Immediately heals a target ally for #1[i] HP.',
    params: [
      [200],
      [340],
      [480],
      [676],
      [830],
      [984],
      [1138],
      [1292],
      [1446],
      [1600],
      [1684],
      [1768],
      [1],
      [1],
      [1]
    ],
    icon: 'icon/skill/1306_skill.png'
  },
  150003: {
    id: '150003',
    name: 'Champagne Etiquette',
    max_level: 15,
    element: 'Fire',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoE',
    effect_text: 'AoE',
    simple_desc: '',
    desc: "Inflicts Besotted on all enemies, lasting for 2 turns. At the same time, deals Fire DMG equal to #1[i]% of Gallagher's ATK to all enemies, and enhances this unit's next Basic ATK to Nectar Blitz.",
    params: [
      [0.75],
      [0.825],
      [0.9],
      [0.975],
      [1.05],
      [1.125],
      [1.21875],
      [1.3125],
      [1.40625],
      [1.5],
      [1.575],
      [1.65],
      [1],
      [1],
      [1]
    ],
    icon: 'icon/skill/1306_ultimate.png'
  },
  150004: {
    id: '150004',
    name: 'Tipsy Tussle',
    max_level: 15,
    element: 'Fire',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "The Besotted state increases the Break DMG that targets receive by #1[i]%. Every time a Besotted target is attacked by an ally, the attacker's HP gets restored by #2[i].",
    params: [
      [0.06, 80],
      [0.066, 136],
      [0.072, 192],
      [0.078, 270.4],
      [0.084, 332],
      [0.09, 393.6],
      [0.0975, 455.2],
      [0.105, 516.8],
      [0.1125, 578.4],
      [0.12, 640],
      [0.126, 673.6],
      [0.132, 707.2],
      [1, 1],
      [1, 1],
      [1, 1]
    ],
    icon: 'icon/skill/1306_talent.png'
  },
  150007: {
    id: '150007',
    name: 'Artisan Elixir',
    max_level: 1,
    element: 'Fire',
    type: 'Maze',
    type_text: 'Technique',
    effect: '',
    effect_text: '',
    simple_desc: '',
    desc: "Immediately attacks the enemy. Upon entering battle, inflicts Besotted on all enemies, lasting for 2 turns. And deals Fire DMG equal to #1[i]% of Gallagher's ATK to all enemies.",
    params: [[0.5]],
    icon: 'icon/skill/1306_technique.png'
  },
  130401: {
    id: '130401',
    name: 'Straight Bet',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Imaginary DMG to a single target enemy.',
    desc: "Deals Imaginary DMG equal to #1[i]% of Aventurine's DEF to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1304_basic_atk.png'
  },
  130402: {
    id: '130402',
    name: 'Cornerstone Deluxe',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Defence',
    effect_text: 'Defense',
    simple_desc:
      'Provides all allies with a Fortified Wager shield, whose Shield effect is stackable.',
    desc: "Provides all allies with a Fortified Wager shield that can block DMG equal to #1[i]% of Aventurine's DEF plus #2[i], lasting for #3[i] turn(s). When repeatedly gaining Fortified Wager, the Shield effect can stack, up to #4[i]% of the Shield provided by the current Skill.",
    params: [
      [0.16, 80, 3, 2],
      [0.17, 128, 3, 2],
      [0.18, 164, 3, 2],
      [0.19, 200, 3, 2],
      [0.2, 224, 3, 2],
      [0.208, 248, 3, 2],
      [0.216, 266, 3, 2],
      [0.224, 284, 3, 2],
      [0.232, 302, 3, 2],
      [0.24, 320, 3, 2],
      [0.248, 338, 3, 2],
      [0.256, 356, 3, 2],
      [0.264, 374, 3, 2],
      [0.272, 392, 3, 2],
      [0.28, 410, 3, 2]
    ],
    icon: 'icon/skill/1304_skill.png'
  },
  130403: {
    id: '130403',
    name: 'Roulette Shark',
    max_level: 15,
    element: 'Imaginary',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Gains a random amount of Blind Bet points and inflicts Unnerved on a single enemy, dealing Imaginary DMG. When an ally hits an Unnerved enemy, the CRIT DMG dealt increases.',
    desc: "Randomly gains 1 to #1[i] points of Blind Bet. Then inflicts Unnerved on a single target enemy, lasting for #4[i] turn(s). And deals Imaginary DMG equal to #2[i]% of Aventurine's DEF to the single target enemy. When an ally hits an Unnerved enemy target, the CRIT DMG dealt increases by #3[i]%.",
    params: [
      [7, 1.62, 0.09, 3],
      [7, 1.728, 0.096, 3],
      [7, 1.836, 0.102, 3],
      [7, 1.944, 0.108, 3],
      [7, 2.052, 0.114, 3],
      [7, 2.16, 0.12, 3],
      [7, 2.295, 0.1275, 3],
      [7, 2.43, 0.135, 3],
      [7, 2.565, 0.1425, 3],
      [7, 2.7, 0.15, 3],
      [7, 2.808, 0.156, 3],
      [7, 2.916, 0.162, 3],
      [7, 3.024, 0.168, 3],
      [7, 3.132, 0.174, 3],
      [7, 3.24, 0.18, 3]
    ],
    icon: 'icon/skill/1304_ultimate.png'
  },
  130404: {
    id: '130404',
    name: 'Shot Loaded Right',
    max_level: 15,
    element: 'Imaginary',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Bounce',
    effect_text: 'Bounce',
    simple_desc:
      'The Effect RES increases for a single ally with Fortified Wager. When the single ally gets attacked, Aventurine accumulates Blind Bet. When Aventurine has Fortified Wager, he can resist Crowd Control debuffs. Upon reaching 7 points of Blind Bet, Aventurine consumes the 7 points to launch a follow-up attack that deals minor Imaginary DMG to random enemies, bouncing a total of 7 times.',
    desc: "The Effect RES increases by #4[i]% for a single ally with Fortified Wager. And when this allied character gets attacked, Aventurine gains 1 point of Blind Bet. When Aventurine has Fortified Wager, he can resist Crowd Control debuffs. This effect can trigger again after #5[i] turn(s). Aventurine additionally gains #1[i] point(s) of Blind Bet after getting attacked. Upon reaching 7 points of Blind Bet, Aventurine consumes the 7 points to launch a #2[i]-hit follow-up attack, with each hit dealing Imaginary DMG equal to #3[i]% of Aventurine's DEF to a single random enemy. Blind Bet is capped at 10 points.",
    params: [
      [1, 7, 0.125, 0.25, 2],
      [1, 7, 0.1375, 0.275, 2],
      [1, 7, 0.15, 0.3, 2],
      [1, 7, 0.1625, 0.325, 2],
      [1, 7, 0.175, 0.35, 2],
      [1, 7, 0.1875, 0.375, 2],
      [1, 7, 0.2031, 0.4062, 2],
      [1, 7, 0.2188, 0.4375, 2],
      [1, 7, 0.2344, 0.4688, 2],
      [1, 7, 0.25, 0.5, 2],
      [1, 7, 0.2625, 0.525, 2],
      [1, 7, 0.275, 0.55, 2],
      [1, 7, 0.2875, 0.575, 2],
      [1, 7, 0.3, 0.6, 2],
      [1, 7, 0.3125, 0.625, 2]
    ],
    icon: 'icon/skill/1304_talent.png'
  },
  130407: {
    id: '130407',
    name: 'The Red or the Black',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Defence',
    effect_text: 'Defense',
    simple_desc:
      "Using the Technique randomly grants one out of the three DEF Boost effects with different buff values. After entering the next battle, increases all allies' DEF by the corresponding value.",
    desc: "After using the Technique, 1 of the following effects will be granted:\nThere is a chance for DEF to increase by #1[i]%.\nThere is a high chance for DEF to increase by #2[i]%.\nThere is a small chance for DEF to increase by #3[i]%.\nWhen this Technique is used repeatedly, the acquired effect with the highest buff value is retained.\nWhen the next battle starts, increases all allies' DEF by the corresponding value, lasting for #4[i] turn(s).",
    params: [[0.24, 0.36, 0.6, 3]],
    icon: 'icon/skill/1304_technique.png'
  },
  130901: {
    id: '130901',
    name: 'Wingflip White Noise',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Physical DMG to a single target enemy.',
    desc: "Deals Physical DMG equal to #1[i]% of Robin's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1304_basic_atk.png'
  },
  130902: {
    id: '130902',
    name: "Pinion's Aria",
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '???',
    desc: "Increase DMG dealt by all allies by #1[i]%, lasting for 3 turn(s). This duration decreases by 1 at the start of Robin's every turn.",
    params: [
      [0.25],
      [0.275],
      [0.3],
      [0.325],
      [0.35],
      [0.375],
      [0.40625],
      [0.4375],
      [0.46875],
      [0.5],
      [0.525],
      [0.55],
      [0.575],
      [0.6],
      [0.625]
    ],
    icon: 'icon/skill/1304_skill.png'
  },
  130903: {
    id: '130903',
    name: 'Vox Harmonique, Opus Cosmique',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '???',
    desc: "Robin enters the Concerto state and makes all other allies immediately take action.\nWhen in the Concerto state, increase all allies' ATK by #1[i]% of Robin's ATK plus #2[i]. Moreover, after every attack by allies, Robin deals Additional Physical DMG equal to #3[i]% of her ATK 1 time, with a fixed CRIT Rate for this damage set at 100% and fixed CRIT DMG set at 150%.\nWhen in the Concerto state, Robin is immune to Crowd Control debuffs, and cannot enter her turn or take action until Concerto state ends.\nA Concerto countdown appears on the Action Order bar. When the countdown's turn begins, Robin exits the Concerto state and immediately takes action. The countdown has its own fixed SPD of 90.",
    params: [
      [0.152, 50, 0.72, 3],
      [0.1596, 65, 0.768, 3],
      [0.1672, 80, 0.816, 3],
      [0.1748, 95, 0.864, 3],
      [0.1824, 110, 0.912, 3],
      [0.19, 125, 0.96, 3],
      [0.1995, 143.75, 1.02, 3],
      [0.209, 162.5, 1.08, 3],
      [0.2185, 181.25, 1.14, 3],
      [0.228, 200, 1.2, 3],
      [0.2356, 215, 1.248, 3],
      [0.2432, 230, 1.296, 3],
      [0.2508, 245, 1.344, 3],
      [0.2584, 260, 1.392, 3],
      [0.266, 275, 1.44, 3]
    ],
    icon: 'icon/skill/1304_ultimate.png'
  },
  130904: {
    id: '130904',
    name: 'Tonal Resonance',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '???',
    desc: "Increase all allies' CRIT DMG by #1[i]%. Moreover, after allies attack enemy targets, Robin additionally regenerates 2 Energy for herself.",
    params: [
      [0.05],
      [0.065],
      [0.08],
      [0.095],
      [0.11],
      [0.125],
      [0.14375],
      [0.1625],
      [0.18125],
      [0.2],
      [0.215],
      [0.23],
      [0.245],
      [0.26],
      [0.275]
    ],
    icon: 'icon/skill/1304_talent.png'
  },
  130907: {
    id: '130907',
    name: 'Overture of Inebriation',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '???',
    desc: 'After using Technique, creates a dimension around the character that lasts for 15 seconds. Enemies within this dimension will not attack Robin and will follow Robin while the dimension is active. After entering battle while the dimension is active, Robin regenerates 5 Energy at the start of each wave. Only 1 dimension created by allies can exist at the same time.',
    params: [[0.24, 0.36, 0.6, 3]],
    icon: 'icon/skill/1304_technique.png'
  },
  800501: {
    id: '800501',
    name: 'Swing Dance Etiquette',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Imaginary DMG to a single target enemy.',
    desc: "Deals Imaginary DMG equal to #1[i]% of the Trailblazer's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1304_basic_atk.png'
  },
  800502: {
    id: '800502',
    name: 'Halftime to Make It Rain',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Bounce',
    effect_text: 'Bounce',
    simple_desc: '???',
    desc: "Deals Imaginary DMG equal to #1[i]% of the Trailblazer's ATK to a single target enemy and additionally deals DMG for 4 times, with each time dealing Imaginary DMG equal to #1[i]% of the Trailblazer's ATK to a random enemy.",
    params: [
      [0.25],
      [0.275],
      [0.3],
      [0.325],
      [0.35],
      [0.375],
      [0.40625],
      [0.4375],
      [0.46875],
      [0.5],
      [0.525],
      [0.55],
      [0.575]
    ],
    icon: 'icon/skill/1304_skill.png'
  },
  800503: {
    id: '800503',
    name: 'All-Out Footlight Parade',
    max_level: 15,
    element: 'Imaginary',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '???',
    desc: "Grants all allies the Backup Dancer effect, lasting for <b>3</b> turn(s). This duration reduces by 1 at the start of Trailblazer's every turn. Allies that have the Backup Dancer effect have their Break Effect increased by #1[i]%. And when they attack enemy targets that are in the Weakness Broken state, the Toughness Reduction of this attack will be converted into 1 instance of <u>Super Break DMG</u>.",
    params: [
      [0.15],
      [0.165],
      [0.18],
      [0.195],
      [0.21],
      [0.225],
      [0.24375],
      [0.2625],
      [0.28125],
      [0.3],
      [0.315],
      [0.33],
      [0.345]
    ],
    icon: 'icon/skill/1304_ultimate.png'
  },
  800504: {
    id: '800504',
    name: 'Full-on Aerial Dance',
    max_level: 15,
    element: 'Imaginary',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc: '???',
    desc: "The Trailblazer immediately regenerates #1[i] Energy when an enemy target's Weakness is Broken.",
    params: [
      [5],
      [5.5],
      [6],
      [6.5],
      [7],
      [7.5],
      [8.125],
      [8.75],
      [9.375],
      [10],
      [10.5],
      [11],
      [11.5]
    ],
    icon: 'icon/skill/1304_talent.png'
  },
  800507: {
    id: '800507',
    name: "Now! I'm the Band!",
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Defence',
    effect_text: 'Defense',
    simple_desc: '???',
    desc: "After the Technique is used, at the start of the next battle, all allies' Break Effect increases by #1[i]%, lasting for #2[i] turn(s).",
    params: [[0.3, 2]],
    icon: 'icon/skill/1304_technique.png'
  },
  131501: {
    id: '131501',
    name: 'Skullcrush Spurs',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Physical DMG to a single enemy.',
    desc: "Deals Physical DMG equal to #1[i]% of Boothill's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1315_basic_atk.png'
  },
  131502: {
    id: '131502',
    name: "Sizzlin' Tango",
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'Initiates Standoff. After the target in the Standoff is defeated or Weakness Broken, Boothill receives Pocket Trickshot and dispels the Standoff. Boothill gains Enhanced Basic ATK and this turn does not end.',
    desc: "Forces Boothill and a single target enemy into the Standoff state. Boothill's Basic ATK gets Enhanced, and he cannot use his Skill, lasting for #3[i] turn(s). This duration reduces by 1 at the start of Boothill's every turn.\nThe enemy target in the Standoff becomes Taunted. When this enemy target/Boothill gets attacked by the other party in the Standoff, the DMG they receive increases by #1[i]%/#2[i]%.\nAfter this target is defeated or becomes Weakness Broken, Boothill gains 1 stack of Pocket Trickshot, then dispels the Standoff.\nThis Skill cannot regenerate Energy. After using this Skill, the current turn does not end.",
    params: [
      [0.15, 0.15, 2],
      [0.165, 0.15, 2],
      [0.18, 0.15, 2],
      [0.195, 0.15, 2],
      [0.21, 0.15, 2],
      [0.225, 0.15, 2],
      [0.2437, 0.15, 2],
      [0.2625, 0.15, 2],
      [0.2812, 0.15, 2],
      [0.3, 0.15, 2],
      [0.315, 0.15, 2],
      [0.33, 0.15, 2],
      [0.345, 0.15, 2],
      [0.36, 0.15, 2],
      [0.375, 0.15, 2]
    ],
    icon: 'icon/skill/1315_skill.png'
  },
  131503: {
    id: '131503',
    name: "Dust Devil's Sunset Rodeo",
    max_level: 15,
    element: 'Physical',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Applies Physical Weakness to a single enemy, deals massive Physical DMG to them, and delays their action.',
    desc: "Applies Physical Weakness to a single target enemy, lasting for #3[i] turn(s).\nDeals Physical DMG equal to #1[i]% of Boothill's ATK to the target and delays their action by #2[i]%.",
    params: [
      [2.4, 0.3, 2],
      [2.56, 0.31, 2],
      [2.72, 0.32, 2],
      [2.88, 0.33, 2],
      [3.04, 0.34, 2],
      [3.2, 0.35, 2],
      [3.4, 0.3625, 2],
      [3.6, 0.375, 2],
      [3.8, 0.3875, 2],
      [4, 0.4, 2],
      [4.16, 0.41, 2],
      [4.32, 0.42, 2],
      [4.48, 0.43, 2],
      [4.64, 0.44, 2],
      [4.8, 0.45, 2]
    ],
    icon: 'icon/skill/1315_ultimate.png'
  },
  131504: {
    id: '131504',
    name: 'Five Peas in a Pod',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      "Pocket Trickshot increases the Enhanced Basic ATK's Toughness Reduction and additionally deals Physical Break DMG if the target is Weakness Broken. After winning the battle, retains Pocket Trickshot for the next battle.",
    desc: 'Each stack of Pocket Trickshot increases the Enhanced Basic Attack\'s Toughness Reduction by #4[i]%, stacking up to #5[i] time(s).\nIf the target is Weakness Broken while the Enhanced Basic ATK is being used, based on the number of Pocket Trickshot stacks, deals Break DMG to this target equal to #1[i]%/#2[i]%/#3[i]% of Boothill\'s Physical Break DMG. The max Toughness taken into account for this DMG cannot exceed #6[i] times the base Toughness Reduction of the Basic Attack "Skullcrush Spurs."\nAfter winning the battle, Boothill can retain Pocket Trickshot for the next battle.',
    params: [
      [0.35, 0.6, 0.85, 0.5, 3, 16],
      [0.385, 0.66, 0.935, 0.5, 3, 16],
      [0.42, 0.72, 1.02, 0.5, 3, 16],
      [0.455, 0.78, 1.105, 0.5, 3, 16],
      [0.49, 0.84, 1.19, 0.5, 3, 16],
      [0.525, 0.9, 1.275, 0.5, 3, 16],
      [0.5687, 0.975, 1.3813, 0.5, 3, 16],
      [0.6125, 1.05, 1.4875, 0.5, 3, 16],
      [0.6562, 1.125, 1.5938, 0.5, 3, 16],
      [0.7, 1.2, 1.7, 0.5, 3, 16],
      [0.735, 1.26, 1.785, 0.5, 3, 16],
      [0.77, 1.32, 1.87, 0.5, 3, 16],
      [0.805, 1.38, 1.955, 0.5, 3, 16],
      [0.84, 1.44, 2.04, 0.5, 3, 16],
      [0.875, 1.5, 2.125, 0.5, 3, 16]
    ],
    icon: 'icon/skill/1315_talent.png'
  },
  131507: {
    id: '131507',
    name: '3-9× Smile',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'After the Technique is used, inflicts Physical Weakness on a single enemy when casting the Skill for the first time in the next battle.',
    desc: 'After the Technique is used, when casting the Skill for the first time in the next battle, applies the same Physical Weakness to the target as the one induced by the Ultimate, lasting for #1[i] turn(s).',
    params: [[2]],
    icon: 'icon/skill/1315_technique.png'
  },
  131508: {
    id: '131508',
    name: 'Fanning the Hammer',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc:
      'Deals Physical DMG to a single enemy. Can only attack the target in the Standoff.',
    desc: "Deals Physical DMG equal to #1[i]% of Boothill's ATK to a single target enemy.\nThe Enhanced Basic Attack cannot recover Skill Points and can only target the enemy that is in the Standoff.",
    params: [
      [1.1],
      [1.32],
      [1.54],
      [1.76],
      [1.98],
      [2.2],
      [2.42],
      [2.64],
      [2.86]
    ],
    icon: 'icon/skill/1315_basic_atk.png'
  },
  150901: {
    id: '150901',
    name: 'Order: Flare Propulsion',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to a single target enemy.',
    desc: "Deals Fire DMG equal to #1[i]% of SAM's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]]
  },
  150902: {
    id: '150902',
    name: 'Order: Aerial Bombardment',
    max_level: 15,
    element: 'Fire',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '???',
    desc: "Consumes SAM's HP equal to 40% of SAM's Max HP and regenerates a fixed amount of Energy equal to #2[i]%  of SAM's Max Energy. Deals Fire DMG equal to #1[i]% of SAM's ATK to a single target enemy. If the current HP is not sufficient, then SAM's HP is reduced to 1 when using this Skill. Enables this unit's next Action to be Advanced by 25%.",
    params: [
      [1, 0.5],
      [1.1, 0.51],
      [1.2, 0.52],
      [1.3, 0.53],
      [1.4, 0.54],
      [1.5, 0.55],
      [1.625, 0.5625],
      [1.75, 0.575],
      [1.875, 0.5875],
      [2, 0.6],
      [2.1, 0.61],
      [2.2, 0.62],
      [2.3, 0.5],
      [2.4, 0.5],
      [2.5, 0.5]
    ]
  },
  150903: {
    id: '150903',
    name: 'Fyrefly Type-IV: Complete Combustion',
    max_level: 15,
    element: 'Fire',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '???',
    desc: "Upon entering the Complete Combustion state, Advances SAM's Action by 100% and gains Enhanced Basic ATK and Enhanced Skill. While in Complete Combustion, increases SPD by #1[i], and when using the Enhanced Basic ATK or Enhanced Skill, increases this unit's Weakness Break efficiency by 50% and the Break DMG received by the enemy targets by #2[i]%, lasting until the current attack ends.\nA countdown timer for the Complete Combustion state appears on the Action Order. When the countdown turn starts, SAM exits the Complete Combustion state. The countdown has a fixed SPD of 70.\nSAM cannot use Ultimate while in Complete Combustion.",
    params: [
      [30, 0.1, 0.72, 3],
      [33, 0.11, 0.768, 3],
      [36, 0.12, 0.816, 3],
      [39, 0.13, 0.864, 3],
      [42, 0.14, 0.912, 3],
      [45, 0.15, 0.96, 3],
      [48.75, 0.1625, 1.02, 3],
      [52.5, 0.175, 1.08, 3],
      [56.25, 0.1875, 1.14, 3],
      [60, 0.2, 1.2, 3],
      [63, 0.21, 1.248, 3],
      [66, 0.22, 1.296, 3],
      [69, 0.23, 1.344, 3],
      [0.2584, 260, 1.392, 3],
      [0.266, 275, 1.44, 3]
    ]
  },
  150904: {
    id: '150904',
    name: 'Chrysalid Pyronexus',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Defense',
    effect_text: 'Defense',
    simple_desc: '???',
    desc: 'The lower the HP, the less DMG received. When HP is 20% or lower, the DMG Reduction reaches its maximum effect, reducing up to #1[i]%. During the Complete Combustion, the DMG Reduction remains at its maximum effect, and the Effect RES increases by #2[i]%.\nIf Energy is lower than 50% when the battle starts, regenerates Energy to 50%. Once Energy is regenerated to its maximum, dispels all debuffs on this unit.',
    params: [
      [0.2, 0.1],
      [0.22, 0.12],
      [0.24, 0.14],
      [0.26, 0.16],
      [0.28, 0.18],
      [0.3, 0.2],
      [0.325, 0.225],
      [0.35, 0.25],
      [0.375, 0.275],
      [0.4, 0.3],
      [0.42, 0.32],
      [0.44, 0.34],
      [0.46, 0.36],
      [2.4, 1.2],
      [2.5, 1.25]
    ]
  },
  150907: {
    id: '150907',
    name: 'Δ Order: Meteoric Incineration',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '???',
    desc: "Leaps into the air and moves about freely for 5 seconds, which can be ended early by launching a plunging attack. When the duration ends, plunges and immediately attacks all enemies within a set area. At the start of each wave, applies a Fire Weakness to all enemies, lasting for 2 turn(s). Then, deals Fire DMG equal to 200% of SAM's ATK to all enemies.",
    params: [[0.24, 0.36, 0.6, 3]]
  },
  150908: {
    id: '150908',
    name: 'Fyrefly Type-IV: Pyrogenic Decimation',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to a single target enemy.',
    desc: "Restores HP by an amount equal to 20% of this unit's Max HP. Deals Fire DMG equal to #1[i]% of SAM's ATK to a single target enemy.",
    params: [
      [1],
      [1.1],
      [1.2],
      [1.3],
      [1.4],
      [1.5],
      [1.625],
      [1.75],
      [1.875],
      [2],
      [2.1],
      [2.2],
      [2.3],
      [2.4],
      [2.5]
    ]
  },
  150909: {
    id: '150909',
    name: 'Fyrefly Type-IV: Deathstar Overload',
    max_level: 15,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc: 'Deals minor Fire DMG to a single target enemy.',
    desc: "Restores HP by an amount equal to 25% of this unit's Max HP. Applies Fire Weakness to a single target enemy, lasting for 2 turn(s). Deals Fire DMG equal to (0.2 × Break Effect + #1[i]%) of SAM's ATK to this target. At the same time, deals Fire DMG equal to (0.1 × Break Effect + #2[i]%) of SAM's ATK to adjacent targets. The Break Effect taken into the calculation is capped at 360%.",
    params: [
      [1, 0.5],
      [1.1, 0.55],
      [1.2, 0.6],
      [1.3, 0.65],
      [1.4, 0.7],
      [1.5, 0.75],
      [1.625, 0.8125],
      [1.75, 0.875],
      [1.875, 0.9375],
      [2, 1],
      [2.1, 1.05],
      [2.2, 1.1],
      [2.3, 1.15],
      [2.4, 1.2],
      [2.5, 1.25]
    ]
  },
  131401: {
    id: '131401',
    name: 'Lash of Riches',
    max_level: 9,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals minor Quantum DMG to a single enemy and minor Quantum DMG to enemies adjacent to it.',
    desc: "Deals Quantum DMG equal to #1[i]% of Jade's ATK to a single target enemy, and Quantum DMG equal to #2[i]% of Jade's ATK to adjacent enemies.",
    params: [
      [0.45, 0.15],
      [0.54, 0.18],
      [0.63, 0.21],
      [0.72, 0.24],
      [0.81, 0.27],
      [0.9, 0.3],
      [0.99, 0.33],
      [1.08, 0.36],
      [1.17, 0.39]
    ],
    icon: 'icon/skill/1314_basic_atk.png'
  },
  131402: {
    id: '131402',
    name: 'Acquisition Surety',
    max_level: 15,
    element: 'Quantum',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      'Makes a single ally become the Debt Collector and increases their SPD. After the Debt Collector attacks, they deal minor Additional Quantum DMG to each enemy target hit and consume their own HP. When Jade becomes the Debt Collector, she cannot gain the SPD boost effect, and her attacks do not consume HP.',
    desc: "Makes a single target ally become the Debt Collector and increases their SPD by #1[i], lasting for #4[i] turn(s).\nAfter a Debt Collector attacks, deals 1 instance of Additional Quantum DMG equal to #3[i]% of Jade's ATK to each enemy target hit, and consumes the Debt Collector's HP by an amount equal to #2[i]% of their Max HP. If their current HP is insufficient, reduces their HP to 1.\nIf Jade becomes the Debt Collector, she cannot gain the SPD boost effect, and her attacks do not consume HP.\nWhen a Debt Collector exists on the field, Jade cannot use her Skill. At the start of Jade's every turn, the Debt Collector's duration reduces by 1 turn.",
    params: [
      [30, 0.02, 0.15, 3],
      [30, 0.02, 0.16, 3],
      [30, 0.02, 0.17, 3],
      [30, 0.02, 0.18, 3],
      [30, 0.02, 0.19, 3],
      [30, 0.02, 0.2, 3],
      [30, 0.02, 0.2125, 3],
      [30, 0.02, 0.225, 3],
      [30, 0.02, 0.2375, 3],
      [30, 0.02, 0.25, 3],
      [30, 0.02, 0.26, 3],
      [30, 0.02, 0.27, 3],
      [30, 0.02, 0.28, 3],
      [30, 0.02, 0.29, 3],
      [30, 0.02, 0.3, 3]
    ],
    icon: 'icon/skill/1314_skill.png'
  },
  131403: {
    id: '131403',
    name: 'Vow of the Deep',
    max_level: 15,
    element: 'Quantum',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Deals Quantum DMG to all enemies and gains increased DMG multiplier for follow-up attack.',
    desc: "Deals Quantum DMG equal to #3[i]% of Jade's ATK to all enemies. At the same time, enhances follow-up attack from Jade's Talent, increasing the follow-up attacks's DMG multiplier by #1[i]%. This enhancing effect can activate #2[i] time(s).",
    params: [
      [0.4, 2, 1.2],
      [0.44, 2, 1.32],
      [0.48, 2, 1.44],
      [0.52, 2, 1.56],
      [0.56, 2, 1.68],
      [0.6, 2, 1.8],
      [0.65, 2, 1.95],
      [0.7, 2, 2.1],
      [0.75, 2, 2.25],
      [0.8, 2, 2.4],
      [0.84, 2, 2.52],
      [0.88, 2, 2.64],
      [0.92, 2, 2.76],
      [0.96, 2, 2.88],
      [1, 2, 3]
    ],
    icon: 'icon/skill/1314_ultimate.png'
  },
  131404: {
    id: '131404',
    name: 'Fang of Flare Flaying',
    max_level: 15,
    element: 'Quantum',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'After Jade or an ally that had become the Debt Collector attacks, gains 1 point of Charge for each enemy target attacked. Upon reaching 8 points of Charge, consumes the 8 points to launch 1 instance of follow-up attack, dealing Quantum DMG to all enemies.\nWhen Jade launches the follow-up attack, gains Pawned Asset and increases CRIT DMG, stacking up to 50 times.',
    desc: "After Jade or an ally that had become the Debt Collector attacks, Jade gains 1 Charge for each enemy target attacked. When the Charge reaches #3[i], consume #3[i] Charges to launch follow-up attack 1 time, dealing Quantum DMG equal to #5[i]% of Jade's ATK to all enemies. This follow-up attack does not generate Charge.\nWhen launching her Talent's follow-up attack, Jade immediately gains #4[i] stack(s) of Pawned Asset, with each stack increasing her CRIT DMG by #1[i]%. This effect can stack up to #2[i] times.",
    params: [
      [0.012, 50, 8, 5, 0.6],
      [0.0132, 50, 8, 5, 0.66],
      [0.0144, 50, 8, 5, 0.72],
      [0.0156, 50, 8, 5, 0.78],
      [0.0168, 50, 8, 5, 0.84],
      [0.018, 50, 8, 5, 0.9],
      [0.0195, 50, 8, 5, 0.975],
      [0.021, 50, 8, 5, 1.05],
      [0.0225, 50, 8, 5, 1.125],
      [0.024, 50, 8, 5, 1.2],
      [0.0252, 50, 8, 5, 1.26],
      [0.0264, 50, 8, 5, 1.32],
      [0.0276, 50, 8, 5, 1.38],
      [0.0288, 50, 8, 5, 1.44],
      [0.03, 50, 8, 5, 1.5]
    ],
    icon: 'icon/skill/1314_talent.png'
  },
  131406: {
    id: '131406',
    name: 'Attack',
    max_level: 1,
    element: 'Quantum',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attacks an enemy, and when the battle starts, reduces their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1314_basic_atk.png'
  },
  131407: {
    id: '131407',
    name: 'Visionary Predation',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'Inflicts Blind Fealty on all enemies within a set area. Attacking an enemy with Blind Fealty causes all enemies with Blind Fealty to enter combat simultaneously. Upon entering combat, deals minor Quantum DMG to all enemies and immediately gains 15 stack(s) of Pawned Asset.',
    desc: "After using the Technique, inflicts enemies within a set area with Blind Fealty for #1[i] second(s). Enemies inflicted with Blind Fealty will not initiate attacks on allies. When entering battle via actively attacking enemies inflicted with Blind Fealty, all enemies with Blind Fealty will enter combat simultaneously. After entering battle, deals Quantum DMG equal to #2[i]% of Jade's ATK to all enemies, and immediately gains #3[i] stack(s) of Pawned Asset.",
    params: [[10, 0.5, 15]],
    icon: 'icon/skill/1314_technique.png'
  },
  122101: {
    id: '122101',
    name: 'Galespin Summersault',
    max_level: 9,
    element: 'Physical',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '???',
    desc: "Deals Physical DMG equal to #1[i]% of Yunli's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]]
  },
  122102: {
    id: '122102',
    name: 'Bladeborne Quake',
    max_level: 15,
    element: 'Physical',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc: '???',
    desc: "Restores HP equal to #1[i]% of Yunli's ATK plus #2[i]. Deals Physical DMG equal to #3[i]% of Yunli's ATK to a single target enemy and Physical DMG equal to #4[i]% of Yunli's ATK to adjacent targets.",
    params: [
      [0.2, 50, 0.6, 0.3],
      [0.2125, 80, 0.66, 0.33],
      [0.225, 102.5, 0.72, 0.36],
      [0.2375, 125, 0.78, 0.39],
      [0.25, 140, 0.84, 0.42],
      [0.26, 155, 0.9, 0.45],
      [0.27, 166.25, 0.975, 0.4875],
      [0.28, 177.5, 1.05, 0.525],
      [0.29, 188.75, 1.125, 0.5625],
      [0.3, 200, 1.2, 0.6],
      [0.31, 211.25, 1.26, 0.63],
      [0.32, 222.5, 1.32, 0.66],
      [30, 0.02, 0.28, 3],
      [30, 0.02, 0.29, 3],
      [30, 0.02, 0.3, 3]
    ],
    icon: 'icon/skill/1314_skill.png'
  },
  122103: {
    id: '122103',
    name: 'Earthbind, Etherbreak',
    max_level: 15,
    element: 'Physical',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '???',
    desc: "Consumes 120 Energy. Yunli gains Parry and Taunts all enemies, lasting until the end of the next ally's or enemy's turn. Increases the CRIT DMG dealt by Yunli's next Counter by #1[i]%. When triggering the Counter effect from Talent, launches the Counter 'Intuit: Cull' instead and removes the Parry effect. If no Counter is triggered while Parry is active, Yunli will immediately launch the Counter 'Intuit: Slash' on a random enemy target.\n'Intuit: Slash': Deals Physical DMG equal to #2[i]% of Yunli's ATK to the target, and deals Physical DMG equal to #3[i]% of Yunli's ATK to adjacent targets.\n'Intuit: Cull': Deals Physical DMG equal to #2[i]% of Yunli's ATK to the target, and deals Physical DMG equal to #3[i]% of Yunli's ATK to adjacent targets. Then, additionally deals 6 instances of DMG, each dealing Physical DMG equal to #4[i]% of Yunli's ATK to a random single enemy.\nWhen Yunli deals DMG via this ability, it's considered as dealing Ultimate DMG.",
    params: [
      [0.6, 1.32, 0.66, 0.432],
      [0.64, 1.408, 0.704, 0.4608],
      [0.68, 1.496, 0.748, 0.4896],
      [0.72, 1.584, 0.792, 0.5184],
      [0.76, 1.672, 0.836, 0.5472],
      [0.8, 1.76, 0.88, 0.576],
      [0.85, 1.87, 0.935, 0.612],
      [0.9, 1.98, 0.99, 0.648],
      [0.95, 2.09, 1.045, 0.684],
      [1, 2.2, 1.1, 0.72],
      [1.04, 2.288, 1.144, 0.7488],
      [1.08, 2.376, 1.188, 0.7776],
      [30, 0.02, 0.28, 3],
      [30, 0.02, 0.29, 3],
      [30, 0.02, 0.3, 3]
    ],
    icon: 'icon/skill/1314_ultimate.png'
  },
  122104: {
    id: '122104',
    name: 'Flashforge',
    max_level: 15,
    element: 'Physical',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc: '???',
    desc: "When Yunli gets attacked by an enemy target, additionally regenerates 15 Energy and immediately launches a Counter on the attacker, dealing Physical DMG equal to #1[i]% of Yunli's ATK to the attacker and Physical DMG equal to #2[i]% of Yunli's ATK to adjacent targets.\nIf there is no immediate target to Counter, then Counters a random enemy target instead.",
    params: [
      [0.6, 0.3],
      [0.66, 0.33],
      [0.72, 0.36],
      [0.78, 0.39],
      [0.84, 0.42],
      [0.9, 0.45],
      [0.975, 0.4875],
      [1.05, 0.525],
      [1.125, 0.5625],
      [1.2, 0.6],
      [1.26, 0.63],
      [1.32, 0.66],
      [0.0276, 50],
      [0.0288, 50],
      [0.03, 50]
    ],
    icon: 'icon/skill/1314_talent.png'
  },
  122107: {
    id: '122107',
    name: 'Posterior Precedence',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "This unit gains the Ward effect, lasting for 20 seconds. During this time, upon entering combat by either attacking enemies or receiving an attack, immediately casts 'Intuit: Cull' on a random enemy, and increases the DMG dealt by this attack by 80%.",
    params: [[10, 0.5, 15]],
    icon: 'icon/skill/1314_technique.png'
  },
  122401: {
    id: '122401',
    name: 'My Sword Zaps Demons',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '???',
    desc: "Deals Imaginary DMG equal to #1[i]%  of March 7th's ATK to a single enemy and gains 1 point(s) of Charge.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]]
  },
  122406: {
    id: '122406',
    name: 'Brows Be Smitten, Heart Be Bitten',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '???',
    desc: "Initially, deals 3 hits, each causing Imaginary DMG equal to #1[i]% of March 7th's ATK to a single target enemy. After dealing the final hit, there is a 60% fixed chance to deal 1 extra hit, up to a max of 3 extra hit(s). Energy regenerated from using Enhanced Basic ATK does not increase with the number of hits.\nEnhanced Basic ATK cannot recover Skill Points.",
    params: [
      [0.4],
      [0.48],
      [0.56],
      [0.64],
      [0.72],
      [0.8],
      [0.88],
      [0.96],
      [1.04]
    ]
  },
  122402: {
    id: '122402',
    name: "Master, It's Tea Time!",
    max_level: 15,
    element: 'Imaginary',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '???',
    desc: "Designates a single ally (excluding this unit) as Shifu and increases Shifu's SPD by #1[i]%. Only the most recent target of March 7th's Skill is considered as Shifu.\nWhen using Basic ATK or dealing 1 hit of Enhanced Basic ATK's DMG, triggers the corresponding effect based on the specific Path of Shifu:\nErudition, Destruction, The Hunt, Remembrance: Deals Additional DMG (DMG Type based on Shifu's Combat Type) equal to #2[i]% of March 7th's ATK.\nHarmony, Nihility, Preservation, Abundance: Increases the Toughness Reduction of this instance of DMG by 100%.",
    params: [
      [0.06, 0.1],
      [0.064, 0.11],
      [0.068, 0.12],
      [0.072, 0.13],
      [0.076, 0.14],
      [0.08, 0.15],
      [0.085, 0.1625],
      [0.09, 0.175],
      [0.095, 0.1875],
      [0.1, 0.2],
      [0.104, 0.21],
      [0.108, 0.22]
    ]
  },
  122403: {
    id: '122403',
    name: 'March 7th, the Apex Heroine',
    max_level: 15,
    element: 'Imaginary',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Single Target',
    effect_text: 'Single Target',
    simple_desc: '???',
    desc: "Deals Imaginary DMG equal to #1[i]% of March 7th's ATK to a single target enemy.\nIncreases the initial Hits Per Action of the next Enhanced Basic ATK by 2 hits and increase the fixed chance of additionally dealing DMG by 20%.",
    params: [
      [1.44],
      [1.536],
      [1.632],
      [1.728],
      [1.824],
      [1.92],
      [2.04],
      [2.16],
      [2.28],
      [2.4],
      [2.496],
      [2.592]
    ]
  },
  122404: {
    id: '122404',
    name: "Master, I've Ascended!",
    max_level: 15,
    element: 'Imaginary',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '???',
    desc: 'After Shifu uses an attack or Ultimate, March 7th gains up to 1 point of Charge each time.\nUpon reaching 7 or more points of Charge, March 7th immediately takes action and increases the DMG she deals by #1[i]%. Her Basic ATK gets Enhanced, and her Skill cannot be used. After using Enhanced Basic ATK, consumes 7 point(s) of Charge. Charge is capped at 10 points.',
    params: [
      [0.4],
      [0.44],
      [0.48],
      [0.52],
      [0.56],
      [0.6],
      [0.65],
      [0.7],
      [0.75],
      [0.8],
      [0.84],
      [0.88]
    ]
  },
  122407: {
    id: '122407',
    name: 'Feast in One Go',
    max_level: 1,
    element: 'Imaginary',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'If March 7th is on the team, she gains 1 point of Charge at the start of the next battle whenever an ally uses Technique, up to a max of 3 point(s).\nAfter using Technique, March 7th regenerates 30 Energy when the next battle starts.',
    params: [[10, 0.5, 15]]
  },
  121801: {
    id: '121801',
    name: 'Heart Afire',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to a single enemy.',
    desc: "Deals Fire DMG equal to #1[i]% of Jiaoqiu's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1218_basic_atk.png'
  },
  121802: {
    id: '121802',
    name: 'Scorch Onslaught',
    max_level: 15,
    element: 'Fire',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals Fire DMG to a single enemy and minor Fire DMG to adjacent targets, with a high chance to inflict 1 stack of Ashen Roast on the primary target.',
    desc: "Deals Fire DMG equal to #1[i]% of Jiaoqiu's ATK to a single target enemy and Fire DMG equal to #2[i]% of Jiaoqiu's ATK to adjacent targets, with a #3[i]% base chance to inflict 1 stack of Ashen Roast on the primary target.",
    params: [
      [0.75, 0.45, 1],
      [0.825, 0.495, 1],
      [0.9, 0.54, 1],
      [0.975, 0.585, 1],
      [1.05, 0.63, 1],
      [1.125, 0.675, 1],
      [1.2188, 0.7312, 1],
      [1.3125, 0.7875, 1],
      [1.4062, 0.8438, 1],
      [1.5, 0.9, 1],
      [1.575, 0.945, 1],
      [1.65, 0.99, 1],
      [1.725, 1.035, 1],
      [1.8, 1.08, 1],
      [1.875, 1.125, 1]
    ],
    icon: 'icon/skill/1218_skill.png'
  },
  121803: {
    id: '121803',
    name: 'Pyrograph Arcanum',
    max_level: 15,
    element: 'Fire',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      'Sets the number of "Ashen Roast" stacks on enemy targets to the highest number of "Ashen Roast" stacks present on the battlefield. Then, activates a Zone and deals Fire DMG to all enemies. While inside the Zone, enemy targets receive increased Ultimate DMG, with a chance of being inflicted with 1 stack of Ashen Roast when taking action.',
    desc: 'Sets the number of "Ashen Roast" stacks on enemy targets to the highest number of "Ashen Roast" stacks present on the battlefield. Then, activates a Zone and deals Fire DMG equal to #1[i]% of Jiaoqiu\'s ATK to all enemies.\nWhile inside the Zone, enemy targets receive #3[i]% increased Ultimate DMG, with a #2[i]% base chance of being inflicted with 1 stack of Ashen Roast when taking action. While the Zone exists, this effect can trigger up to #5[i] time(s). And for each enemy target, it can only trigger once per turn. This trigger count resets every time Jiaoqiu uses Ultimate.\nThe Zone lasts for #4[i] turn(s), and its duration decreases by 1 at the start of this unit\'s every turn. If Jiaoqiu gets knocked down, the Zone will also be dispelled.',
    params: [
      [0.6, 0.5, 0.09, 3, 6],
      [0.64, 0.51, 0.096, 3, 6],
      [0.68, 0.52, 0.102, 3, 6],
      [0.72, 0.53, 0.108, 3, 6],
      [0.76, 0.54, 0.114, 3, 6],
      [0.8, 0.55, 0.12, 3, 6],
      [0.85, 0.5625, 0.1275, 3, 6],
      [0.9, 0.575, 0.135, 3, 6],
      [0.95, 0.5875, 0.1425, 3, 6],
      [1, 0.6, 0.15, 3, 6],
      [1.04, 0.61, 0.156, 3, 6],
      [1.08, 0.62, 0.162, 3, 6],
      [1.12, 0.63, 0.168, 3, 6],
      [1.16, 0.64, 0.174, 3, 6],
      [1.2, 0.65, 0.18, 3, 6]
    ],
    icon: 'icon/skill/1218_ultimate.png'
  },
  121804: {
    id: '121804',
    name: 'Quartet Finesse, Octave Finery',
    max_level: 15,
    element: 'Fire',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'After attacking, there is a high chance to inflict 1 stack of Ashen Roast on the target, causing the enemy to take increased DMG and also be considered as Burned at the same time.',
    desc: "When Jiaoqiu hits an enemy with Basic ATK, Skill or Ultimate, there is a #1[i]% base chance to inflict 1 stack of Ashen Roast on them. At 1 stack, increases DMG received by the enemy by #2[i]%. Then, each subsequent stack increases this by #3[i]%.\nAshen Roast is capped at #4[i] stack(s) and lasts for #5[i] turn(s).\nWhen an enemy target is afflicted with Ashen Roast, they are also considered as being Burned at the same time, taking Fire DoT equal to #6[i]% of Jiaoqiu's ATK at the start of each turn.",
    params: [
      [1, 0.075, 0.025, 5, 2, 0.9],
      [1, 0.0825, 0.0275, 5, 2, 0.99],
      [1, 0.09, 0.03, 5, 2, 1.08],
      [1, 0.0975, 0.0325, 5, 2, 1.17],
      [1, 0.105, 0.035, 5, 2, 1.26],
      [1, 0.1125, 0.0375, 5, 2, 1.35],
      [1, 0.1219, 0.0406, 5, 2, 1.4625],
      [1, 0.1313, 0.0437, 5, 2, 1.575],
      [1, 0.1406, 0.0469, 5, 2, 1.6875],
      [1, 0.15, 0.05, 5, 2, 1.8],
      [1, 0.1575, 0.0525, 5, 2, 1.89],
      [1, 0.165, 0.055, 5, 2, 1.98],
      [1, 0.1725, 0.0575, 5, 2, 2.07],
      [1, 0.18, 0.06, 5, 2, 2.16],
      [1, 0.1875, 0.0625, 5, 2, 2.25]
    ],
    icon: 'icon/skill/1218_talent.png'
  },
  121807: {
    id: '121807',
    name: 'Fiery Queller',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'Creates a special dimension. After entering combat with enemies in this dimension, deals minor Fire DMG to all enemies, with a high chance of applying 1 "Ashen Roast" stack.',
    desc: 'After using Technique, creates a special dimension that lasts for #2[i] second(s). After entering combat with enemies in this special dimension, deals Fire DMG equal to #1[i]% of Jiaoqiu\'s ATK to all enemies, with a #3[i]% base chance of applying 1 "Ashen Roast" stack. Only 1 dimension created by allies can exist at the same time.',
    params: [[1, 15, 1]]
  },
  122001: {
    id: '122001',
    name: 'Boltsunder',
    max_level: 9,
    element: 'Wind',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Wind DMG to a single enemy.',
    desc: "Deals Wind DMG equal to #1[i]% of Feixiao's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]]
  },
  122002: {
    id: '122002',
    name: 'Waraxe',
    max_level: 15,
    element: 'Wind',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '',
    desc: "Deals Wind DMG equal to #1[i]% of Feixiao's ATK to a target enemy. Then, immediately launches 1 instance of Talent's follow-up attack against the target.",
    params: [
      [1],
      [1.1],
      [1.2],
      [1.3],
      [1.4],
      [1.5],
      [1.625],
      [1.75],
      [1.875],
      [2],
      [2.1],
      [2.2],
      [2.3]
    ]
  },
  122003: {
    id: '122003',
    name: 'Terrasplit',
    max_level: 15,
    element: 'Wind',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '',
    desc: "Deals Wind DMG to a single target enemy, up to #1[i]% of Feixiao's ATK. During this time, can ignore Weakness Type to reduce the target's Toughness. When the target is not Weakness Broken, Feixiao's Weakness Break Efficiency increases by 100%.\nDuring the attack, Feixiao first launches Boltsunder Blitz or Waraxe Skyward on the target, for a total of 6 time(s).\nAt the end, deals Wind DMG equal to #2[i]% of Feixiao's ATK to the target.\n\n<b>Boltsunder Blitz:</b> Deals Wind DMG equal to #3[i]% of Feixiao's ATK to the chosen target. If the target is Weakness Broken, the DMG multiplier increases by #4[i]%. \n\n<b>Waraxe Skyward:</b> Deals Wind DMG equal to #3[i]% of Feixiao's ATK to the chosen target. If the target is not Weakness Broken, the DMG multiplier increases by #4[i]%.",
    params: [
      [4.02, 0.96, 0.36, 0.15],
      [4.318, 1.024, 0.384, 0.165],
      [4.616, 1.088, 0.408, 0.18],
      [4.914, 1.152, 0.432, 0.195],
      [5.212, 1.216, 0.456, 0.21],
      [5.51, 1.28, 0.48, 0.225],
      [5.8825, 1.36, 0.51, 0.24375],
      [6.255, 1.44, 0.54, 0.2625],
      [6.6275, 1.52, 0.57, 0.28125],
      [7, 1.6, 0.6, 0.3],
      [7.298, 1.664, 0.624, 0.315],
      [7.596, 1.728, 0.648, 0.33]
    ]
  },
  122004: {
    id: '122004',
    name: 'Thunderhunt',
    max_level: 15,
    element: 'Wind',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '',
    desc: "Can activate Ultimate when Flying Aureus reaches 6 points, accumulating up to 12 points. Feixiao gains 1 point of Flying Aureus for every 2 attacks by ally targets. Feixiao's Ultimate attacks do not count towards this number.\nAfter Feixiao's teammates attack an enemy target, Feixiao immediately launches follow-up attack against the primary target, dealing Wind DMG equal to #1[i]% of Feixiao's ATK. If there is no primary target available to attack, Feixiao attacks a single random enemy instead. This effect can only trigger once per turn and the trigger count resets at the start of Feixiao's turn. When using this attack, increases DMG dealt by this unit by #2[i]%, lasting for 2 turn(s).",
    params: [
      [0.55, 0.3],
      [0.605, 0.33],
      [0.66, 0.36],
      [0.715, 0.39],
      [0.77, 0.42],
      [0.825, 0.45],
      [0.89375, 0.4875],
      [0.9625, 0.525],
      [1.03125, 0.5625],
      [1.1, 0.6],
      [1.155, 0.63],
      [1.21, 0.66]
    ]
  },
  122007: {
    id: '122007',
    name: 'Stormborn',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "After using Technique, enters the Onrush state, lasting for 20 seconds. While in Onrush, pulls in enemies within a certain range, and increases this unit's movement speed by 50%. After entering battle, gains 1 point(s) of Flying Aureus.\nWhile in Onrush, actively attacking will start battle with all pulled enemies. After entering battle, deals Wind DMG equal to 200% of Feixiao's ATK to all enemies at the start of each wave. This DMG is guaranteed to CRIT. If more than 1 enemy is pulled in, increases the multiplier of this DMG by 100% for each additional enemy pulled in, up to a maximum of 1000%.",
    params: [[1, 15, 1]]
  },
  122301: {
    id: '122301',
    name: 'Hurlthorn',
    max_level: 9,
    element: 'Lightning',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '',
    desc: "Deals Lightning DMG equal to #1[i]% of Moze's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]]
  },
  122302: {
    id: '122302',
    name: 'Fleetwinged Raid',
    max_level: 15,
    element: 'Lightning',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '',
    desc: 'Marks a designated single enemy target as "Prey" and deals to it Lightning DMG equal to #1[i]% of Moze\'s ATK, and gains 9 points of Charge.\nWhen there are no other characters on the field that are capable of combat, Moze cannot use his Skill and dispels the enemy\'s "Prey" state.',
    params: [
      [0.75],
      [0.825],
      [0.9],
      [0.975],
      [1.05],
      [1.125],
      [1.21875],
      [1.3125],
      [1.40625],
      [1.5],
      [1.575],
      [1.65]
    ]
  },
  122303: {
    id: '122303',
    name: 'Dash In, Gash Out',
    max_level: 15,
    element: 'Lightning',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '',
    desc: "Deals Lightning DMG equal to #1[i]% of Moze's ATK to a single target enemy, and launches the Talent's follow-up attack against this target. If the target is defeated before this follow-up attack is used, then launches the follow-up attack against a random single enemy instead.",
    params: [
      [1.62],
      [1.728],
      [1.836],
      [1.944],
      [2.052],
      [2.16],
      [2.295],
      [2.43],
      [2.565],
      [2.7],
      [2.808],
      [2.916]
    ]
  },
  122304: {
    id: '122304',
    name: 'Cascading Featherblade',
    max_level: 15,
    element: 'Lightning',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '',
    desc: 'When "Prey" exists on the field, Moze will enter the Departed state.\nAfter allies attack "Prey," Moze will additionally deal 1 instance of Lightning Additional DMG equal to #1[i]% of his ATK and consumes 1 point of Charge. For every 3 point(s) of Charge consumed, Moze launches 1 follow-up attack to "Prey," dealing Lightning DMG equal to #2[i]% of his ATK. When Charge reaches 0, dispels the target\'s "Prey" state and resets the tally of Charge points required to launch follow-up attack. Talent\'s follow-up attack does not consume Charge.',
    params: [
      [0.15, 0.8],
      [0.165, 0.88],
      [0.18, 0.96],
      [0.195, 1.04],
      [0.21, 1.12],
      [0.225, 1.2],
      [0.24375, 1.3],
      [0.2625, 1.4],
      [0.28125, 1.5],
      [0.3, 1.6],
      [0.315, 1.68],
      [0.33, 1.76]
    ]
  },
  122307: {
    id: '122307',
    name: 'Bated Wings',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'After using Technique, enters the Stealth state for 20 second(s). While in Stealth, Moze is undetectable by enemies. If Moze attacks enemies to enter combat while in Stealth, increases DMG by 30%, lasting for 2 turn(s).',
    params: [[1, 15, 1]]
  },
  122201: {
    id: '122201',
    name: 'Votive Incense',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to a single enemy.',
    desc: "Deals Fire DMG equal to #1[i]% of Lingsha's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1222_basic_atk.png'
  },
  122202: {
    id: '122202',
    name: 'Smoke and Splendor',
    max_level: 15,
    element: 'Fire',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      "Deals minor Fire DMG to all enemies and, at the same time, restores HP for all allies. Fuyuan's action advances.",
    desc: "Deals Fire DMG equal to #1[i]% of Lingsha's ATK to all enemies and at the same time, restores HP equal to #2[i]% of Lingsha's ATK plus #3[i] for all allies. Fuyuan's action advances by #4[i]%.",
    params: [
      [0.4, 0.1, 105, 0.2],
      [0.44, 0.105, 168, 0.2],
      [0.48, 0.11, 215.25, 0.2],
      [0.52, 0.115, 262.5, 0.2],
      [0.56, 0.12, 294, 0.2],
      [0.6, 0.124, 325.5, 0.2],
      [0.65, 0.128, 349.125, 0.2],
      [0.7, 0.132, 372.75, 0.2],
      [0.75, 0.136, 396.375, 0.2],
      [0.8, 0.14, 420, 0.2],
      [0.84, 0.144, 443.625, 0.2],
      [0.88, 0.148, 467.25, 0.2],
      [0.92, 0.152, 490.875, 0.2],
      [0.96, 0.156, 514.5, 0.2],
      [1, 0.16, 538.125, 0.2]
    ],
    icon: 'icon/skill/1222_skill.png'
  },
  122203: {
    id: '122203',
    name: 'Dripping Mistscape',
    max_level: 15,
    element: 'Fire',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      "Increases Break DMG taken by all enemies, deals Fire DMG to all enemies, and at the same time, restores HP for all allies. Fuyuan's action advances.",
    desc: 'Inflicts "Befog" on all enemies. While in "Befog," targets receive #4[i]% increased Break DMG, lasting for #5[i] turn(s).\nDeals Fire DMG equal to #1[i]% of Lingsha\'s ATK to all enemies, and at the same time restores HP equal to #2[i]% of Lingsha\'s ATK plus #3[i] for all allies. Fuyuan\'s action advances by #6[i]%.',
    params: [
      [0.9, 0.08, 90, 0.15, 2, 1],
      [0.96, 0.085, 144, 0.16, 2, 1],
      [1.02, 0.09, 184.5, 0.17, 2, 1],
      [1.08, 0.095, 225, 0.18, 2, 1],
      [1.14, 0.1, 252, 0.19, 2, 1],
      [1.2, 0.104, 279, 0.2, 2, 1],
      [1.275, 0.108, 299.25, 0.2125, 2, 1],
      [1.35, 0.112, 319.5, 0.225, 2, 1],
      [1.425, 0.116, 339.75, 0.2375, 2, 1],
      [1.5, 0.12, 360, 0.25, 2, 1],
      [1.56, 0.124, 380.25, 0.26, 2, 1],
      [1.62, 0.128, 400.5, 0.27, 2, 1],
      [1.68, 0.132, 420.75, 0.28, 2, 1],
      [1.74, 0.136, 441, 0.29, 2, 1],
      [1.8, 0.14, 461.25, 0.3, 2, 1]
    ],
    icon: 'icon/skill/1222_ultimate.png'
  },
  122204: {
    id: '122204',
    name: 'Mistdance Manifest',
    max_level: 15,
    element: 'Fire',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      "Using Skill summons Fuyuan: When taking action, launches follow-up attack and deals minor Fire DMG to all enemies. Additionally deals minor Fire DMG to a single random enemy, prioritizing targets with both Toughness greater than 0 and Fire Weakness. Dispels 1 debuff from all allies, and restores HP.\nUsing Skill repeatedly will increase Fuyuan's action count.",
    desc: "When using Skill, summons Fuyuan, with an initial SPD of #1[i] and an initial action count of #7[i].\nWhen taking action, Fuyuan launches follow-up attack, dealing Fire DMG equal to #2[i]% of Lingsha's ATK to all enemies. Additionally deals Fire DMG equal to #8[i]% of Lingsha's ATK to a single random enemy, and this DMG prioritizes targets that have both Toughness greater than 0 and Fire Weakness. Dispels #6[i] debuff(s) from all allies and restores HP equal to #3[i]% of Lingsha's ATK plus #4[i].\nFuyuan's action count can accumulate up to #5[i]. When the action count reaches 0 or when Lingsha is knocked down, Fuyuan disappears.\nWhile Fuyuan is on the field, using Skill can increase Fuyuan's action count by #7[i].",
    params: [
      [90, 0.375, 0.08, 90, 5, 1, 3, 0.375],
      [90, 0.4125, 0.085, 144, 5, 1, 3, 0.4125],
      [90, 0.45, 0.09, 184.5, 5, 1, 3, 0.45],
      [90, 0.4875, 0.095, 225, 5, 1, 3, 0.4875],
      [90, 0.525, 0.1, 252, 5, 1, 3, 0.525],
      [90, 0.5625, 0.104, 279, 5, 1, 3, 0.5625],
      [90, 0.6094, 0.108, 299.25, 5, 1, 3, 0.6094],
      [90, 0.6562, 0.112, 319.5, 5, 1, 3, 0.6562],
      [90, 0.7031, 0.116, 339.75, 5, 1, 3, 0.7031],
      [90, 0.75, 0.12, 360, 5, 1, 3, 0.75],
      [90, 0.7875, 0.124, 380.25, 5, 1, 3, 0.7875],
      [90, 0.825, 0.128, 400.5, 5, 1, 3, 0.825],
      [90, 0.8625, 0.132, 420.75, 5, 1, 3, 0.8625],
      [90, 0.9, 0.136, 441, 5, 1, 3, 0.9],
      [90, 0.9375, 0.14, 461.25, 5, 1, 3, 0.9375]
    ],
    icon: 'icon/skill/1222_talent.png'
  },
  122206: {
    id: '122206',
    name: 'Attack',
    max_level: 1,
    element: 'Fire',
    type: 'MazeNormal',
    type_text: '',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '',
    desc: 'Attacks an enemy, and when the battle starts, reduces their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1222_basic_atk.png'
  },
  122207: {
    id: '122207',
    name: 'Wisps of Aurora',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      'After using Technique, immediately summons Fuyuan at the start of the next battle and increases Break DMG taken by all enemies.',
    desc: 'After using Technique, immediately summons Fuyuan at the start of the next battle and inflicts "Befog" on all enemies, lasting for #1[i] turn(s).',
    params: [[2]],
    icon: 'icon/skill/1222_technique.png'
  },
  131701: {
    id: '131701',
    name: 'Ninjutsu: Rise Above Tumbles',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Imaginary DMG to a single enemy.',
    desc: "Deals Imaginary DMG equal to #1[i]% of Rappa's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]]
  },
  131709: {
    id: '131709',
    name: 'Ningu: Demonbane Petalblade',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc: 'Deals minor Imaginary DMG to a single enemy.',
    desc: "Launches Ningu: Demonbane Petalblade. The first 2 hits deal Imaginary DMG equal to #1[i]% of Rappa's ATK to one designated enemy and Imaginary DMG equal to #2[i]% of Rappa's ATK to adjacent targets, and the 3rd hit deals Imaginary DMG equal to #1[i]% of Rappa's ATK to all enemies.\nEnhanced Basic ATK will not recover Skill Points. Attacking enemies that don't have Imaginary Weakness can still reduce Toughness, whose effect is equal to 50% of the original Toughness Reduction. When Breaking Weakness, triggers the Imaginary Weakness Break effect.",
    params: [
      [0.6, 0.3],
      [0.68, 0.34],
      [0.76, 0.38],
      [0.84, 0.42],
      [0.92, 0.46],
      [1, 0.5],
      [1.08, 0.54],
      [1.16, 0.58],
      [1.24, 0.62]
    ]
  },
  131702: {
    id: '131702',
    name: 'Ninja Strike: Rooted Resolute',
    max_level: 15,
    element: 'Imaginary',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc: '',
    desc: "Deals Imaginary DMG equal to #1[i]% of Rappa's ATK to all enemies.",
    params: [
      [0.6],
      [0.66],
      [0.72],
      [0.78],
      [0.84],
      [0.9],
      [0.975],
      [1.05],
      [1.125],
      [1.2],
      [1.26],
      [1.32],
      [1.38]
    ]
  },
  131703: {
    id: '131703',
    name: 'Nindō Supreme: Aishiteru',
    max_level: 15,
    element: 'Imaginary',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'Enters the "Sealform" state, immediately gains 1 extra turn, obtains 3 points of "Chroma Ink," and increases Weakness Break Efficiency by 50% and Break Effect by #1[i]%.\nWhile in the "Sealform" state, Basic ATK is enhanced, and Skill and Ultimate cannot be used. After using Enhanced Basic ATK, consumes 1 point of "Chroma Ink." When "Chroma Ink" is depleted, exits the "Sealform" state.',
    params: [
      [0.1],
      [0.12],
      [0.14],
      [0.16],
      [0.18],
      [0.2],
      [0.225],
      [0.25],
      [0.275],
      [0.3],
      [0.32],
      [0.34],
      [0.36]
    ]
  },
  131704: {
    id: '131704',
    name: 'Ninja Tech: Endurance Gauge',
    max_level: 15,
    element: 'Imaginary',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "Each time the enemy target is Weakness Broken, Rappa gains 1 point of Charge, up to a max of 10 points of Charge. When Rappa next launches the third hit of Ningu: Demonbane Petalblade, additionally deals Break DMG equal to #1[i]% of Rappa's Imaginary Break DMG to all enemies. This DMG can ignore Weakness Type to reduce 2 Toughness, consuming all Charge. Each point of Charge increases the Break DMG multiplier by #2[i]% and increases the Toughness Reduction that can ignore Weakness Type by 1.\nWhen Breaking Weakness, triggers the Imaginary Weakness Break effect.",
    params: [
      [0.3, 0.25],
      [0.33, 0.275],
      [0.36, 0.3],
      [0.39, 0.325],
      [0.42, 0.35],
      [0.45, 0.375],
      [0.4875, 0.40625],
      [0.525, 0.4375],
      [0.5625, 0.46875],
      [0.6, 0.5],
      [0.63, 0.525],
      [0.66, 0.55],
      [0.69, 0.575],
      [0.72, 0.6],
      [0.75, 0.625]
    ]
  },
  131707: {
    id: '131707',
    name: 'Wisps of Aurora',
    max_level: 1,
    element: 'Imaginary',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '',
    desc: "After using Technique, enters the Graffiti state for 20 seconds. While in the Graffiti state, moves forward rapidly for a set distance and attacks any enemies touched. During the rapid movement, can block all enemies' attacks. Using an attack in the Graffiti state can end the state's duration early. After entering combat via attacking enemies, deals 30 Toughness Reduction regardless of Weakness Type and Break DMG equal to 200% of Rappa's Imaginary Break DMG to each enemy target, and deals Break DMG equal to 180% of Rappa's Imaginary Break DMG to adjacent targets. At the same time, this unit regenerates 10 Energy.",
    params: [[2]]
  },
  131301: {
    id: '131301',
    name: 'Gleaming Admonition',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Imaginary DMG to a single enemy.',
    desc: "Deals Imaginary DMG equal to #1[i]% of Sunday's ATK to a single target enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]]
  },
  131302: {
    id: '131302',
    name: 'Benison of Paper and Rites',
    max_level: 15,
    element: 'Imaginary',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '',
    desc: 'Enables one designated ally character and their summon to immediately take action, and increases their DMG dealt by #1[i]%. If the target has a summon, then the dealt DMG increase is further boosted by an additional #2[i]%, lasting for 2 turn(s).\nAfter using Skill on The Beatified, recovers 1 Skill Point.\nWhen Sunday uses this ability on characters following the Path of Harmony, cannot trigger the immediate action effect.',
    params: [
      [0.15, 0.25],
      [0.165, 0.275],
      [0.18, 0.3],
      [0.195, 0.325],
      [0.21, 0.35],
      [0.225, 0.375],
      [0.24375, 0.40625],
      [0.2625, 0.4375],
      [0.28125, 0.46875],
      [0.3, 0.5],
      [0.315, 0.525],
      [0.33, 0.55],
      [0.69, 0.575],
      [0.72, 0.6],
      [0.75, 0.625]
    ]
  },
  131303: {
    id: '131303',
    name: 'Ode to Caress and Cicatrix',
    max_level: 15,
    element: 'Imaginary',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '',
    desc: 'Regenerates Energy by 20% of Max Energy for one designated ally character, and turns the target and their summon into "The Beatified." "The Beatified" have their CRIT DMG increased by an amount equal to #1[i]% of Sunday\'s CRIT DMG plus #2[i]%.\nAt the start of Sunday\'s each turn, the duration of "The Beatified" decreases by 1 turn, lasting for a total of 3 turn(s). And it only takes effect on the most recent target of the Ultimate (excluding Sunday himself). When Sunday is knocked down, "The Beatified" will also be dispelled.',
    params: [
      [0.12, 0.08],
      [0.138, 0.084],
      [0.18, 0.088],
      [0.156, 0.092],
      [0.174, 0.096],
      [0.192, 0.1],
      [0.21, 0.105],
      [0.2325, 0.11],
      [0.2775, 0.115],
      [0.3, 0.12],
      [0.318, 0.124],
      [0.336, 0.128]
    ]
  },
  131304: {
    id: '131304',
    name: 'The Sorrowing Body',
    max_level: 15,
    element: 'Imaginary',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "When using Skill, increases the target's CRIT Rate by #1[i]%, lasting for 3 turn(s).",
    params: [
      [0.1],
      [0.11],
      [0.12],
      [0.13],
      [0.14],
      [0.15],
      [0.1625],
      [0.175],
      [0.1875],
      [0.2],
      [0.21],
      [0.22]
    ]
  },
  131307: {
    id: '131307',
    name: 'The Glorious Mysteries',
    max_level: 1,
    element: 'Imaginary',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '',
    desc: "After this Technique is used, the first time Sunday uses an ability on an ally target in the next battle, the target's DMG dealt increases by <b>50%</b>, lasting for 2 turn(s).",
    params: [[2]]
  },
  122501: {
    id: '122501',
    name: 'Radiant Streak',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Fire DMG to one enemy.',
    desc: "Deals Fire DMG equal to #1[i]% of Fugue's ATK to one designated enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]],
    icon: 'icon/skill/1225_basic_atk.png'
  },
  122502: {
    id: '122502',
    name: 'Virtue Beckons Bliss',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc:
      'Grants one ally "Foxian Prayer", which increases Break Effect, and enables to reduce Toughness when attacking enemies that don\'t have the corresponding Weakness Type.\nMakes this unit enter the "Torrid Scorch" state, enhancing Basic ATK. When ally units with "Foxian Prayer" attack, Fugue has a high chance to reduce the enemy target\'s DEF.',
    desc: 'Grants one designated ally "Foxian Prayer". Enters the "Torrid Scorch" state, lasting for #1[i] turn(s). The duration reduces by 1 at the start of Fugue\'s every turn. "Foxian Prayer" only takes effect on the most recent target of Fugue\'s Skill.\nThe ally target with "Foxian Prayer" increases their Break Effect by #2[i]% and can also reduce Toughness even when attacking enemies that don\'t have the corresponding Weakness Type, with the effect equivalent to #6[i]% of the original Toughness Reduction value. This cannot stack with other Toughness Reduction effects that also ignore Weakness Type.\nWhile in the "Torrid Scorch" state, Fugue enhances her Basic ATK. Every time an ally target with "Foxian Prayer" attacks, Fugue has a #3[i]% base chance to reduce the attacked enemy target\'s DEF by #4[i]%, lasting for #5[i] turn(s).',
    params: [
      [3, 0.15, 1, 0.08, 2, 0.5],
      [3, 0.165, 1, 0.09, 2, 0.5],
      [3, 0.18, 1, 0.1, 2, 0.5],
      [3, 0.195, 1, 0.11, 2, 0.5],
      [3, 0.21, 1, 0.12, 2, 0.5],
      [3, 0.225, 1, 0.13, 2, 0.5],
      [3, 0.2437, 1, 0.1425, 2, 0.5],
      [3, 0.2625, 1, 0.155, 2, 0.5],
      [3, 0.2812, 1, 0.1675, 2, 0.5],
      [3, 0.3, 1, 0.18, 2, 0.5],
      [3, 0.315, 1, 0.19, 2, 0.5],
      [3, 0.33, 1, 0.2, 2, 0.5],
      [3, 0.345, 1, 0.21, 2, 0.5],
      [3, 0.36, 1, 0.22, 2, 0.5],
      [3, 0.375, 1, 0.23, 2, 0.5]
    ],
    icon: 'icon/skill/1225_skill.png'
  },
  122503: {
    id: '122503',
    name: 'Solar Splendor Shines Upon All',
    max_level: 15,
    element: 'Fire',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc:
      "Deals Fire DMG to all enemies. This attack ignores Weakness Type to reduce all enemies' Toughness.",
    desc: "Deals Fire DMG equal to #1[i]% of Fugue's ATK to all enemies. This attack ignores Weakness Type to reduce all enemies' Toughness. And when breaking Weakness, triggers the Fire Weakness Break effect.",
    params: [
      [1],
      [1.1],
      [1.2],
      [1.3],
      [1.4],
      [1.5],
      [1.625],
      [1.75],
      [1.875],
      [2],
      [2.1],
      [2.2],
      [2.3],
      [2.4],
      [2.5]
    ],
    icon: 'icon/skill/1225_ultimate.png'
  },
  122504: {
    id: '122504',
    name: 'Fortune Follows Where Virtue Spreads',
    max_level: 15,
    element: 'Fire',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      'While Fugue is on the field, enemy targets will get additionally afflicted with "Cloudflame Luster." When "Cloudflame Luster" is reduced to 0, the enemy will take Weakness Break DMG again. After allies attack Weakness Broken enemy targets, additionally deals Super Break DMG.',
    desc: 'While Fugue is on the field, enemy targets will get additionally afflicted with "Cloudflame Luster," equal to #2[i]% of their Max Toughness. When the initial Toughness is reduced to 0, "Cloudflame Luster" can be further reduced. When "Cloudflame Luster" is reduced to 0, the enemy will receive Weakness Break DMG again.\nWhile Fugue is on the field and after allies attack Weakness Broken enemy targets, converts the Toughness Reduction of this attack into 1 instance of #1[i]% Super Break DMG.',
    params: [
      [0.5, 0.4],
      [0.55, 0.4],
      [0.6, 0.4],
      [0.65, 0.4],
      [0.7, 0.4],
      [0.75, 0.4],
      [0.8125, 0.4],
      [0.875, 0.4],
      [0.9375, 0.4],
      [1, 0.4],
      [1.05, 0.4],
      [1.1, 0.4],
      [1.15, 0.4],
      [1.2, 0.4],
      [1.25, 0.4]
    ],
    icon: 'icon/skill/1225_talent.png'
  },
  122506: {
    id: '122506',
    name: 'Attack',
    max_level: 1,
    element: 'Fire',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attacks an enemy, and when the battle starts, reduces their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1225_basic_atk.png'
  },
  122507: {
    id: '122507',
    name: 'Percipient Shine',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      "Inflicts Daze on enemies within a certain area. After entering battle via attacking Dazed enemies, Fugue's action advances, with a high chance to inflict each enemy target with the same DEF Reduction state as that applied by Fugue's Skill.",
    desc: "After using Technique, inflicts Daze on enemies within a certain area, lasting for #1[i] second(s). While Dazed, enemies will not actively attack ally targets.\nAfter entering battle via actively attacking Dazed enemies, Fugue's action advances by #4[i]%, with a #2[i]% base chance to inflict each enemy target with the same DEF Reduction state as that applied by Fugue's Skill, lasting for #3[i] turn(s).",
    params: [[10, 1, 2, 0.4]]
  },
  122508: {
    id: '122508',
    name: 'Fiery Caress',
    max_level: 9,
    element: 'Fire',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Deals minor Fire DMG to one enemy and minor Fire DMG to adjacent targets.',
    desc: "Deals Fire DMG equal to #1[i]% of Fugue's ATK to one designated enemy and Fire DMG equal to #2[i]% of Fugue's ATK to adjacent targets.",
    params: [
      [0.5, 0.25],
      [0.6, 0.3],
      [0.7, 0.35],
      [0.8, 0.4],
      [0.9, 0.45],
      [1, 0.5],
      [1.1, 0.55],
      [1.2, 0.6],
      [1.3, 0.65]
    ]
  },
  800701: {
    id: '800701',
    name: 'Leave It to Me!',
    max_level: 9,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '',
    desc: "Deals Ice DMG equal to #1[i]% of Trailblazer's ATK to one designated enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]]
  },
  800702: {
    id: '800702',
    name: 'I Choose You!',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Summon',
    effect_text: 'Summon',
    simple_desc: '',
    desc: "Summons the memosprite Mem. If Mem is already on the field, restores Mem's HP by an amount equal to #1[i]% of Mem's Max HP, and grants Mem 10% Charge.",
    params: [
      [0.3],
      [0.33],
      [0.36],
      [0.39],
      [0.42],
      [0.45],
      [0.4875],
      [0.525],
      [0.565],
      [0.6],
      [0.63],
      [0.66]
    ]
  },
  800703: {
    id: '800703',
    name: 'Together, Mem!',
    max_level: 15,
    element: 'Ice',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc: '',
    desc: "Summons memosprite Mem. Grants Mem 40% Charge, then enables Mem to deal Ice DMG equal to #1[i]% of Mem's ATK to all enemies.",
    params: [
      [1.2],
      [1.32],
      [1.44],
      [1.56],
      [1.68],
      [1.8],
      [1.95],
      [2.1],
      [2.25],
      [2.4],
      [2.52],
      [2.64]
    ]
  },
  800704: {
    id: '800704',
    name: 'Almighty Companion',
    max_level: 15,
    element: 'Ice',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "Memosprite Mem has an initial SPD of 130 and Max HP equal to #1[i]% of Trailblazer's Max HP plus #2[i]. For every 10 Energy regenerated by all allies in total, Mem gains 1% Charge.",
    params: [
      [0.5, 400],
      [0.53, 424],
      [0.56, 448],
      [0.59, 472],
      [0.62, 496],
      [0.65, 520],
      [0.6875, 550],
      [0.725, 580],
      [0.7625, 610],
      [0.8, 640],
      [0.83, 664],
      [0.86, 688]
    ]
  },
  800707: {
    id: '800707',
    name: 'Memories Back as Echoes',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc: '',
    desc: "After using Technique, creates a Special Dimension that lasts for 10 second(s). Enemies within the Special Dimension are placed in a Time Stop state, halting all their actions. After entering battle against enemies afflicted with the Time Stop state, delays the action of all enemies by 50%, and then deals Ice DMG to all enemies equal to 100% of Trailblazer's ATK. Only 1 Dimension Effect created by allies can exist at the same time.",
    params: [[10, 1, 2, 0.4]]
  },
  8007010: {
    id: '8007010',
    name: 'Baddies! Trouble!',
    max_level: 7,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Memosprite Skill',
    effect: 'AoE',
    effect_text: 'AoE',
    simple_desc: '',
    desc: "Deals 4 instance(s) of DMG, with each instance dealing Ice DMG equal to #1[i]% of Mem's ATK to one random enemy. Finally, deals Ice DMG equal to #2[i]% of Mem's ATK to all enemies.",
    params: [
      [0.18, 0.45],
      [0.216, 0.54],
      [0.252, 0.63],
      [0.2888, 0.72],
      [0.324, 0.81],
      [0.36, 0.9],
      [0.396, 0.99]
    ]
  },
  8007011: {
    id: '8007011',
    name: 'Lemme! Help You!',
    max_level: 7,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Memosprite Skill',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '',
    desc: 'Advances the action of one designated ally by 100% and grants them "Mem\'s Support," lasting for 3 turn(s).\nFor every 1 instance of DMG dealt by the target that has "Mem\'s Support," additionally deals 1 instance of True DMG equal to #1[i]% of the original DMG.\nWhen using this ability on this unit, cannot trigger the action advance effect.',
    params: [[0.18], [0.2], [0.22], [0.24], [0.26], [0.28], [0.3]]
  },
  8007012: {
    id: '8007012',
    name: 'Friends! Together!',
    max_level: 7,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Memosprite Talent',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '',
    desc: 'All allies\' CRIT DMG increases by #1[i]% of Mem\'s CRIT DMG plus #2[i]%.\nIf the Charge has yet to reach 100%, Mem automatically uses "Baddies! Trouble!" during action. When the Charge reaches 100%, Mem immediately takes action, and can select one ally unit to use "Lemme! Help You!" in the next action.',
    params: [
      [0.06, 0.12],
      [0.072, 0.144],
      [0.084, 0.168],
      [0.096, 0.192],
      [0.108, 0.216],
      [0.12, 0.24],
      [0.132, 0.264]
    ]
  },
  8007013: {
    id: '8007013',
    name: 'Go, Mem, Go!',
    max_level: 7,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Memosprite Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'When Mem is summoned, immediately gains <b>50%</b> Charge.',
    params: [[0.06, 0.12]]
  },
  8007014: {
    id: '8007014',
    name: 'No... Regrets',
    max_level: 7,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Memosprite Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "When Mem disappears, advances Trailblazer's action by <b>25%</b>.",
    params: [[0.06, 0.12]]
  },
  140101: {
    id: '140101',
    name: 'Did You Get It',
    max_level: 9,
    element: 'Ice',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '',
    desc: "Deals Ice DMG equal to #1[i]% of The Herta's ATK to one designated enemy.",
    params: [[0.5], [0.6], [0.7], [0.8], [0.9], [1], [1.1], [1.2], [1.3]]
  },
  140102: {
    id: '140102',
    name: 'Big Brain Energy',
    max_level: 15,
    element: 'Ice',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc: '',
    desc: 'Deals Ice DMG equal to #1[i]% of The Herta\'s ATK to one designated enemy, and inflicts 1 stack(s) of "Interpretation." Deals Ice DMG equal to 70% of The Herta\'s ATK to the targets hit by this instance of Skill and their respective adjacent targets. This effect can repeat 2 times.',
    params: [
      [0.35],
      [0.385],
      [0.42],
      [0.455],
      [0.49],
      [0.525],
      [0.56875],
      [0.6125],
      [0.65625],
      [0.7],
      [0.735],
      [0.77]
    ]
  },
  140103: {
    id: '140103',
    name: 'Told Ya! Magic Happens',
    max_level: 15,
    element: 'Ice',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc: '',
    desc: 'Rearranges the number of "Interpretation" stacks on all enemies, prioritizing the transfer of a higher number of "Interpretation" stacks to Elite-level targets and above. Then, deals Ice DMG equal to #1[i]% The Herta\'s ATK to all enemies. When using Ultimate, increases The Herta\'s ATK by #2[i]%, lasting for 3 turn(s). After using the Ultimate, The Herta immediately takes action and gains 1 stack of "Inspiration." "Inspiration" can stack up to 4 time(s). While having "Inspiration," enhances Skill to "Hear Me Out.',
    params: [
      [1, 0.4],
      [1.1, 0.44],
      [1.2, 0.48],
      [1.3, 0.52],
      [1.4, 0.56],
      [1.5, 0.6],
      [1.625, 0.65],
      [1.75, 0.7],
      [1.875, 0.75],
      [2, 0.8],
      [2.1, 0.84],
      [2.2, 0.88]
    ]
  },
  140104: {
    id: '140104',
    name: 'Hand Them Over',
    max_level: 15,
    element: 'Ice',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'When enemy targets enter battle, The Herta inflicts 1 stack of "Interpretation" on them. At the start of each wave, applies 25 stack(s) of "Interpretation" to a random enemy target, prioritizing Elite enemy targets or higher. When the Enhanced Skill\'s primary target has "Interpretation," the multiplier for the DMG dealt increases, with each stack granting an increase of #1[i]%/#2[i]% on the primary target/other targets respectively. If 2 or more characters follow the Path of Erudition in the team, each stack grants an additional increase of #1[i]%/#2[i]% on the primary target/other targets respectively. "Interpretation" can stack up to 42 time(s). When using the Enhanced Skill, resets the number of "Interpretation" stacks on the primary target to 1. After the enemy target leaves the battle or gets defeated by any unit, "Interpretation" will be transferred, prioritizing the transfer to Elite-level targets and above.',
    params: [
      [0.04, 0.02],
      [0.044, 0.022],
      [0.048, 0.024],
      [0.052, 0.026],
      [0.056, 0.028],
      [0.06, 0.03],
      [0.065, 0.0325],
      [0.07, 0.035],
      [0.075, 0.0375],
      [0.08, 0.04],
      [0.084, 0.042],
      [0.088, 0.044]
    ]
  },
  140107: {
    id: '140107',
    name: 'Vibe Checker',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "After using Technique, The Herta's ATK increases by 60% at the start of the next battle, lasting for 2 turn(s).\nIf there are Basic Treasures in this current map, using Technique will mark up to 3 Basic Treasures' locations.\nAfter entering battle by using Technique in Simulated Universe or Divergent Universe, deals True DMG equal to 99% of the target's Max HP to enemy targets lower than Elite-level, and True DMG equal to 30% of the target's Max HP to enemy targets at Elite-level and above.",
    params: [[10, 1, 2, 0.4]]
  },
  140108: {
    id: '140108',
    name: 'Hear Me Out',
    max_level: 15,
    element: 'Ice',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc: '',
    desc: 'Consumes 1 stack of "Inspiration." Deals Ice DMG equal to #1[i]% of The Herta\'s ATK to one designated enemy and inflicts 1 stack(s) of "Interpretation." Deals Ice DMG equal to #1[i]% of The Herta\'s ATK to the target hit by this instance of Skill and adjacent targets, repeating 2 times. Finally, deals Ice DMG equal to #2[i]% of The Herta\'s ATK to all enemies.',
    params: [
      [0.4, 0.2],
      [0.44, 0.22],
      [0.48, 0.24],
      [0.52, 0.26],
      [0.56, 0.28],
      [0.6, 0.3],
      [0.65, 0.325],
      [0.7, 0.35],
      [0.75, 0.375],
      [0.8, 0.4],
      [0.84, 0.42],
      [0.88, 0.44]
    ]
  },
  140201: {
    id: '140201',
    name: 'Thorned Nectar',
    max_level: 9,
    element: 'Thunder',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Lightning DMG to a single enemy.',
    desc: "Deals Lightning DMG equal to #1[i]% of Aglaea's ATK to one designated enemy.",
    params: [
      [0.5, 1],
      [0.6, 1],
      [0.7, 1],
      [0.8, 1],
      [0.9, 1],
      [1, 1],
      [1.1, 1],
      [1.2, 1],
      [1.3, 1]
    ],
    icon: 'icon/skill/1402_basic_atk.png'
  },
  140202: {
    id: '140202',
    name: 'Rise, Exalted Renown',
    max_level: 15,
    element: '',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Summon',
    effect_text: 'Summon',
    simple_desc:
      'Restores HP for Garmentmaker. If Garmentmaker is absent, summons the memosprite Garmentmaker and this unit immediately takes action.',
    desc: 'Restores HP to Garmentmaker by #1[i]% of its Max HP. If Garmentmaker is absent, summons the memosprite Garmentmaker and this unit immediately takes action.',
    params: [
      [0.25, 0, 5],
      [0.275, 0, 5],
      [0.3, 0, 5],
      [0.325, 0, 5],
      [0.35, 0, 5],
      [0.375, 0, 5],
      [0.4062, 0, 5],
      [0.4375, 0, 5],
      [0.4688, 0, 5],
      [0.5, 0, 5],
      [0.525, 0, 5],
      [0.55, 0, 5],
      [0.575, 0, 5],
      [0.6, 0, 5],
      [0.625, 0, 5]
    ],
    icon: 'icon/skill/1402_skill.png'
  },
  140203: {
    id: '140203',
    name: 'Dance, Destined Weaveress',
    max_level: 15,
    element: '',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'Summons the memosprite Garmentmaker, enabling Aglaea to enter the "Supreme Stance" state, immediately take action, and gain Enhanced Basic ATK.',
    desc: 'Summons the memosprite Garmentmaker. If Garmentmaker is already on the field, then restores its HP to max. Aglaea enters the "Supreme Stance" state and immediately takes action.\nWhile in the "Supreme Stance" state, Aglaea gains the SPD Boost stacks from Garmentmaker\'s Memosprite Talent, with each stack increasing her SPD by #1[i]%. Enhances Basic ATK to "Slash by a Thousandfold Kiss," and cannot use Skill. Garmentmaker is immune to Crowd Control debuffs.\nA countdown appears on the Action Order, with its own SPD set at #4[i]. Using Ultimate again when the countdown is on the Action Order will reset the countdown. When the countdown\'s turn starts, Garmentmaker self-destructs. When Garmentmaker disappears, Aglaea\'s "Supreme Stance" state is dispelled.',
    params: [
      [0.1, 0, 0, 100, 0, 0],
      [0.105, 0, 0, 100, 0, 0],
      [0.11, 0, 0, 100, 0, 0],
      [0.115, 0, 0, 100, 0, 0],
      [0.12, 0, 0, 100, 0, 0],
      [0.125, 0, 0, 100, 0, 0],
      [0.1313, 0, 0, 100, 0, 0],
      [0.1375, 0, 0, 100, 0, 0],
      [0.1437, 0, 0, 100, 0, 0],
      [0.15, 0, 0, 100, 0, 0],
      [0.155, 0, 0, 100, 0, 0],
      [0.16, 0, 0, 100, 0, 0],
      [0.165, 0, 0, 100, 0, 0],
      [0.17, 0, 0, 100, 0, 0],
      [0.175, 0, 0, 100, 0, 0]
    ],
    icon: 'icon/skill/1402_ultimate.png'
  },
  140204: {
    id: '140204',
    name: 'Rosy-Fingered',
    max_level: 15,
    element: 'Thunder',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'While Garmentmaker is on the field, Aglaea\'s attacks inflict the target with the "Seam Stitch" state. After attacking enemies in the "Seam Stitch" state, further deals a minor Lightning Additional DMG.',
    desc: 'The memosprite Garmentmaker has an initial SPD equal to #4[i]% of Aglaea\'s SPD and a Max HP equal to #5[i]% of Aglaea\'s Max HP plus #6[i]. While Garmentmaker is on the field, Aglaea\'s attacks inflict the target with the "Seam Stitch" state. After attacking enemies in the "Seam Stitch" state, further deals Lightning Additional DMG equal to #1[i]% of Aglaea\'s ATK. "Seam Stitch" only takes effect on the most recently inflicted target.',
    params: [
      [0.12, 0, 0, 0.35, 0.44, 180],
      [0.138, 0, 0, 0.35, 0.4675, 247.5],
      [0.156, 0, 0, 0.35, 0.495, 315],
      [0.174, 0, 0, 0.35, 0.5225, 382.5],
      [0.192, 0, 0, 0.35, 0.55, 450],
      [0.21, 0, 0, 0.35, 0.572, 504],
      [0.2325, 0, 0, 0.35, 0.594, 558],
      [0.255, 0, 0, 0.35, 0.616, 612],
      [0.2775, 0, 0, 0.35, 0.638, 666],
      [0.3, 0, 0, 0.35, 0.66, 720],
      [0.318, 0, 0, 0.35, 0.682, 774],
      [0.336, 0, 0, 0.35, 0.704, 828],
      [0.354, 0, 0, 0.35, 0.726, 882],
      [0.372, 0, 0, 0.35, 0.748, 936],
      [0.39, 0, 0, 0.35, 0.77, 990]
    ],
    icon: 'icon/skill/1402_talent.png'
  },
  140206: {
    id: '140206',
    name: 'Attack',
    max_level: 1,
    element: 'Thunder',
    type: 'MazeNormal',
    type_text: '',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'Attacks an enemy, and when the battle starts, reduces their Toughness of the corresponding Type.',
    params: [],
    icon: 'icon/skill/1402_basic_atk.png'
  },
  140207: {
    id: '140207',
    name: 'Meteoric Sunder',
    max_level: 1,
    element: 'Thunder',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc:
      'Summons the memosprite Garmentmaker and launches a forward joint attack. After entering battle, regenerates Energy and deals minor Lightning DMG to all enemies. Then, randomly inflicts the "Seam Stitch" state to a random enemy target.',
    desc: 'Summons the memosprite Garmentmaker and launches a forward joint attack. After entering battle, regenerates #2[i] Energy and deals Lightning DMG equal to #1[i]% of Aglaea\'s ATK to all enemy targets. Then, randomly inflicts the "Seam Stitch" state to a random enemy target.',
    params: [[1, 30]],
    icon: 'icon/skill/1402_technique.png'
  },
  140208: {
    id: '140208',
    name: 'Slash by a Thousandfold Kiss',
    max_level: 9,
    element: 'Thunder',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Aglaea and Garmentmaker launch a Joint ATK on the target. Deals Lightning DMG to one enemy and minor Lightning DMG to adjacent targets.',
    desc: "Aglaea and Garmentmaker launch a Joint ATK on the target, respectively dealing Lightning DMG equal to #1[i]% of Aglaea's ATK and #3[i]% of Garmentmaker's ATK to the target. Also, deal Lightning DMG equal to #2[i]% of Aglaea's ATK and #4[i]% of Garmentmaker's ATK to adjacent targets.\n\"Slash by a Thousandfold Kiss\" cannot recover Skill Points.",
    params: [
      [1, 0.45, 1, 0.45],
      [1.2, 0.54, 1.2, 0.54],
      [1.4, 0.63, 1.4, 0.63],
      [1.6, 0.72, 1.6, 0.72],
      [1.8, 0.81, 1.8, 0.81],
      [2, 0.9, 2, 0.9],
      [2.2, 0.99, 2.2, 0.99],
      [2.4, 1.08, 2.4, 1.08],
      [2.6, 1.17, 2.6, 1.17],
      [1.4, 0.56, 1.4, 0.56],
      [1.4, 0.56, 1.4, 0.56],
      [1.4, 0.56, 1.4, 0.56],
      [1.4, 0.56, 1.4, 0.56],
      [1.4, 0.56, 1.4, 0.56],
      [1.4, 0.56, 1.4, 0.56]
    ],
    icon: 'icon/skill/1402_basic_atk.png'
  },
  1402010: {
    id: '1402010',
    name: 'Thorned Snare',
    max_level: 7,
    element: 'Lightning',
    type: 'Normal',
    type_text: 'Memosprite Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc: '',
    desc: 'Deals Lightning DMG equal to #1[i]% of ATK to one enemy and Lightning DMG equal to #2[i]% of ATK to adjacent targets.',
    params: [
      [0.55, 0.33],
      [0.66, 0.396],
      [0.77, 0.462],
      [0.88, 0.528],
      [0.99, 0.594],
      [1.1, 0.66],
      [1.21, 0.726]
    ]
  },
  1402012: {
    id: '1402012',
    name: 'A Body Brewed by Tears',
    max_level: 7,
    element: 'Lightning',
    type: 'Normal',
    type_text: 'Memosprite Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'After attacking an enemy afflicted with "Seam Stitch," increases this unit\'s SPD by #1[i] , stacking up to 6 time(s). When Garmentmaker takes action, automatically uses "Thorned Snare," prioritizing enemies under the "Seam Stitch" state.',
    params: [[44], [46], [48], [50], [52], [55], [57]]
  },
  1402013: {
    id: '1402013',
    name: 'The Speeding Summer',
    max_level: 7,
    element: 'Lightning',
    type: 'Normal',
    type_text: 'Memosprite Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: "When Garmentmaker is summoned, this unit's action advances by <b>100%</b>.",
    params: [[0.06, 0.12]]
  },
  1402014: {
    id: '1402014',
    name: 'Bloom of Drying Grass',
    max_level: 7,
    element: 'Lightning',
    type: 'Normal',
    type_text: 'Memosprite Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'When Garmentmaker disappears, regenerates <b>20</b> Energy for Aglaea.',
    params: [[0.06, 0.12]]
  },
  140301: {
    id: '140301',
    name: 'Hundred Rockets',
    max_level: 9,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Blast',
    simple_desc: '',
    desc: "Deals Quantum DMG equal to #1[i]% of Tribbie's Max HP to one designated enemy. Deals Quantum DMG equal to #2[i]% of Tribbie's Max HP to adjacent targets.",
    params: [
      [0.15, 0.075],
      [0.18, 0.09],
      [0.21, 0.105],
      [0.24, 0.12],
      [0.27, 0.135],
      [0.3, 0.15],
      [0.33, 0.165],
      [0.36, 0.18],
      [0.39, 0.195]
    ]
  },
  140302: {
    id: '140302',
    name: "Where'd the Gifts Go",
    max_level: 15,
    element: 'Quantum',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '',
    desc: 'Gains "Numinosity," lasting for 3 turn(s). This duration decreases by 1 at the start of this unit\'s every turn. While Tribbie has "Numinosity," increases all ally targets\' All-Type RES PEN by #1[i]%.',
    params: [
      [0.12],
      [0.132],
      [0.144],
      [0.156],
      [0.168],
      [0.18],
      [0.195],
      [0.21],
      [0.225],
      [0.24],
      [0.252],
      [0.264]
    ]
  },
  140303: {
    id: '140303',
    name: 'Guess Who Lives Here',
    max_level: 15,
    element: 'Quantum',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'AoEAttack',
    effect_text: 'AoE',
    simple_desc: '',
    desc: "Activates a Zone and deals Quantum DMG equal to #1[i]% of Tribbie's Max HP to all enemies.\nWhile the Zone lasts, increases enemy targets' DMG taken by #1[i]%. After an ally target attacks, for every 1 target hit, deals 1 instance of Quantum Additional DMG equal to #2[i]% of Tribbie's Max HP to the target that has the highest HP among the hit targets.\nThe Zone lasts for 2 turn(s). This duration decreases by 1 at the start of this unit's every turn.",
    params: [
      [0.15, 0.06],
      [0.165, 0.066],
      [0.18, 0.072],
      [0.195, 0.078],
      [0.21, 0.084],
      [0.225, 0.09],
      [0.24375, 0.0975],
      [0.2625, 0.105],
      [0.28125, 0.1125],
      [0.3, 0.12],
      [0.315, 0.126],
      [0.33, 0.132]
    ]
  },
  140304: {
    id: '140304',
    name: 'Busy as Tribbie',
    max_level: 15,
    element: 'Quantum',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'AoE',
    effect_text: 'AoE',
    simple_desc: '',
    desc: "After other ally characters use Ultimate, Tribbie launches Follow-up ATK, dealing Quantum DMG equal to #1[i]% of Tribbie's Max HP to all enemies. This effect triggers up to 1 time per character. When Tribbie uses Ultimate, resets the trigger count for other ally characters. If the target was defeated before the Follow-up ATK is launched, then launches the Follow-up ATK against new enemy targets entering the battlefield.",
    params: [
      [0.09],
      [0.099],
      [0.108],
      [0.117],
      [0.126],
      [0.135],
      [0.14625],
      [0.1575],
      [0.16875],
      [0.18],
      [0.189],
      [0.198]
    ]
  },
  140307: {
    id: '140307',
    name: "If You're Happy and You Know It",
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'After using Technique and upon entering battle, obtains "Numinosity," lasting for 3 turn(s).',
    params: [[10, 1, 2, 0.4]]
  },
  140401: {
    id: '140401',
    name: 'Vow of Voyage',
    max_level: 9,
    element: 'Imaginary',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: 'Deals minor Imaginary DMG to one enemy.',
    desc: "Deals Imaginary DMG equal to #1[i]% of Mydei's Max HP to one designated enemy.",
    params: [
      [0.25],
      [0.3],
      [0.35],
      [0.4],
      [0.45],
      [0.5],
      [0.55],
      [0.6],
      [0.65]
    ],
    icon: 'icon/skill/1404_basic_atk.png'
  },
  140402: {
    id: '140402',
    name: 'Deaths are Legion, Regrets are None',
    max_level: 15,
    element: 'Imaginary',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Consumes HP and deals Imaginary DMG to one designated enemy unit and minor Imaginary DMG to adjacent targets.',
    desc: "Consumes HP by an amount equal to #3[i]% of Mydei's current HP. Deals Imaginary DMG equal to #1[i]% of Mydei's Max HP to one designated enemy and Imaginary DMG equal to #2[i]% of Mydei's Max HP to adjacent targets.\nIf the current HP is not sufficient, using Skill reduces Mydei's current HP to 1.",
    params: [
      [0.45, 0.25, 0.5],
      [0.495, 0.275, 0.5],
      [0.54, 0.3, 0.5],
      [0.585, 0.325, 0.5],
      [0.63, 0.35, 0.5],
      [0.675, 0.375, 0.5],
      [0.7312, 0.4062, 0.5],
      [0.7875, 0.4375, 0.5],
      [0.8438, 0.4688, 0.5],
      [0.9, 0.5, 0.5],
      [0.945, 0.525, 0.5],
      [0.99, 0.55, 0.5],
      [1.035, 0.575, 0.5],
      [1.08, 0.6, 0.5],
      [1.125, 0.625, 0.5]
    ],
    icon: 'icon/skill/1404_skill.png'
  },
  140403: {
    id: '140403',
    name: 'Throne of Bones',
    max_level: 15,
    element: 'Imaginary',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      "Restores HP and accumulates Talent's Charge. Deals massive Imaginary DMG to one designated enemy and Imaginary DMG to adjacent targets, then Taunts the target and their adjacent targets.",
    desc: "Restores HP by #3[i]% of Mydei's Max HP and accumulates #5[i] Talent's Charge point(s). Deals Imaginary DMG equal to #1[i]% of Mydei's Max HP to one designated enemy, and deals Imaginary DMG equal to #2[i]% of Mydei's Max HP to adjacent targets. Additionally, Taunts the target and targets adjacent to it, lasting for #4[i] turn(s). The next use of \"Godslayer Be God\" prioritizes attacking one designated enemy, and this effect only works on the latest target.",
    params: [
      [0.96, 0.6, 0.15, 2, 20],
      [1.024, 0.64, 0.155, 2, 20],
      [1.088, 0.68, 0.16, 2, 20],
      [1.152, 0.72, 0.165, 2, 20],
      [1.216, 0.76, 0.17, 2, 20],
      [1.28, 0.8, 0.175, 2, 20],
      [1.36, 0.85, 0.1812, 2, 20],
      [1.44, 0.9, 0.1875, 2, 20],
      [1.52, 0.95, 0.1938, 2, 20],
      [1.6, 1, 0.2, 2, 20],
      [1.664, 1.04, 0.205, 2, 20],
      [1.728, 1.08, 0.21, 2, 20],
      [1.792, 1.12, 0.215, 2, 20],
      [1.856, 1.16, 0.22, 2, 20],
      [1.92, 1.2, 0.225, 2, 20]
    ],
    icon: 'icon/skill/1404_ultimate.png'
  },
  140404: {
    id: '140404',
    name: 'Blood for Blood',
    max_level: 15,
    element: '',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc:
      'When losing HP, accumulates Charge. When Charge is at 100, enters the "Vendetta" state, restores HP and advances action. During "Vendetta," Max HP increases and DEF remains at 0. At the start of this unit\'s turn, automatically uses "Kingslayer Be King."\nWhen Charge reaches 150 during "Vendetta," Mydei immediately gains 1 extra turn and automatically uses "Godslayer Be God."\nWhen Mydei receives a killing blow, he exits the "Vendetta" state.',
    desc: 'For each 1% of HP lost, accumulates 1 point of Charge (up to 200 points). When Charge reaches 100, consumes 100 points of Charge to enter the "Vendetta" state, restores HP equal to #1[i]% of Mydei\'s Max HP, and advances action by 100%. While the "Vendetta" state is active, Max HP increases by #5[i]% of the current Max HP and DEF remains at 0. At the start of this unit\'s turn, automatically uses "Kingslayer Be King."\nWhen Charge reaches #3[i] points during the "Vendetta" state, Mydei immediately gains 1 extra turn and automatically uses "Godslayer Be God."\nWhen receiving a killing blow during the "Vendetta" state, Mydei will not be knocked down, but will clear his Charge, exits the "Vendetta" state, and restores HP by #4[i]% of his Max HP.',
    params: [
      [0.15, 0, 150, 0.5, 0.5],
      [0.16, 0, 150, 0.5, 0.5],
      [0.17, 0, 150, 0.5, 0.5],
      [0.18, 0, 150, 0.5, 0.5],
      [0.19, 0, 150, 0.5, 0.5],
      [0.2, 0, 150, 0.5, 0.5],
      [0.2125, 0, 150, 0.5, 0.5],
      [0.225, 0, 150, 0.5, 0.5],
      [0.2375, 0, 150, 0.5, 0.5],
      [0.25, 0, 150, 0.5, 0.5],
      [0.26, 0, 150, 0.5, 0.5],
      [0.27, 0, 150, 0.5, 0.5],
      [0.28, 0, 150, 0.5, 0.5],
      [0.29, 0, 150, 0.5, 0.5],
      [0.3, 0, 150, 0.5, 0.5]
    ],
    icon: 'icon/skill/1404_talent.png'
  },
  140407: {
    id: '140407',
    name: 'Cage of Broken Lance',
    max_level: 1,
    element: '',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'Impair',
    effect_text: 'Impair',
    simple_desc:
      "Pulls in enemies within a certain area and inflicts Daze on them. After attacking Dazed enemies and entering battle, deals minor Imaginary DMG to all enemies and Taunts the targets. This unit accumulates Talent's Charge.",
    desc: "After using Technique, pulls in enemies within a certain area and inflicts Daze on them for #1[i] second(s). Dazed enemies will not actively attack ally targets.\nIf actively attacking Dazed enemies, when entering battle, deals Imaginary DMG equal to #2[i]% of Mydei's Max HP to all enemies, and Taunts the targets, lasting for #4[i] turn(s). This unit accumulates #5[i] point(s) of Talent's Charge.",
    params: [[10, 0.8, 1, 1, 50]],
    icon: 'icon/skill/1404_technique.png'
  },
  140409: {
    id: '140409',
    name: 'Kingslayer Be King',
    max_level: 15,
    element: 'Imaginary',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Consumes HP. Deals Imaginary DMG to one designated enemy and Imaginary DMG to adjacent targets.\nThis ability will be automatically used.',
    desc: "Consumes HP by an amount equal to #3[i]% of Mydei's current HP. Deals Imaginary DMG equal to #1[i]% of Mydei's Max HP to one enemy and Imaginary DMG equal to #2[i]% of Mydei's Max HP to adjacent targets.\nIf the current HP is not sufficient, using Skill reduces Mydei's current HP to 1.\nThis ability will be automatically used.",
    params: [
      [0.55, 0.33, 0.35],
      [0.605, 0.363, 0.35],
      [0.66, 0.396, 0.35],
      [0.715, 0.429, 0.35],
      [0.77, 0.462, 0.35],
      [0.825, 0.495, 0.35],
      [0.8938, 0.5363, 0.35],
      [0.9625, 0.5775, 0.35],
      [1.0312, 0.6188, 0.35],
      [1.1, 0.66, 0.35],
      [1.155, 0.693, 0.35],
      [1.21, 0.726, 0.35],
      [1.265, 0.759, 0.35],
      [1.32, 0.792, 0.35],
      [1.375, 0.825, 0.35]
    ],
    icon: 'icon/skill/1404_skill.png'
  },
  140411: {
    id: '140411',
    name: 'Godslayer Be God',
    max_level: 15,
    element: 'Imaginary',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc:
      'Consumes Charge. Deals massive Imaginary DMG to one designated enemy and massive Imaginary DMG to adjacent targets.\nThis ability will be automatically used.',
    desc: "Consumes #3[i] point(s) of Charge. Deals Imaginary DMG equal to #1[i]% of Mydei's Max HP to one enemy and Imaginary DMG equal to #2[i]% of Mydei's Max HP to adjacent targets.\nThis ability will be automatically used. While this ability is in use, Charge cannot be accumulated.",
    params: [
      [1.4, 0.84, 150],
      [1.54, 0.924, 150],
      [1.68, 1.008, 150],
      [1.82, 1.092, 150],
      [1.96, 1.176, 150],
      [2.1, 1.26, 150],
      [2.275, 1.365, 150],
      [2.45, 1.47, 150],
      [2.625, 1.575, 150],
      [2.8, 1.68, 150],
      [2.94, 1.764, 150],
      [3.08, 1.848, 150],
      [3.22, 1.932, 150],
      [3.36, 2.016, 150],
      [3.5, 2.1, 150]
    ],
    icon: 'icon/skill/1404_skill.png'
  },
  140701: {
    id: '140701',
    name: "Lament, Nethersea's Ripple",
    max_level: 9,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Basic ATK',
    effect: 'SingleAttack',
    effect_text: 'Single Target',
    simple_desc: '',
    desc: "Deals Quantum DMG equal to #1[i]% of Castorice's Max HP to one designated enemy.",
    params: [
      [0.25],
      [0.3],
      [0.35],
      [0.4],
      [0.45],
      [0.5],
      [0.55],
      [0.6],
      [0.65]
    ],
    icon: 'icon/skill/1407_basic_atk.png'
  },
  140702: {
    id: '140702',
    name: "Silence, Wraithfly's Caress",
    max_level: 15,
    element: 'Quantum',
    type: 'BPSkill',
    type_text: 'Skill',
    effect: 'Blast',
    effect_text: 'Blast',
    simple_desc: '',
    desc: "Consumes 30% of all allies' current HP. Deals Quantum DMG equal to #1[i]% of Castorice's Max HP to one designated enemy and Quantum DMG equal to #2[i]% of Castorice's Max HP to adjacent targets.\nIf current HP is insufficient, this ability will reduce HP to 1.\nIf Netherwing is on the battlefield, this Skill becomes \"Boneclaw, Doomdrake's Embrace\" instead.",
    params: [
      [0.25, 0.15],
      [0.275, 0.165],
      [0.3, 0.18],
      [0.325, 0.195],
      [0.35, 0.21],
      [0.375, 0.225],
      [0.40625, 0.24375],
      [0.4375, 0.2625],
      [0.46875, 0.28125],
      [0.5, 0.3],
      [0.525, 0.315],
      [0.55, 0.33]
    ],
    icon: 'icon/skill/1407_skill.png'
  },
  140703: {
    id: '140703',
    name: "Doomshriek, Dawn's Chime",
    max_level: 15,
    element: 'Quantum',
    type: 'Ultra',
    type_text: 'Ultimate',
    effect: 'Summon',
    effect_text: 'Summon',
    simple_desc: '',
    desc: 'Summons the memosprite Netherwing and advances its action by 100%. At the same time, creates the Territory "Lost Netherland", which decreases all enemies\' All-Type RES by #1[i]%. If the DMG Boost effect from Castorice\'s Talent is active, the effect is extended to Netherwing. Netherwing has an initial SPD of 165 and a set Max HP equal to 100% of max Newbud.\nAfter Netherwing experiences 3 turns or when its HP is 0, it disappears and dispels the Territory "Lost Netherland".',
    params: [
      [0.1],
      [0.11],
      [0.12],
      [0.13],
      [0.14],
      [0.15],
      [0.1625],
      [0.175],
      [0.1875],
      [0.2],
      [0.21],
      [0.22]
    ],
    icon: 'icon/skill/1407_ultimate.png'
  },
  140704: {
    id: '140704',
    name: 'Desolation Across Palms',
    max_level: 15,
    element: 'Quantum',
    type: 'Talent',
    type_text: 'Talent',
    effect: 'Enhance',
    effect_text: 'Enhance',
    simple_desc: '',
    desc: 'Max "Newbud" is based on all characters\' levels on the battlefield. For each point of HP lost by all allies, Castorice gains 1 point of "Newbud." When "Newbud" reaches its maximum, Castorice\'s Ultimate can be used. When allies lose HP, Castorice\'s and Netherwing\'s DMG dealt increase by #1[i]%. This effect can stack up to 3 times, lasting for 3 turn(s).\nWhen Netherwing is on the field, "Newbud" cannot be gained through Talent, and HP lost by all allies (except Netherwing) will be converted to an equal amount of HP for Netherwing.',
    params: [
      [0.1],
      [0.11],
      [0.12],
      [0.13],
      [0.14],
      [0.15],
      [0.1625],
      [0.175],
      [0.1875],
      [0.2],
      [0.21],
      [0.22]
    ],
    icon: 'icon/skill/1407_talent.png'
  },
  140706: {
    id: '140706',
    name: 'Sanctuary of Mooncocoon',
    max_level: 1,
    element: 'Quantum',
    type: 'Unique',
    type_text: 'Unique',
    effect: 'Unique',
    effect_text: 'Unique',
    simple_desc: '',
    desc: 'After obtaining Castorice or when Castorice is in the current team, receive the following effect: In battle, when an ally character receives a killing blow, all ally characters that received a killing blow in this action enter the "Mooncocoon" state. Characters in "Mooncocoon" temporarily delay becoming downed and can take actions normally. After the action, if their present HP increases, or if they gain the Shield effect before their next turn, "Mooncocoon" is removed. Otherwise, they will be downed immediately. This effect can be triggered 1 time per battle.',
    params: [[1, 30]],
    icon: 'icon/skill/1407_basic_atk.png'
  },
  140707: {
    id: '140707',
    name: "Wail, Death's Herald",
    max_level: 1,
    element: 'Quantum',
    type: 'Maze',
    type_text: 'Technique',
    effect: 'MazeAttack',
    effect_text: '',
    simple_desc: '',
    desc: 'After using Technique, enters the "Netherveil" state that lasts for 20 seconds. While "Netherveil" is active, enemies are unable to approach Castorice on their own.\nWhile in the "Netherveil" state, attacking will cause all enemies within range to enter combat. At the same time, summons the memosprite Netherwing and causes it to advance its action by 100%, as well as create its Territory "Lost Netherland." Netherwing starts with current HP equal to 50% of max "Newbud." After entering battle, consumes 40% of all allies\' current HP aside from Netherwing.\nAfter entering battle and before summoning Netherwing, Castorice gains "Newbud" equal to 30% of maximum "Newbud."',
    params: [[1, 30]],
    icon: 'icon/skill/1407_technique.png'
  },
  140708: {
    id: '140708',
    name: "Boneclaw, Doomdrake's Embrace",
    max_level: 15,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'AoE',
    effect: 'AoE',
    effect_text: 'AoE',
    simple_desc: '',
    desc: "Consumes 40% of all allies' (except Netherwing) current HP. Castorice and Netherwing launch a Joint ATK on the target and deal Quantum DMG equal to #1[i]% and #2[i]% of Castorice's Max HP to all enemies.\nIf current HP is insufficient, using the ability will reduce HP to 1.",
    params: [
      [0.15, 0.25],
      [0.165, 0.275],
      [0.18, 0.3],
      [0.195, 0.325],
      [0.21, 0.35],
      [0.225, 0.375],
      [0.24375, 0.40625],
      [0.2625, 0.4375],
      [0.28125, 0.46875],
      [0.3, 0.5],
      [0.315, 0.525],
      [0.33, 0.55]
    ],
    icon: 'icon/skill/1407_basic_atk.png'
  },
  1407010: {
    id: '1407010',
    name: 'Claw Splits the Veil',
    max_level: 7,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Memosprite Skill',
    effect: 'AoE',
    effect_text: 'AoE',
    simple_desc: '',
    desc: "Deals Quantum DMG equal to #1[i]% of Castorice's Max HP to all enemies.",
    params: [
      [0.2],
      [0.24],
      [0.28],
      [0.32],
      [0.36],
      [0.4],
      [0.44],
      [0.48],
      [0.52]
    ]
  },
  1407011: {
    id: '1407011',
    name: 'Breath Scorches the Shadow',
    max_level: 7,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Memosprite Skill',
    effect: 'AoE',
    effect_text: 'AoE',
    simple_desc: '',
    desc: 'Activating "Breath Scorches the Shadow" will consume 25% of Netherwing\'s Max HP to deal Quantum DMG equal to #1[i]% of Castorice\'s Max HP to all enemies.\nIn one attack, "Breath Scorches the Shadow" can be activated repeatedly, with the DMG multiplier increasing respectively to #2[i]% / #3[i]%, until #3[i]%. The DMG Multiplier Boost effect will not be reduced before Netherwing disappears.\nWhen Netherwing\'s current HP is equal to or lower than 25% of its Max HP, activating the ability will reduce HP to 1, and then trigger the ability effect equal to that of the Talent "Wings Sweep the Ruins.',
    params: [
      [0.12, 0.14, 0.17],
      [0.144, 0.168, 0.204],
      [0.168, 0.196, 0.238],
      [0.192, 0.224, 0.272],
      [0.216, 0.252, 0.306],
      [0.24, 0.28, 0.34],
      [0.264, 0.308, 0.374],
      [0.288, 0.336, 0.408],
      [0.312, 0.364, 0.442]
    ]
  },
  1407012: {
    id: '1407012',
    name: 'Mooncocoon Shrouds the Form',
    max_level: 7,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Memosprite Talent',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '',
    desc: 'When Netherwing is on the field, it acts as backup for allies. When allies take DMG or consumes HP, their current HP can be reduced to a minimum of 1, after which Netherwing will consume HP at <b>500%</b> of the original value until Netherwing disappears.',
    params: [[44]]
  },
  1407013: {
    id: '1407013',
    name: 'Roar Rumbles the Realm',
    max_level: 7,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Memosprite Talent',
    effect: 'Support',
    effect_text: 'Support',
    simple_desc: '',
    desc: 'When Netherwing is summoned, increases DMG dealt by all allies by <b>10%</b> for <b>3</b> turn(s).',
    params: [[0.06, 0.12]]
  },
  1407014: {
    id: '1407014',
    name: 'Wings Sweep the Ruins',
    max_level: 7,
    element: 'Quantum',
    type: 'Normal',
    type_text: 'Memosprite Talent',
    effect: 'Bounce',
    effect_text: 'Bounce',
    simple_desc: '',
    desc: "When Netherwing disappears, deals 6 instance(s) of DMG, with every instance dealing Quantum DMG equal to #1[i]% of Castorice's Max HP to one random enemy units. At the same time, restores HP equal to #2[i]% of Castorice's Max HP plus #3[i] to all allies.",
    params: [
      [0.2, 0.03, 400],
      [0.24, 0.036, 480],
      [0.28, 0.042, 560],
      [0.32, 0.048, 640],
      [0.36, 0.054, 720],
      [0.4, 0.06, 800],
      [0.44, 0.066, 880],
      [0.48, 0.072, 960],
      [0.52, 0.078, 1040]
    ]
  }
};
